"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/.pnpm/tsup@5.12.9_@swc+core@1.3.96_postcss@8.4.31_ts-node@10.9.1_typescript@4.9.5/node_modules/tsup/assets/cjs_shims.js
var init_cjs_shims = __esm({
  "../../node_modules/.pnpm/tsup@5.12.9_@swc+core@1.3.96_postcss@8.4.31_ts-node@10.9.1_typescript@4.9.5/node_modules/tsup/assets/cjs_shims.js"() {
  }
});

// ../types/dist/index.js
var require_dist = __commonJS({
  "../types/dist/index.js"(exports, module2) {
    "use strict";
    init_cjs_shims();
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var src_exports2 = {};
    __export2(src_exports2, {
      AccountManagerType: () => AccountManagerType,
      ApplicationChatMode: () => ApplicationChatMode,
      ApplicationReminderType: () => ApplicationReminderType,
      ApplicationRoundStatus: () => ApplicationRoundStatus3,
      ApplicationRoundType: () => ApplicationRoundType2,
      ApplicationStatus: () => ApplicationStatus4,
      ApprovalType: () => ApprovalType,
      AssessActivityType: () => AssessActivityType,
      AssessPlatformDifficulty: () => AssessPlatformDifficulty,
      AssessmentDuration: () => AssessmentDuration,
      AssignmentSubmissionType: () => AssignmentSubmissionType2,
      AttemptStatus: () => AttemptStatus,
      AvailedInterviewType: () => AvailedInterviewType,
      BehaviouralFlagStatus: () => BehaviouralFlagStatus,
      BriedDebriefCallType: () => BriedDebriefCallType,
      CallLogsDispositions: () => CallLogsDispositions,
      CampusApplicationStatus: () => CampusApplicationStatus,
      CampusRoundStatus: () => CampusRoundStatus,
      CampusRoundType: () => CampusRoundType,
      CompanyNature: () => CompanyNature2,
      CompanyOwnershipType: () => CompanyOwnershipType2,
      CompanyType: () => CompanyType2,
      ContestRewardTypes: () => ContestRewardTypes,
      ContestStatus: () => ContestStatus,
      CourseType: () => CourseType,
      CurrentWorkingStatus: () => CurrentWorkingStatus,
      DegreeType: () => DegreeType,
      DevelopmentRoleType: () => DevelopmentRoleType2,
      DriveInviteeApplicationStatus: () => DriveInviteeApplicationStatus2,
      DriveInviteeStatus: () => DriveInviteeStatus,
      DriveInviteeTestStatusType: () => DriveInviteeTestStatusType,
      DriveInviteeType: () => DriveInviteeType,
      DriveRoundType: () => DriveRoundType,
      EscalationLevel: () => EscalationLevel,
      FeatureFlagType: () => FeatureFlagType,
      GaugingCandidateStatus: () => GaugingCandidateStatus,
      GradeType: () => GradeType,
      HighestQualification: () => HighestQualification,
      InterviewFormatType: () => InterviewFormatType,
      InterviewPathType: () => InterviewPathType,
      JobseekerFormJobType: () => JobseekerFormJobType,
      JobseekerSubRole: () => JobseekerSubRole,
      LMSLinkingStatus: () => LMSLinkingStatus,
      MarketingPageStatus: () => MarketingPageStatus,
      MeetingJoineeStatus: () => MeetingJoineeStatus,
      MeetingStatus: () => MeetingStatus3,
      MeetingSuccessStatus: () => MeetingSuccessStatus,
      MeetingType: () => MeetingType2,
      MessageSenderType: () => MessageSenderType,
      NatureOfBusinessType: () => NatureOfBusinessType2,
      NbfcDetailStatus: () => NbfcDetailStatus,
      OFFLINE_DRIVE_CITY: () => OFFLINE_DRIVE_CITY,
      OfflineDocumentsTypes: () => OfflineDocumentsTypes,
      OfflineDriveCandidateStatus: () => OfflineDriveCandidateStatus,
      OfflineTechStackType: () => OfflineTechStackType,
      OptOutReason: () => OptOutReason,
      PIFReviewStatusType: () => PIFReviewStatusType,
      PaymentStatus: () => PaymentStatus,
      PaymentType: () => PaymentType,
      PhoneVerificationStatus: () => PhoneVerificationStatus,
      PositionBucketType: () => PositionBucketType,
      PositionEducationRequirementType: () => PositionEducationRequirementType,
      PositionQualifiedFor: () => PositionQualifiedFor,
      PositionStatus: () => PositionStatus3,
      PositionTitle: () => PositionTitle3,
      PositionType: () => PositionType3,
      PositionUserBehaviouralFlag: () => PositionUserBehaviouralFlag2,
      PostgraduateDegreeTypes: () => PostgraduateDegreeTypes2,
      PrepPlanBadgeStatus: () => PrepPlanBadgeStatus,
      ProctoringStatus: () => ProctoringStatus2,
      ProfilePageTabs: () => ProfilePageTabs,
      QuestionDifficulty: () => QuestionDifficulty2,
      QuestionTypes: () => QuestionTypes,
      Reason: () => Reason,
      RecommendedPath: () => RecommendedPath,
      RecordingStatus: () => RecordingStatus,
      RewardActivityType: () => RewardActivityType,
      RewardType: () => RewardType,
      RoundLabelType: () => RoundLabelType,
      RoundType: () => RoundType,
      ScoreType: () => ScoreType,
      ScreeningStatus: () => ScreeningStatus,
      SerriTemplateType: () => SerriTemplateType,
      SessionJoineeStatus: () => SessionJoineeStatus,
      SessionRecordingStatus: () => SessionRecordingStatus,
      SessionStatus: () => SessionStatus3,
      SessionSuccessStatus: () => SessionSuccessStatus,
      SessionType: () => SessionType,
      SkillGroupType: () => SkillGroupType,
      SkillPriority: () => SkillPriority,
      SkillType: () => SkillType2,
      SlackMessageHistoryErrorEnums: () => SlackMessageHistoryErrorEnums,
      SlackMessageHistoryStatusEnums: () => SlackMessageHistoryStatusEnums,
      SlackMessageTypeEnums: () => SlackMessageTypeEnums,
      SlackWorkspaceEnvironment: () => SlackWorkspaceEnvironment,
      SlackWorkspaceType: () => SlackWorkspaceType,
      Source: () => Source,
      SpecializationType: () => SpecializationType,
      StateCityTypes: () => StateCityTypes2,
      StateFilterType: () => StateFilterType,
      Status: () => Status,
      SubRoundType: () => SubRoundType,
      SupportQuestionCategory: () => SupportQuestionCategory,
      SupportTicketStatus: () => SupportTicketStatus,
      TechStackType: () => TechStackType3,
      TechStacksForPosition: () => TechStacksForPosition2,
      TierType: () => TierType,
      TrackingContent: () => TrackingContent,
      TrackingType: () => TrackingType,
      TypeOfUsers: () => TypeOfUsers,
      UIApplicationCardState: () => UIApplicationCardState,
      UIApplicationTypeEnum: () => UIApplicationTypeEnum,
      UIPositionStatus: () => UIPositionStatus,
      UIRemarksDrawerType: () => UIRemarksDrawerType,
      UITrackingType: () => UITrackingType,
      UndergraduateDegreeTypes: () => UndergraduateDegreeTypes2,
      UserCareerPathType: () => UserCareerPathType3,
      UserExperienceLevelType: () => UserExperienceLevelType4,
      UserISAStatus: () => UserISAStatus,
      UserJapEnrollmentStatus: () => UserJapEnrollmentStatus,
      UserJapEnrollmentType: () => UserJapEnrollmentType,
      UserPapStatus: () => UserPapStatus,
      UserPercentileBucket: () => UserPercentileBucket2,
      UserPlacementTags: () => UserPlacementTags3,
      UserRole: () => UserRole5,
      VerificationType: () => VerificationType,
      VisibilityType: () => VisibilityType2,
      VoteType: () => VoteType,
      WeekDay: () => WeekDay3,
      WhatsappMessageType: () => WhatsappMessageType,
      WorkingMode: () => WorkingMode3,
      YesOrNoEnum: () => YesOrNoEnum,
      matchedPercentileType: () => matchedPercentileType,
      skillsWeightageParameters: () => skillsWeightageParameters
    });
    module2.exports = __toCommonJS2(src_exports2);
    var UserRole5 = /* @__PURE__ */ ((UserRole22) => {
      UserRole22["JOBSEEKER"] = "JobSeeker";
      UserRole22["EXPERIENCED_JOBSEEKER"] = "ExperiencedJobSeeker";
      UserRole22["MENTOR"] = "Mentor";
      UserRole22["SUPER_ADMIN"] = "SuperAdmin";
      UserRole22["ADMIN"] = "Admin";
      UserRole22["RECRUITER"] = "Recruiter";
      UserRole22["ACCOUNT_MANAGER"] = "AccountManager";
      UserRole22["SUPER_ACCOUNT_MANAGER"] = "SuperAccountManager";
      UserRole22["AI_INTERVIEWER"] = "AIInterviewer";
      UserRole22["ALUMNI_CONNECT"] = "AlumniConnect";
      UserRole22["UNIVERSITY_REPRESENTATIVE"] = "UniversityRepresentative";
      UserRole22["GUEST_JOBSEEKER"] = "GuestJobseeker";
      UserRole22["DRIVE_ADMIN"] = "DriveAdmin";
      UserRole22["SUPER_LEAD_GEN"] = "SuperLeadGen";
      UserRole22["LEAD_GEN"] = "LeadGen";
      return UserRole22;
    })(UserRole5 || {});
    var PhoneVerificationStatus = /* @__PURE__ */ ((PhoneVerificationStatus2) => {
      PhoneVerificationStatus2["Error"] = "Error";
      PhoneVerificationStatus2["Success"] = "Success";
      return PhoneVerificationStatus2;
    })(PhoneVerificationStatus || {});
    var AvailedInterviewType = /* @__PURE__ */ ((AvailedInterviewType2) => {
      AvailedInterviewType2["First"] = "First";
      AvailedInterviewType2["Second"] = "Second";
      AvailedInterviewType2["OneNoShow"] = "OneNoShow";
      return AvailedInterviewType2;
    })(AvailedInterviewType || {});
    var ScreeningStatus = /* @__PURE__ */ ((ScreeningStatus2) => {
      ScreeningStatus2["Requested"] = "Requested";
      ScreeningStatus2["Completed"] = "Completed";
      return ScreeningStatus2;
    })(ScreeningStatus || {});
    var TypeOfUsers = /* @__PURE__ */ ((TypeOfUsers2) => {
      TypeOfUsers2["FRESHER"] = "fresher";
      TypeOfUsers2["ASSESSMENT"] = "assessment";
      TypeOfUsers2["CAMPUS"] = "campus";
      TypeOfUsers2["DRIVE"] = "drive";
      return TypeOfUsers2;
    })(TypeOfUsers || {});
    var JobseekerSubRole = /* @__PURE__ */ ((JobseekerSubRole2) => {
      JobseekerSubRole2["MasaiStudent"] = "MasaiStudent";
      JobseekerSubRole2["MasaiTechInterns"] = "MasaiTechInterns";
      JobseekerSubRole2["MasaiYodha"] = "MasaiYodha";
      JobseekerSubRole2["CAP"] = "CAP";
      JobseekerSubRole2["CN"] = "CN";
      JobseekerSubRole2["MasaiAlum"] = "MasaiAlum";
      JobseekerSubRole2["LevelUpExternal"] = "LevelUpExternal";
      JobseekerSubRole2["MCL_LevelUp"] = "MCL_LevelUp";
      JobseekerSubRole2["Onwards"] = "Onwards";
      JobseekerSubRole2["CollegeStudents"] = "CollegeStudents";
      JobseekerSubRole2["Vector"] = "Vector";
      JobseekerSubRole2["Empower_Her"] = "Empower_Her";
      JobseekerSubRole2["Chitkara"] = "Chitkara";
      JobseekerSubRole2["IIT"] = "IIT";
      return JobseekerSubRole2;
    })(JobseekerSubRole || {});
    var UserPlacementTags3 = /* @__PURE__ */ ((UserPlacementTags22) => {
      UserPlacementTags22["Placed"] = "Placed";
      UserPlacementTags22["VerballyPlaced"] = "VerballyPlaced";
      UserPlacementTags22["Paused"] = "Paused";
      UserPlacementTags22["Available"] = "Available";
      UserPlacementTags22["Recovery"] = "Recovery";
      UserPlacementTags22["OutOfPLacement"] = "OutOfPLacement";
      UserPlacementTags22["PrePlacement"] = "PrePlacement";
      UserPlacementTags22["NotAvailable"] = "NotAvailable";
      UserPlacementTags22["AutoPaused"] = "AutoPaused";
      return UserPlacementTags22;
    })(UserPlacementTags3 || {});
    var LMSLinkingStatus = /* @__PURE__ */ ((LMSLinkingStatus2) => {
      LMSLinkingStatus2["STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL"] = "STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL";
      LMSLinkingStatus2["STUDENT_CODE_SUCCESSFULLY_UPDATED"] = "STUDENT_CODE_SUCCESSFULLY_UPDATED";
      LMSLinkingStatus2["PHONE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL"] = "PHONE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL";
      LMSLinkingStatus2["ACCOUNT_SUCCESSFULLY_CREATED"] = "ACCOUNT_SUCCESSFULLY_CREATED";
      LMSLinkingStatus2["CREATION_FAILED_STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL"] = "CREATION_FAILED_STUDENT_CODE_ALREADY_EXISTS_WITH_ANOTHER_EMAIL";
      return LMSLinkingStatus2;
    })(LMSLinkingStatus || {});
    var FeatureFlagType = /* @__PURE__ */ ((FeatureFlagType2) => {
      FeatureFlagType2["OFFLINE_DRIVE_PUSH_USER"] = "OFFLINE_DRIVE_PUSH_USER";
      return FeatureFlagType2;
    })(FeatureFlagType || {});
    var UserPercentileBucket2 = /* @__PURE__ */ ((UserPercentileBucket22) => {
      UserPercentileBucket22["TOP_ONE"] = "TOP_ONE";
      UserPercentileBucket22["TOP_TEN"] = "TOP_TEN";
      UserPercentileBucket22["TOP_TWENTY_FIVE"] = "TOP_TWENTY_FIVE";
      UserPercentileBucket22["TOP_FIFTY"] = "TOP_FIFTY";
      return UserPercentileBucket22;
    })(UserPercentileBucket2 || {});
    var UserExperienceLevelType4 = /* @__PURE__ */ ((UserExperienceLevelType22) => {
      UserExperienceLevelType22["FINAL_YEAR_STUDENT"] = "finalYearStudent";
      UserExperienceLevelType22["FRESHER"] = "fresher";
      UserExperienceLevelType22["OneToTwoYears"] = "oneToTwoYears";
      UserExperienceLevelType22["TwoPlusYears"] = "twoPlusYears";
      return UserExperienceLevelType22;
    })(UserExperienceLevelType4 || {});
    var UserCareerPathType3 = /* @__PURE__ */ ((UserCareerPathType22) => {
      UserCareerPathType22["SOFTWARE_DEVELOPMENT"] = "softwareDevelopment";
      UserCareerPathType22["DATA_ANALYTICS"] = "dataAnalytics";
      UserCareerPathType22["SDET"] = "sdet";
      UserCareerPathType22["TECH_SUPPORT"] = "techSupport";
      UserCareerPathType22["OPERATIONS"] = "operations";
      UserCareerPathType22["BD_EXECUTIVE"] = "bdExecutive";
      UserCareerPathType22["DEV_OPS"] = "devOps";
      UserCareerPathType22["MATH_ANNOTATIONS_EXPERT"] = "mathAnnotationsExpert";
      UserCareerPathType22["SITE_RELIABILITY_ENGINEER"] = "siteReliabilityEngineer";
      UserCareerPathType22["SALES"] = "sales";
      UserCareerPathType22["PRODUCT"] = "product";
      UserCareerPathType22["HUMAN_RESOURCES"] = "humanResources";
      UserCareerPathType22["MARKETING"] = "marketing";
      UserCareerPathType22["HASKELL"] = "haskell";
      UserCareerPathType22["REACT_NATIVE"] = "reactNative";
      UserCareerPathType22["AI_ENGINEER"] = "aiEngineer";
      return UserCareerPathType22;
    })(UserCareerPathType3 || {});
    var DevelopmentRoleType2 = /* @__PURE__ */ ((DevelopmentRoleType22) => {
      DevelopmentRoleType22["FRONTEND"] = "frontend";
      DevelopmentRoleType22["BACKEND"] = "backend";
      DevelopmentRoleType22["FULL_STACK"] = "fullStack";
      DevelopmentRoleType22["OTHER"] = "other";
      DevelopmentRoleType22["DATA_ANALYST"] = "dataAnalyst";
      DevelopmentRoleType22["DATA_SCIENTIST"] = "dataScientist";
      DevelopmentRoleType22["TWO_TO_FOUR_YEARS"] = "twoToFourYearsExperience";
      DevelopmentRoleType22["FOUR_PLUS_YEARS"] = "fourPlusYearsExperience";
      DevelopmentRoleType22["SALES_B2C"] = "salesB2C";
      DevelopmentRoleType22["SALES_B2B"] = "salesB2B";
      DevelopmentRoleType22["PRODUCT_MANAGER"] = "productManager";
      DevelopmentRoleType22["HR_MANAGER"] = "hrManager";
      DevelopmentRoleType22["DIGITAL_MARKETING"] = "digitalMarketing";
      DevelopmentRoleType22["SENIOR_QA_ENGINEER"] = "seniorQAEngineer";
      DevelopmentRoleType22["SENIOR_HASKELL_ENGINEER"] = "seniorHaskellEngineer";
      DevelopmentRoleType22["SENIOR_REACT_NATIVE_DEVELOPER"] = "seniorReactNativeDeveloper";
      return DevelopmentRoleType22;
    })(DevelopmentRoleType2 || {});
    var TechStackType3 = /* @__PURE__ */ ((TechStackType22) => {
      TechStackType22["MEAN"] = "mean";
      TechStackType22["PYTHON"] = "python";
      TechStackType22["MERN"] = "mern";
      TechStackType22["DJANGO"] = "django";
      TechStackType22["JAVA"] = "java";
      TechStackType22["NODE"] = "node";
      TechStackType22["REACT"] = "react";
      TechStackType22["SDET"] = "sdet";
      TechStackType22["DATA_ANALYTICS"] = "dataAnalytics";
      TechStackType22["ANGULAR"] = "angular";
      TechStackType22["VUE"] = "vue";
      TechStackType22["FLASK"] = "flask";
      TechStackType22["C_SHARP_ENGINEER"] = "csharpEngineer";
      TechStackType22["OTHER"] = "other";
      return TechStackType22;
    })(TechStackType3 || {});
    var UserPapStatus = /* @__PURE__ */ ((UserPapStatus2) => {
      UserPapStatus2["NEW_PAP"] = "New PAP";
      UserPapStatus2["NO_PAP"] = "No PAP";
      UserPapStatus2["OLD_PAP"] = "Old PAP";
      UserPapStatus2["PAP"] = "PAP";
      return UserPapStatus2;
    })(UserPapStatus || {});
    var AssessmentDuration = /* @__PURE__ */ ((AssessmentDuration2) => {
      AssessmentDuration2["THIRTY_MIN"] = "30 MINS";
      AssessmentDuration2["SIXTY_MIN"] = "60 MINS";
      AssessmentDuration2["NINETY_MIN"] = "90 MINS";
      return AssessmentDuration2;
    })(AssessmentDuration || {});
    var GaugingCandidateStatus = /* @__PURE__ */ ((GaugingCandidateStatus2) => {
      GaugingCandidateStatus2["OVERALL"] = "Overall";
      GaugingCandidateStatus2["THEORETICAL"] = "Theoretical";
      GaugingCandidateStatus2["PRACTICAL"] = "Practical";
      return GaugingCandidateStatus2;
    })(GaugingCandidateStatus || {});
    var skillsWeightageParameters = /* @__PURE__ */ ((skillsWeightageParameters2) => {
      skillsWeightageParameters2["REACT"] = "react";
      skillsWeightageParameters2["JAVA"] = "java";
      skillsWeightageParameters2["HTML"] = "html";
      skillsWeightageParameters2["MERN"] = "mern";
      skillsWeightageParameters2["CSS"] = "css";
      skillsWeightageParameters2["ALGORITHMS"] = "algorithms";
      skillsWeightageParameters2["DSA"] = "dsa";
      skillsWeightageParameters2["BACKEND"] = "backend";
      skillsWeightageParameters2["SOFT_SKILLS"] = "softSkills";
      skillsWeightageParameters2["SQL"] = "sql";
      return skillsWeightageParameters2;
    })(skillsWeightageParameters || {});
    var YesOrNoEnum = /* @__PURE__ */ ((YesOrNoEnum2) => {
      YesOrNoEnum2["Yes"] = "yes";
      YesOrNoEnum2["No"] = "no";
      return YesOrNoEnum2;
    })(YesOrNoEnum || {});
    var StateCityTypes2 = /* @__PURE__ */ ((StateCityTypes22) => {
      StateCityTypes22["Maharashtra"] = "Maharashtra";
      StateCityTypes22["Karnataka"] = "Karnataka";
      StateCityTypes22["TamilNadu"] = "Tamil Nadu";
      StateCityTypes22["UttarPradesh"] = "Uttar Pradesh";
      StateCityTypes22["WestBengal"] = "West Bengal";
      StateCityTypes22["Gujarat"] = "Gujarat";
      StateCityTypes22["Rajasthan"] = "Rajasthan";
      StateCityTypes22["MadhyaPradesh"] = "Madhya Pradesh";
      StateCityTypes22["Punjab"] = "Punjab";
      StateCityTypes22["Bihar"] = "Bihar";
      StateCityTypes22["Odisha"] = "Odisha";
      StateCityTypes22["Telangana"] = "Telangana";
      StateCityTypes22["AndhraPradesh"] = "Andhra Pradesh";
      StateCityTypes22["Kerala"] = "Kerala";
      StateCityTypes22["Haryana"] = "Haryana";
      StateCityTypes22["Jharkhand"] = "Jharkhand";
      StateCityTypes22["Chhattisgarh"] = "Chhattisgarh";
      StateCityTypes22["Assam"] = "Assam";
      StateCityTypes22["HimachalPradesh"] = "Himachal Pradesh";
      StateCityTypes22["JammuAndKashmir"] = "Jammu and Kashmir";
      StateCityTypes22["Uttarakhand"] = "Uttarakhand";
      StateCityTypes22["Tripura"] = "Tripura";
      StateCityTypes22["Meghalaya"] = "Meghalaya";
      StateCityTypes22["Manipur"] = "Manipur";
      StateCityTypes22["Nagaland"] = "Nagaland";
      StateCityTypes22["Mizoram"] = "Mizoram";
      StateCityTypes22["ArunachalPradesh"] = "Arunachal Pradesh";
      StateCityTypes22["Sikkim"] = "Sikkim";
      StateCityTypes22["Goa"] = "Goa";
      StateCityTypes22["Delhi"] = "Delhi";
      StateCityTypes22["Chandigarh"] = "Chandigarh";
      StateCityTypes22["Puducherry"] = "Puducherry";
      StateCityTypes22["Lakshadweep"] = "Lakshadweep";
      StateCityTypes22["DadraAndNagarHaveliAndDamanAndDiu"] = "Dadra and Nagar Haveli and Daman and Diu";
      StateCityTypes22["AndamanAndNicobarIslands"] = "Andaman and Nicobar Islands";
      StateCityTypes22["Ladakh"] = "Ladakh";
      return StateCityTypes22;
    })(StateCityTypes2 || {});
    var UndergraduateDegreeTypes2 = /* @__PURE__ */ ((UndergraduateDegreeTypes22) => {
      UndergraduateDegreeTypes22["Others"] = "Others";
      UndergraduateDegreeTypes22["BSc"] = "B.Sc.";
      UndergraduateDegreeTypes22["BTech"] = "B.Tech.";
      UndergraduateDegreeTypes22["BE"] = "B.E.";
      UndergraduateDegreeTypes22["BArch"] = "B.Arch.";
      UndergraduateDegreeTypes22["BCA"] = "BCA";
      UndergraduateDegreeTypes22["BCom"] = "B.Com.";
      UndergraduateDegreeTypes22["BBA"] = "BBA";
      UndergraduateDegreeTypes22["BBM"] = "BBM";
      UndergraduateDegreeTypes22["BMS"] = "BMS";
      UndergraduateDegreeTypes22["BA"] = "BA";
      UndergraduateDegreeTypes22["BFA"] = "BFA";
      UndergraduateDegreeTypes22["BVA"] = "BVA";
      UndergraduateDegreeTypes22["BDes"] = "B.Des.";
      UndergraduateDegreeTypes22["BJMC"] = "BJMC";
      UndergraduateDegreeTypes22["BSW"] = "BSW";
      UndergraduateDegreeTypes22["LLB"] = "LLB";
      UndergraduateDegreeTypes22["MBBS"] = "MBBS";
      UndergraduateDegreeTypes22["BDS"] = "BDS";
      UndergraduateDegreeTypes22["BAMS"] = "BAMS";
      UndergraduateDegreeTypes22["BHMS"] = "BHMS";
      UndergraduateDegreeTypes22["BPT"] = "BPT";
      UndergraduateDegreeTypes22["BOT"] = "BOT";
      UndergraduateDegreeTypes22["BPharm"] = "B.Pharm.";
      UndergraduateDegreeTypes22["BHM"] = "BHM";
      UndergraduateDegreeTypes22["BEd"] = "B.Ed.";
      UndergraduateDegreeTypes22["BLiSc"] = "B.Li.Sc.";
      UndergraduateDegreeTypes22["BPlan"] = "B.Plan.";
      UndergraduateDegreeTypes22["BVoc"] = "B.Voc.";
      UndergraduateDegreeTypes22["BASLP"] = "BASLP";
      UndergraduateDegreeTypes22["BALlb"] = "BA LLB";
      UndergraduateDegreeTypes22["BComLlb"] = "B.Com LLB";
      UndergraduateDegreeTypes22["BBALLb"] = "BBA LLB";
      return UndergraduateDegreeTypes22;
    })(UndergraduateDegreeTypes2 || {});
    var PostgraduateDegreeTypes2 = /* @__PURE__ */ ((PostgraduateDegreeTypes22) => {
      PostgraduateDegreeTypes22["Others"] = "Others";
      PostgraduateDegreeTypes22["MSc"] = "M.Sc.";
      PostgraduateDegreeTypes22["MTech"] = "M.Tech.";
      PostgraduateDegreeTypes22["ME"] = "M.E.";
      PostgraduateDegreeTypes22["MArch"] = "M.Arch.";
      PostgraduateDegreeTypes22["MCA"] = "MCA";
      PostgraduateDegreeTypes22["MCom"] = "M.Com.";
      PostgraduateDegreeTypes22["MBA"] = "MBA";
      PostgraduateDegreeTypes22["MA"] = "MA";
      PostgraduateDegreeTypes22["MFA"] = "MFA";
      PostgraduateDegreeTypes22["MDes"] = "M.Des.";
      PostgraduateDegreeTypes22["MJMC"] = "MJMC";
      PostgraduateDegreeTypes22["MSW"] = "MSW";
      PostgraduateDegreeTypes22["LLM"] = "LLM";
      PostgraduateDegreeTypes22["MD"] = "MD";
      PostgraduateDegreeTypes22["MS"] = "MS";
      PostgraduateDegreeTypes22["MDS"] = "MDS";
      PostgraduateDegreeTypes22["MPharm"] = "M.Pharm.";
      PostgraduateDegreeTypes22["MEd"] = "M.Ed.";
      PostgraduateDegreeTypes22["MLiSc"] = "M.Li.Sc.";
      PostgraduateDegreeTypes22["MPlan"] = "M.Plan.";
      PostgraduateDegreeTypes22["MVoc"] = "M.Voc.";
      PostgraduateDegreeTypes22["MASLP"] = "MASLP";
      return PostgraduateDegreeTypes22;
    })(PostgraduateDegreeTypes2 || {});
    var ScoreType = /* @__PURE__ */ ((ScoreType2) => {
      ScoreType2["PERCENTAGE"] = "percentage";
      ScoreType2["CGPA"] = "cgpa";
      ScoreType2["GPA"] = "gpa";
      return ScoreType2;
    })(ScoreType || {});
    var ApplicationStatus4 = /* @__PURE__ */ ((ApplicationStatus22) => {
      ApplicationStatus22["OPENED_BY_EMPLOYER"] = "OpenedByEmployer";
      ApplicationStatus22["OPENED_BY_ADMIN"] = "OpenedByAdmin";
      ApplicationStatus22["APPLIED_BY_JOBSEEKER"] = "AppliedByJobSeeker";
      ApplicationStatus22["SHORTLISTED"] = "Shortlisted";
      ApplicationStatus22["REJECTED"] = "Rejected";
      ApplicationStatus22["SCREEN_REJECTED"] = "ScreenRejected";
      ApplicationStatus22["AUTO_REJECTED"] = "AutoRejected";
      ApplicationStatus22["OFFER_REVOKED"] = "OfferRevoked";
      ApplicationStatus22["EXPIRED"] = "Expired";
      ApplicationStatus22["JOBSEEKER_OPTED_OUT"] = "JobSeekerOptedOut";
      ApplicationStatus22["PLACED"] = "Placed";
      ApplicationStatus22["VERBALLY_PLACED"] = "VerballyPlaced";
      ApplicationStatus22["CLOSED_BY_RECRUITER"] = "ClosedByRecruiter";
      ApplicationStatus22["CLOSED_BY_ADMIN"] = "ClosedByAdmin";
      ApplicationStatus22["INTERVIEW_SCHEDULED"] = "InterviewScheduled";
      ApplicationStatus22["ASSIGNMENT_IN_PROGRESS"] = "AssignmentInProgress";
      ApplicationStatus22["CASE_STUDY_IN_PROGRESS"] = "CaseStudyInProgress";
      ApplicationStatus22["OFFER_ROLLED_OUT"] = "OfferRolledOut";
      ApplicationStatus22["OFFER_REJECTED"] = "OfferRejected";
      ApplicationStatus22["WAITING_FOR_RECRUITER_ACTION"] = "WaitingForRecruiterAction";
      ApplicationStatus22["QUALIFIED_ALL_ROUNDS"] = "QualifiedAllRounds";
      ApplicationStatus22["PENDING_FOR_OFFER_LETTER_APPROVAL"] = "PendingForOfferLetterApproval";
      ApplicationStatus22["PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL"] = "PendingForAssignmentSubmissionApproval";
      ApplicationStatus22["PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL"] = "PendingForCaseStudySubmissionApproval";
      ApplicationStatus22["PENDING_FOR_OPT_OUT_APPROVAL"] = "PendingForOptOutApproval";
      ApplicationStatus22["CHANGED_OFFER_TERMS"] = "ChangedOfferTerms";
      ApplicationStatus22["PLACED_ELSEWHERE"] = "PlacedElseWhere";
      ApplicationStatus22["PENDING_FOR_ADMIN_APPROVAL"] = "PendingForAdminApproval";
      return ApplicationStatus22;
    })(ApplicationStatus4 || {});
    var ApplicationReminderType = /* @__PURE__ */ ((ApplicationReminderType2) => {
      ApplicationReminderType2["INACTIVE"] = "inactive";
      ApplicationReminderType2["EXPIRY"] = "expiry";
      ApplicationReminderType2["APPLIED_UNDER_REVIEW_AFTER_3_DAYS"] = "applied_under_review_3_days";
      ApplicationReminderType2["APPLIED_REJECT_AFTER_7_DAYS"] = "applied_reject_after_7_days";
      ApplicationReminderType2["SHORTLISTED_UNDER_REVIEW_AFTER_3_DAYS"] = "shortlisted_under_review_3_days";
      ApplicationReminderType2["SHORTLISTED_REJECT_AFTER_10_DAYS"] = "shortlisted_reject_after_10_days";
      return ApplicationReminderType2;
    })(ApplicationReminderType || {});
    var OptOutReason = /* @__PURE__ */ ((OptOutReason2) => {
      OptOutReason2["LOCATION_CONSTRAINTS"] = "location_constraints";
      OptOutReason2["LOWER_CTC"] = "lower_ctc";
      OptOutReason2["ACCEPTED_ANOTHER_OPPORTUNITY"] = "accepted_another_opportunity";
      OptOutReason2["TECH_STACK_ROLE_NOT_RELEVANT"] = "tech_stack_role_not_relevant";
      OptOutReason2["OTHER"] = "other";
      return OptOutReason2;
    })(OptOutReason || {});
    var UserISAStatus = /* @__PURE__ */ ((UserISAStatus2) => {
      UserISAStatus2["ABOVE_ISA"] = "Above ISA";
      UserISAStatus2["BELOW_ISA"] = "Below ISA";
      UserISAStatus2["NO_REVENUE"] = "No Revenue";
      UserISAStatus2["MORAT"] = "Morat";
      UserISAStatus2["ONLY_INTERN"] = "Only Intern";
      return UserISAStatus2;
    })(UserISAStatus || {});
    var UIApplicationTypeEnum = /* @__PURE__ */ ((UIApplicationTypeEnum2) => {
      UIApplicationTypeEnum2["MATCHED_APPLICATIONS"] = "matchedApplications";
      UIApplicationTypeEnum2["APPLIED_APPLICATIONS"] = "appliedApplications";
      UIApplicationTypeEnum2["ONGOING_APPLICATIONS"] = "ongoingApplications";
      UIApplicationTypeEnum2["CLOSED_APPLICATIONS"] = "closedApplications";
      return UIApplicationTypeEnum2;
    })(UIApplicationTypeEnum || {});
    var UIApplicationCardState = /* @__PURE__ */ ((UIApplicationCardState2) => {
      UIApplicationCardState2["MATCHED_CARD"] = "matched-card";
      UIApplicationCardState2["APPLIED_CARD"] = "applied-card";
      UIApplicationCardState2["INTERVIEW_ROUND_IN_PROGRESS_CARD"] = "interview-round-in-progress-card";
      UIApplicationCardState2["ASSIGNMENT_ROUND_IN_PROGRESS_CARD"] = "assignment-round-in-progress-card";
      UIApplicationCardState2["CASE_STUDY_ROUND_IN_PROGRESS_CARD"] = "case-study-round-in-progress-card";
      UIApplicationCardState2["JOBSEEKER_OPTED_OUT_CARD"] = "jobseeker-opted-out-card";
      UIApplicationCardState2["OFFERED_CARD"] = "offered-card";
      UIApplicationCardState2["CLOSED_CARD"] = "closed-card";
      UIApplicationCardState2["SHORTLISTED_CARD"] = "shortlisted-card";
      UIApplicationCardState2["WAITING_FOR_RECRUITER_ACTION_CARD"] = "waiting-for-recruiter-action-card";
      UIApplicationCardState2["QUALIFIED_ALL_ROUNDS_CARD"] = "qualified-all-rounds-card";
      UIApplicationCardState2["PENDING_FOR_OFFER_LETTER_APPROVAL_CARD"] = "pending-for-offer-letter-approval-card";
      UIApplicationCardState2["PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL_CARD"] = "pending-for-assignment-submission-approval-card";
      UIApplicationCardState2["PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL_CARD"] = "pending-for-case-study-submission-approval-card";
      UIApplicationCardState2["PENDING_FOR_OPT_OUT_APPROVAL_CARD"] = "pending-for-opt-out-approval-card";
      UIApplicationCardState2["PLACED_CARD"] = "placed-card";
      UIApplicationCardState2["REJECTED_CARD"] = "rejected-card";
      UIApplicationCardState2["CHANGED_OFFER_TERMS_CARD"] = "changed-offer-terms-card";
      UIApplicationCardState2["SELECTED_CARD"] = "selected-card";
      return UIApplicationCardState2;
    })(UIApplicationCardState || {});
    var UIRemarksDrawerType = /* @__PURE__ */ ((UIRemarksDrawerType2) => {
      UIRemarksDrawerType2["REQUEST_OFFER_CHANGES"] = "request-offer-changes";
      UIRemarksDrawerType2["REJECT_ASSIGNMENT"] = "reject-assignment";
      UIRemarksDrawerType2["REQUEST_CORRECTION_IN_ASSIGNMENT"] = "request-correction-in-assignment";
      UIRemarksDrawerType2["REJECT_CASE_STUDY"] = "reject-case-study";
      UIRemarksDrawerType2["REQUEST_CORRECTION_IN_CASE_STUDY"] = "request-correction-in-case-study";
      UIRemarksDrawerType2["SEND_OFFER_LETTER_CHANGES"] = "send-offer-letter-changes";
      UIRemarksDrawerType2["SEND_OPT_OUT_OFFER_CHANGES"] = "send-opt-out-offer-changes";
      return UIRemarksDrawerType2;
    })(UIRemarksDrawerType || {});
    var CurrentWorkingStatus = /* @__PURE__ */ ((CurrentWorkingStatus2) => {
      CurrentWorkingStatus2["Studying"] = "Studying";
      CurrentWorkingStatus2["Working"] = "Working";
      CurrentWorkingStatus2["GraduatedNotWorking"] = "GraduatedNotWorking";
      return CurrentWorkingStatus2;
    })(CurrentWorkingStatus || {});
    var DegreeType = /* @__PURE__ */ ((DegreeType2) => {
      DegreeType2["School"] = "School (10th)";
      DegreeType2["HighSchool"] = "High School (12th)";
      DegreeType2["Bachelors"] = "Bachelors";
      DegreeType2["Masters"] = "Masters";
      DegreeType2["Diploma"] = "Diploma";
      DegreeType2["PostGraduateDiploma"] = "Post Graduate Diploma";
      DegreeType2["Doctorate"] = "Doctorate";
      return DegreeType2;
    })(DegreeType || {});
    var PositionEducationRequirementType = /* @__PURE__ */ ((PositionEducationRequirementType2) => {
      PositionEducationRequirementType2["AnyDegree"] = "No Degree Constraints";
      PositionEducationRequirementType2["AnyGraduates"] = "Graduate";
      PositionEducationRequirementType2["BCA_MCA"] = "BCA/MCA";
      PositionEducationRequirementType2["Btech"] = "B.Tech";
      PositionEducationRequirementType2["BtechWithCSE"] = "B.Tech (CS/IT)";
      return PositionEducationRequirementType2;
    })(PositionEducationRequirementType || {});
    var CourseType = /* @__PURE__ */ ((CourseType2) => {
      CourseType2["BTechBE"] = "B.Tech/B.E";
      CourseType2["BCA"] = "BCA";
      CourseType2["MCA"] = "MCA";
      CourseType2["MTech"] = "M.Tech";
      CourseType2["PGDCA"] = "PGDCA";
      CourseType2["BSc"] = "B.Sc";
      CourseType2["BPharm"] = "B.Pharm";
      CourseType2["MSc"] = "M.Sc";
      CourseType2["ITI"] = "ITI";
      CourseType2["BA"] = "B.A";
      CourseType2["BCom"] = "B.Com";
      CourseType2["MBA"] = "MBA";
      CourseType2["Diploma"] = "Diploma";
      CourseType2["BArch"] = "B.Arch";
      CourseType2["MCom"] = "M.COM";
      CourseType2["BBA"] = "BBA";
      CourseType2["LLB"] = "LLB";
      CourseType2["BElEd"] = "B.El.Ed";
      CourseType2["MA"] = "M.A";
      CourseType2["BachelorHotelManagement"] = "Bachelor in Hotel Management";
      CourseType2["HighSchoolGraduate"] = "12th Graduate";
      CourseType2["GraduationDropout"] = "Graduation Dropout";
      return CourseType2;
    })(CourseType || {});
    var SpecializationType = /* @__PURE__ */ ((SpecializationType2) => {
      SpecializationType2["ElectronicsInstrumentation"] = "Electronics & Instrumentation";
      SpecializationType2["Electrical"] = "Electrical";
      SpecializationType2["ElectricalElectronics"] = "Electrical & Electronics";
      SpecializationType2["Electronics"] = "Electronics";
      SpecializationType2["ECE"] = "ECE";
      SpecializationType2["CS"] = "CS";
      SpecializationType2["IT"] = "IT";
      SpecializationType2["Mathematics"] = "Mathematics";
      SpecializationType2["Others"] = "Others";
      SpecializationType2["Any"] = "Any";
      return SpecializationType2;
    })(SpecializationType || {});
    var GradeType = /* @__PURE__ */ ((GradeType2) => {
      GradeType2["Percentage"] = "Percentage (%)";
      GradeType2["GradePointAverage"] = "Grade Point Average (GPA)";
      return GradeType2;
    })(GradeType || {});
    var RecommendedPath = /* @__PURE__ */ ((RecommendedPath2) => {
      RecommendedPath2["PrepPlan"] = "PrepPlan";
      RecommendedPath2["JAP"] = "JAP";
      RecommendedPath2["MAP"] = "MAP";
      RecommendedPath2["Vector"] = "Vector";
      RecommendedPath2["MCL_1_Week"] = "MCL_1_Week";
      RecommendedPath2["MCL_1_Month"] = "MCL_1_Month";
      RecommendedPath2["Need_Improvement"] = "Need_Improvement";
      RecommendedPath2["Back_to_Masai"] = "Back_to_Masai";
      RecommendedPath2["Missed_One_Round"] = "Missed_One_Round";
      RecommendedPath2["Missed_Two_Rounds"] = "Missed_Two_Rounds";
      RecommendedPath2["Schedule_First_Round"] = "Schedule_First_Round";
      return RecommendedPath2;
    })(RecommendedPath || {});
    var UserJapEnrollmentStatus = /* @__PURE__ */ ((UserJapEnrollmentStatus2) => {
      UserJapEnrollmentStatus2["OFFERED"] = "Offered";
      UserJapEnrollmentStatus2["STARTED"] = "Started";
      UserJapEnrollmentStatus2["ENROLLED"] = "Enrolled";
      UserJapEnrollmentStatus2["DECLINED"] = "Declined";
      UserJapEnrollmentStatus2["EXPIRED"] = "Expired";
      return UserJapEnrollmentStatus2;
    })(UserJapEnrollmentStatus || {});
    var UserJapEnrollmentType = /* @__PURE__ */ ((UserJapEnrollmentType2) => {
      UserJapEnrollmentType2["JAP"] = "JAP";
      UserJapEnrollmentType2["MAP"] = "MAP";
      return UserJapEnrollmentType2;
    })(UserJapEnrollmentType || {});
    var VerificationType = /* @__PURE__ */ ((VerificationType2) => {
      VerificationType2["PHONE"] = "Phone";
      VerificationType2["EMAIL"] = "Email";
      return VerificationType2;
    })(VerificationType || {});
    var InterviewPathType = /* @__PURE__ */ ((InterviewPathType2) => {
      InterviewPathType2["Paid"] = "Paid";
      InterviewPathType2["Free"] = "Free";
      return InterviewPathType2;
    })(InterviewPathType || {});
    var Reason = /* @__PURE__ */ ((Reason2) => {
      Reason2["DNP"] = "Did Not Pickup";
      Reason2["SwitchedOffOrNotReachable"] = "Switched Off/Not Reachable";
      Reason2["WrongNumber"] = "Wrong Number";
      Reason2["NumberBusy"] = "Number Busy";
      Reason2["CallRejected"] = "Call Rejected";
      Reason2["NumberNotPresent"] = "Number Not Present";
      Reason2["UserAskedToCallBackLater"] = "User asked to call back later";
      Reason2["UserNotInterested"] = "User mentioned that he/she is not interested to give the screening round";
      return Reason2;
    })(Reason || {});
    var ApplicationRoundStatus3 = /* @__PURE__ */ ((ApplicationRoundStatus22) => {
      ApplicationRoundStatus22["NotStarted"] = "NotStarted";
      ApplicationRoundStatus22["Started"] = "Started";
      ApplicationRoundStatus22["Initiated"] = "Initiated";
      ApplicationRoundStatus22["PendingForSubmissionApproval"] = "PendingForSubmissionApproval";
      ApplicationRoundStatus22["Submitted"] = "Submitted";
      ApplicationRoundStatus22["Rejected"] = "Rejected";
      ApplicationRoundStatus22["Skipped"] = "Skipped";
      ApplicationRoundStatus22["Qualified"] = "Qualified";
      ApplicationRoundStatus22["Cancelled"] = "Cancelled";
      ApplicationRoundStatus22["Rescheduled"] = "Rescheduled";
      ApplicationRoundStatus22["RequestedForReschedule"] = "RequestedForReschedule";
      ApplicationRoundStatus22["RequestedForCancellation"] = "RequestedForCancellation";
      ApplicationRoundStatus22["JobseekerOptedOut"] = "JobseekerOptedOut";
      ApplicationRoundStatus22["PlacedElseWhere"] = "PlacedElseWhere";
      return ApplicationRoundStatus22;
    })(ApplicationRoundStatus3 || {});
    var ApplicationRoundType2 = /* @__PURE__ */ ((ApplicationRoundType22) => {
      ApplicationRoundType22["Assignment"] = "Assignment";
      ApplicationRoundType22["Interview"] = "Interview";
      ApplicationRoundType22["OnlineTest"] = "OnlineTest";
      ApplicationRoundType22["CaseStudy"] = "CaseStudy";
      return ApplicationRoundType22;
    })(ApplicationRoundType2 || {});
    var AssignmentSubmissionType2 = /* @__PURE__ */ ((AssignmentSubmissionType22) => {
      AssignmentSubmissionType22["Link"] = "Link";
      AssignmentSubmissionType22["File"] = "File";
      AssignmentSubmissionType22["Both"] = "Both";
      AssignmentSubmissionType22["Other"] = "Other";
      return AssignmentSubmissionType22;
    })(AssignmentSubmissionType2 || {});
    var ApplicationChatMode = /* @__PURE__ */ ((ApplicationChatMode2) => {
      ApplicationChatMode2["Whatsapp"] = "Whatsapp";
      ApplicationChatMode2["Email"] = "Email";
      ApplicationChatMode2["Both"] = "Both";
      return ApplicationChatMode2;
    })(ApplicationChatMode || {});
    var RoundLabelType = /* @__PURE__ */ ((RoundLabelType2) => {
      RoundLabelType2["Screening"] = "Screening";
      RoundLabelType2["Coding_Test"] = "Coding_Test";
      RoundLabelType2["Take_Home_Assignment"] = "Take_Home_Assignment";
      RoundLabelType2["Technical_Discussion"] = "Technical_Discussion";
      RoundLabelType2["Cultural_Fit_Round"] = "Cultural_Fit_Round";
      RoundLabelType2["CXO_Discussion"] = "CXO_Discussion";
      return RoundLabelType2;
    })(RoundLabelType || {});
    var ApprovalType = /* @__PURE__ */ ((ApprovalType2) => {
      ApprovalType2["AssignmentSubmission"] = "AssignmentSubmission";
      ApprovalType2["CaseStudySubmission"] = "CaseStudySubmission";
      ApprovalType2["OfferLetter"] = "OfferLetter";
      ApprovalType2["OfferLetterRejection"] = "OfferLetterRejection";
      ApprovalType2["MeetingRescheduleOrCancel"] = "MeetingRescheduleOrCancel";
      ApprovalType2["JobseekerOptOut"] = "JobseekerOptOut";
      ApprovalType2["Chat"] = "Chat";
      return ApprovalType2;
    })(ApprovalType || {});
    var ProfilePageTabs = /* @__PURE__ */ ((ProfilePageTabs2) => {
      ProfilePageTabs2["Stats"] = "Stats";
      ProfilePageTabs2["Profile"] = "Profile";
      ProfilePageTabs2["Recordings"] = "Recordings";
      return ProfilePageTabs2;
    })(ProfilePageTabs || {});
    var SubRoundType = /* @__PURE__ */ ((SubRoundType2) => {
      SubRoundType2["Javaandspring"] = "JAVAANDSPRING";
      SubRoundType2["Mern"] = "MERN";
      SubRoundType2["Nodeandexpress"] = "NODEANDEXPRESS";
      SubRoundType2["Pythonanddjango"] = "PYTHONANDDJANGO";
      SubRoundType2["Pythonandflask"] = "PYTHONANDFLASK";
      SubRoundType2["Sdet"] = "SDET";
      SubRoundType2["React"] = "REACT";
      SubRoundType2["DA"] = "DATAANALYTICS";
      return SubRoundType2;
    })(SubRoundType || {});
    var WeekDay3 = /* @__PURE__ */ ((WeekDay22) => {
      WeekDay22["Friday"] = "Friday";
      WeekDay22["Monday"] = "Monday";
      WeekDay22["Saturday"] = "Saturday";
      WeekDay22["Sunday"] = "Sunday";
      WeekDay22["Thursday"] = "Thursday";
      WeekDay22["Tuesday"] = "Tuesday";
      WeekDay22["Wednesday"] = "Wednesday";
      return WeekDay22;
    })(WeekDay3 || {});
    var RoundType = /* @__PURE__ */ ((RoundType2) => {
      RoundType2["DSA"] = "Dsa";
      RoundType2["DSA_OLD"] = "DSA";
      RoundType2["Development"] = "Development";
      RoundType2["HLD"] = "HLD";
      RoundType2["LLD"] = "LLD";
      return RoundType2;
    })(RoundType || {});
    var CompanyType2 = /* @__PURE__ */ ((CompanyType22) => {
      CompanyType22["LARGE_ENTERPRISE"] = "LargeEnterprise";
      CompanyType22["MEDIUM_ENTERPRISE"] = "MediumEnterprise";
      CompanyType22["SMALL_ENTERPRISE"] = "SmallEnterprise";
      CompanyType22["PRE_SEED_OR_BOOTSTRAP_OR_SEED_FUNDED_STARTUP"] = "PreSeedOrBootstrapOrSeedFundedStartup";
      CompanyType22["SERIES_AB_FUNDED_STARTUP"] = "SeriesAbFundedStartup";
      CompanyType22["SONICORN_OR_UNICORN_STARTUP"] = "SonicornOrUnicornStartup";
      return CompanyType22;
    })(CompanyType2 || {});
    var CompanyNature2 = /* @__PURE__ */ ((CompanyNature22) => {
      CompanyNature22["SERVICE"] = "Service";
      CompanyNature22["PRODUCT"] = "Product";
      return CompanyNature22;
    })(CompanyNature2 || {});
    var AccountManagerType = /* @__PURE__ */ ((AccountManagerType2) => {
      AccountManagerType2["Primary"] = "Primary";
      AccountManagerType2["Secondary"] = "Secondary";
      AccountManagerType2["LeadGen"] = "LeadGen";
      AccountManagerType2["PrepCoach"] = "PrepCoach";
      return AccountManagerType2;
    })(AccountManagerType || {});
    var CompanyOwnershipType2 = /* @__PURE__ */ ((CompanyOwnershipType22) => {
      CompanyOwnershipType22["Private"] = "Private";
      CompanyOwnershipType22["Public"] = "Public";
      return CompanyOwnershipType22;
    })(CompanyOwnershipType2 || {});
    var NatureOfBusinessType2 = /* @__PURE__ */ ((NatureOfBusinessType22) => {
      NatureOfBusinessType22["B2B"] = "B2B";
      NatureOfBusinessType22["B2C"] = "B2C";
      return NatureOfBusinessType22;
    })(NatureOfBusinessType2 || {});
    var WorkingMode3 = /* @__PURE__ */ ((WorkingMode22) => {
      WorkingMode22["INTERNSHIP"] = "Internship";
      WorkingMode22["FULL_TIME"] = "FullTime";
      WorkingMode22["INTERNSHIP_TO_FULL_TIME"] = "InternshipToFullTime";
      return WorkingMode22;
    })(WorkingMode3 || {});
    var PositionQualifiedFor = /* @__PURE__ */ ((PositionQualifiedFor2) => {
      PositionQualifiedFor2["MASAI_1"] = "Masai 1";
      PositionQualifiedFor2["ALUMNI"] = "Alumni";
      PositionQualifiedFor2["CAP"] = "CAP";
      return PositionQualifiedFor2;
    })(PositionQualifiedFor || {});
    var BriedDebriefCallType = /* @__PURE__ */ ((BriedDebriefCallType2) => {
      BriedDebriefCallType2["BRIEF"] = "Brief";
      BriedDebriefCallType2["DEBRIEF"] = "Debrief";
      return BriedDebriefCallType2;
    })(BriedDebriefCallType || {});
    var PositionTitle3 = /* @__PURE__ */ ((PositionTitle22) => {
      PositionTitle22["SDE_ONE"] = "SDE_ONE";
      PositionTitle22["SDE_TWO"] = "SDE_TWO";
      PositionTitle22["SDE_THREE"] = "SDE_THREE";
      PositionTitle22["SENIOR_SOFTWARE_ENGINEER"] = "SENIOR_SOFTWARE_ENGINEER";
      PositionTitle22["BACKEND_ENGINEER"] = "BACKEND_ENGINEER";
      PositionTitle22["FRONTEND_ENGINEER"] = "FRONTEND_ENGINEER";
      PositionTitle22["FULL_STACK_ENGINEER"] = "FULL_STACK_ENGINEER";
      PositionTitle22["TECH_LEAD"] = "TECH_LEAD";
      PositionTitle22["ASSOCIATE_SOFTWARE_ENGINEER"] = "ASSOCIATE_SOFTWARE_ENGINEER";
      PositionTitle22["SOFTWARE_ENGINEER"] = "SOFTWARE_ENGINEER";
      PositionTitle22["GRADUATE_ENGINEER_TRAINEE"] = "GRADUATE_ENGINEER_TRAINEE";
      PositionTitle22["ENGINEERING_LEAD"] = "ENGINEERING_LEAD";
      PositionTitle22["ENGINEERING_MANAGER"] = "ENGINEERING_MANAGER";
      PositionTitle22["LEAD_DEVELOPER"] = "LEAD_DEVELOPER";
      PositionTitle22["JUNIOR_SOFTWARE_TESTER"] = "JUNIOR_SOFTWARE_TESTER";
      PositionTitle22["JUNIOR_QA_TESTER"] = "JUNIOR_QA_TESTER";
      PositionTitle22["QA_TESTER"] = "QA_TESTER";
      PositionTitle22["TEST_ANALYST"] = "TEST_ANALYST";
      PositionTitle22["SOFTWARE_TESTER"] = "SOFTWARE_TESTER";
      PositionTitle22["AUTOMATION_ENGINEER"] = "AUTOMATION_ENGINEER";
      PositionTitle22["QA_ENGINEER"] = "QA_ENGINEER";
      PositionTitle22["MANUAL_TESTER"] = "MANUAL_TESTER";
      PositionTitle22["DATA_ANALYST"] = "DATA_ANALYST";
      PositionTitle22["BUSINESS_ANALYST"] = "BUSINESS_ANALYST";
      PositionTitle22["MIS_EXECUTIVE"] = "MIS_EXECUTIVE";
      PositionTitle22["DATA_SCIENTIST"] = "DATA_SCIENTIST";
      PositionTitle22["INSTRUCTIONAL_ASSOCIATE"] = "INSTRUCTIONAL_ASSOCIATE";
      PositionTitle22["INSTRUCTIONAL_ASSOCIATE_DA"] = "INSTRUCTIONAL_ASSOCIATE_DA";
      PositionTitle22["TAG_IMPLEMENTATION"] = "Tag Implementation";
      PositionTitle22["CUSTOMER_SUPPORT_ENGINEER"] = "CUSTOMER_SUPPORT_ENGINEER";
      PositionTitle22["E_COMMERCE_OPERATIONS_ANALYST"] = "E-commerce Operations Analyst";
      PositionTitle22["TECH_SUPPORT"] = "TECH_SUPPORT";
      PositionTitle22["SOLUTION_ENGINEER"] = "SOLUTION_ENGINEER";
      PositionTitle22["MENTOR_ENGINEER"] = "MENTOR_ENGINEER";
      PositionTitle22["ML_ENGINEER"] = "ML_ENGINEER";
      PositionTitle22["AI_DEVELOPER"] = "AI_DEVELOPER";
      PositionTitle22["PROMPT_ENGINEER"] = "PROMPT_ENGINEER";
      PositionTitle22["OPERATION_EXECUTIVE"] = "OPERATION_EXECUTIVE";
      PositionTitle22["EVENTS_EXECUTION"] = "EVENTS_EXECUTION";
      PositionTitle22["EMAILS_EXECUTION"] = "EMAILS_EXECUTION";
      PositionTitle22["CONTENT_PUBLISHER"] = "CONTENT_PUBLISHER";
      PositionTitle22["SALES"] = "SALES";
      PositionTitle22["MARKETING"] = "MARKETING";
      PositionTitle22["OPERATIONS"] = "OPERATIONS";
      PositionTitle22["MANAGEMENT_TRAINEE"] = "MANAGEMENT_TRAINEE";
      PositionTitle22["AI_ENGINEER"] = "AI_ENGINEER";
      PositionTitle22["LLM_ENGINEER"] = "LLM_ENGINEER";
      PositionTitle22["RESEARCH_ANALYST_INTERN"] = "RESEARCH_ANALYST_INTERN";
      PositionTitle22["DIGITAL_MARKETING"] = "DIGITAL_MARKETING";
      PositionTitle22["DOT_NET_DEVELOPER"] = "DOT_NET_DEVELOPER";
      PositionTitle22["CONTENT_CREATOR"] = "CONTENT_CREATOR";
      PositionTitle22["SOCIAL_MEDIA_EXECUTIVE"] = "SOCIAL_MEDIA_EXECUTIVE";
      PositionTitle22["DATA_ENGINEER"] = "DATA_ENGINEER";
      return PositionTitle22;
    })(PositionTitle3 || {});
    var PositionType3 = /* @__PURE__ */ ((PositionType22) => {
      PositionType22["REMOTE"] = "Remote";
      PositionType22["HYBRID"] = "Hybrid";
      PositionType22["OFFICE"] = "Office";
      return PositionType22;
    })(PositionType3 || {});
    var PositionStatus3 = /* @__PURE__ */ ((PositionStatus22) => {
      PositionStatus22["OPEN"] = "Open";
      PositionStatus22["CLOSED"] = "Closed";
      PositionStatus22["MY"] = "My";
      return PositionStatus22;
    })(PositionStatus3 || {});
    var UIPositionStatus = /* @__PURE__ */ ((UIPositionStatus2) => {
      UIPositionStatus2["SELF"] = "Self";
      UIPositionStatus2["ACTIVE"] = "Active";
      UIPositionStatus2["ALL_COMPANIES"] = "All_Companies";
      return UIPositionStatus2;
    })(UIPositionStatus || {});
    var VisibilityType2 = /* @__PURE__ */ ((VisibilityType22) => {
      VisibilityType22["OPENTOALL"] = "OpenToAll";
      VisibilityType22["PRIVATE"] = "Private";
      return VisibilityType22;
    })(VisibilityType2 || {});
    var InterviewFormatType = /* @__PURE__ */ ((InterviewFormatType2) => {
      InterviewFormatType2["ONLINE"] = "Online";
      InterviewFormatType2["HYBRID"] = "Hybrid";
      InterviewFormatType2["INPERSON"] = "InPerson";
      return InterviewFormatType2;
    })(InterviewFormatType || {});
    var PositionUserBehaviouralFlag2 = /* @__PURE__ */ ((PositionUserBehaviouralFlag22) => {
      PositionUserBehaviouralFlag22["RejectedOffer"] = "RejectedOffer";
      PositionUserBehaviouralFlag22["Plagiarism"] = "Plagiarism";
      PositionUserBehaviouralFlag22["MissedInterview"] = "MissedInterview";
      PositionUserBehaviouralFlag22["DidNotSubmitAssignment"] = "DidNotSubmitAssignment";
      PositionUserBehaviouralFlag22["MissingInAction"] = "MissingInAction";
      PositionUserBehaviouralFlag22["MissedBrief"] = "MissedBrief";
      PositionUserBehaviouralFlag22["MissedDebrief"] = "MissedDebrief";
      PositionUserBehaviouralFlag22["NotProvidingAvailability"] = "NotProvidingAvailability";
      PositionUserBehaviouralFlag22["UninformedDepartureFromCompany"] = "UninformedDepartureFromCompany";
      PositionUserBehaviouralFlag22["BadConductDuringInterviewOrMasaiEmployee"] = "BadConductDuringInterviewOrMasaiEmployee";
      PositionUserBehaviouralFlag22["DirectlyNegotiatingWithCompany"] = "DirectlyNegotiatingWithCompany";
      PositionUserBehaviouralFlag22["IntentionalUnderPerformance"] = "IntentionalUnderPerformance";
      return PositionUserBehaviouralFlag22;
    })(PositionUserBehaviouralFlag2 || {});
    var BehaviouralFlagStatus = /* @__PURE__ */ ((BehaviouralFlagStatus2) => {
      BehaviouralFlagStatus2["PENDING"] = "pending";
      BehaviouralFlagStatus2["APPROVED"] = "approved";
      BehaviouralFlagStatus2["REJECTED"] = "rejected";
      return BehaviouralFlagStatus2;
    })(BehaviouralFlagStatus || {});
    var TechStacksForPosition2 = /* @__PURE__ */ ((TechStacksForPosition22) => {
      TechStacksForPosition22["MERN"] = "MERN";
      TechStacksForPosition22["JAVA"] = "JAVA";
      TechStacksForPosition22["NodeJs"] = "NodeJs";
      TechStacksForPosition22["Vanilla_Javascript"] = "Vanilla_Javascript";
      TechStacksForPosition22["Python_Django"] = "Python_Django";
      TechStacksForPosition22["Python_Flask"] = "Python_Flask";
      TechStacksForPosition22["React_and_Java"] = "React_and_Java";
      TechStacksForPosition22["ReactJs"] = "ReactJs";
      TechStacksForPosition22["Java_and_Springboot"] = "Java_and_Springboot";
      TechStacksForPosition22["Tech_Agnostic"] = "Tech_Agnostic";
      TechStacksForPosition22["SDET"] = "SDET";
      TechStacksForPosition22["DATA_ANALYTICS"] = "DATA_ANALYTICS";
      TechStacksForPosition22["NON_TECH"] = "NON_TECH";
      TechStacksForPosition22["AI_ENGINEER"] = "AI";
      TechStacksForPosition22["Python"] = "Python";
      TechStacksForPosition22["R"] = "R";
      TechStacksForPosition22["MATLAB"] = "MATLAB";
      TechStacksForPosition22["Excel"] = "Excel";
      TechStacksForPosition22["SQL"] = "SQL";
      TechStacksForPosition22["PowerBI"] = "PowerBI";
      TechStacksForPosition22["Tableau"] = "Tableau";
      TechStacksForPosition22["DIGITAL_MARKETING"] = "Digital_Marketing";
      TechStacksForPosition22["DOT_NET"] = "Dot_Net";
      TechStacksForPosition22["CONTENT_CREATOR"] = "CONTENT_CREATOR";
      TechStacksForPosition22["SOCIAL_MEDIA_EXECUTIVE"] = "SOCIAL_MEDIA_EXECUTIVE";
      TechStacksForPosition22["DATA_ENGINEER"] = "DATA_ENGINEER";
      return TechStacksForPosition22;
    })(TechStacksForPosition2 || {});
    var MarketingPageStatus = /* @__PURE__ */ ((MarketingPageStatus2) => {
      MarketingPageStatus2["CONFIRMED"] = "Confirmed";
      MarketingPageStatus2["PENDING"] = "Pending";
      return MarketingPageStatus2;
    })(MarketingPageStatus || {});
    var TierType = /* @__PURE__ */ ((TierType2) => {
      TierType2["TIER_ONE"] = "Tier1";
      TierType2["TIER_TWO"] = "Tier2";
      TierType2["TIER_THREE"] = "Tier3";
      TierType2["TIER_FOUR"] = "Tier4";
      return TierType2;
    })(TierType || {});
    var StateFilterType = /* @__PURE__ */ ((StateFilterType2) => {
      StateFilterType2["POSITION_STATE"] = "PositionState";
      StateFilterType2["NEIGHBHOUR_STATES"] = "NeighbourStates";
      StateFilterType2["REGION_STATES"] = "RegionStates";
      return StateFilterType2;
    })(StateFilterType || {});
    var PositionBucketType = /* @__PURE__ */ ((PositionBucketType2) => {
      PositionBucketType2["FrontendEngineer"] = "FrontendEngineer";
      PositionBucketType2["BackendEngineerNode"] = "BackendEngineerNode";
      PositionBucketType2["BackendEngineerJava"] = "BackendEngineerJava";
      PositionBucketType2["FullStackEngineerMERN"] = "FullStackEngineerMERN";
      PositionBucketType2["DataAnalyst"] = "DataAnalyst";
      PositionBucketType2["SDET"] = "SDET";
      return PositionBucketType2;
    })(PositionBucketType || {});
    var AssessPlatformDifficulty = /* @__PURE__ */ ((AssessPlatformDifficulty2) => {
      AssessPlatformDifficulty2["low"] = "low";
      AssessPlatformDifficulty2["medium"] = "medium";
      AssessPlatformDifficulty2["high"] = "high";
      return AssessPlatformDifficulty2;
    })(AssessPlatformDifficulty || {});
    var QuestionTypes = /* @__PURE__ */ ((QuestionTypes2) => {
      QuestionTypes2["int"] = "int";
      QuestionTypes2["fitb"] = "fitb";
      QuestionTypes2["mcsc"] = "mcsc";
      QuestionTypes2["mcmc"] = "mcmc";
      QuestionTypes2["video"] = "video";
      QuestionTypes2["floatRange"] = "floatRange";
      QuestionTypes2["code"] = "coding";
      QuestionTypes2["subjective"] = "subjective";
      return QuestionTypes2;
    })(QuestionTypes || {});
    var SkillType2 = /* @__PURE__ */ ((SkillType22) => {
      SkillType22["TOPIC"] = "Topic";
      SkillType22["SKILL"] = "Skill";
      return SkillType22;
    })(SkillType2 || {});
    var SkillGroupType = /* @__PURE__ */ ((SkillGroupType2) => {
      SkillGroupType2["TECHNICAL_SKILLS"] = "Technical_Skills";
      SkillGroupType2["THEORETICAL_SKILLS"] = "Theoretical_Knowledge";
      SkillGroupType2["SOFT_SKILLS"] = "Soft_Skills";
      SkillGroupType2["APTITUDE_SKILLS"] = "Aptitude_Skills";
      return SkillGroupType2;
    })(SkillGroupType || {});
    var SkillPriority = /* @__PURE__ */ ((SkillPriority2) => {
      SkillPriority2["PRIMARY"] = "Primary";
      SkillPriority2["SECONDARY"] = "Secondary";
      return SkillPriority2;
    })(SkillPriority || {});
    var MeetingStatus3 = /* @__PURE__ */ ((MeetingStatus22) => {
      MeetingStatus22["SCHEDULED"] = "Scheduled";
      MeetingStatus22["STARTED"] = "Started";
      MeetingStatus22["COMPLETED"] = "Completed";
      MeetingStatus22["CANCELLED"] = "Cancelled";
      MeetingStatus22["RESCHEDULED"] = "Rescheduled";
      MeetingStatus22["ERRORED"] = "Errored";
      MeetingStatus22["MENTORCANCELLED"] = "MentorCancelled";
      MeetingStatus22["JOBSEEKERCANCELLED"] = "JobseekerCancelled";
      MeetingStatus22["ADMINCANCELLED"] = "AdminCancelled";
      MeetingStatus22["MENTORRESCHEDULED"] = "MentorRescheduled";
      MeetingStatus22["ADMINRESCHEDULED"] = "AdminRescheduled";
      MeetingStatus22["JOBSEEKERRESCHEDULED"] = "JobseekerRescheduled";
      MeetingStatus22["JOBSEEKERNOSHOW"] = "JobseekerNoShow";
      MeetingStatus22["MENTORNOSHOW"] = "MentorNoShow";
      MeetingStatus22["PENDING"] = "Pending";
      MeetingStatus22["PARTIALLYCOMPLETED"] = "PartiallyCompleted";
      MeetingStatus22["INVITED"] = "Invited";
      return MeetingStatus22;
    })(MeetingStatus3 || {});
    var MeetingSuccessStatus = /* @__PURE__ */ ((MeetingSuccessStatus2) => {
      MeetingSuccessStatus2["SUCCESSFUL"] = "Successful";
      MeetingSuccessStatus2["PARTIALLYSUCCESSFUL"] = "PartiallySuccessful";
      MeetingSuccessStatus2["UNSUCCESSFUL"] = "Unsuccessful";
      return MeetingSuccessStatus2;
    })(MeetingSuccessStatus || {});
    var MeetingType2 = /* @__PURE__ */ ((MeetingType22) => {
      MeetingType22["Interview"] = "Interview";
      MeetingType22["Assessment"] = "Assessment";
      return MeetingType22;
    })(MeetingType2 || {});
    var ProctoringStatus2 = /* @__PURE__ */ ((ProctoringStatus22) => {
      ProctoringStatus22["High"] = "High";
      ProctoringStatus22["Medium"] = "Medium";
      ProctoringStatus22["Low"] = "Low";
      ProctoringStatus22["Pending"] = "Pending";
      return ProctoringStatus22;
    })(ProctoringStatus2 || {});
    var MeetingJoineeStatus = /* @__PURE__ */ ((MeetingJoineeStatus2) => {
      MeetingJoineeStatus2["JOINED"] = "Joined";
      MeetingJoineeStatus2["LEFT"] = "Left";
      return MeetingJoineeStatus2;
    })(MeetingJoineeStatus || {});
    var RecordingStatus = /* @__PURE__ */ ((RecordingStatus2) => {
      RecordingStatus2["INPROGRESS"] = "InProgress";
      RecordingStatus2["UPLOADING"] = "Uploading";
      RecordingStatus2["COMPLETED"] = "Completed";
      return RecordingStatus2;
    })(RecordingStatus || {});
    var PrepPlanBadgeStatus = /* @__PURE__ */ ((PrepPlanBadgeStatus2) => {
      PrepPlanBadgeStatus2["COMPLETED"] = "completed";
      PrepPlanBadgeStatus2["IN_PROGRESS"] = "inProgress";
      PrepPlanBadgeStatus2["LOCKED"] = "locked";
      return PrepPlanBadgeStatus2;
    })(PrepPlanBadgeStatus || {});
    var AssessActivityType = /* @__PURE__ */ ((AssessActivityType2) => {
      AssessActivityType2["ShowSolution"] = "ShowSolution";
      AssessActivityType2["ShowHint"] = "ShowHint";
      AssessActivityType2["ShowHints"] = "ShowHints";
      AssessActivityType2["CodeRun"] = "CodeRun";
      return AssessActivityType2;
    })(AssessActivityType || {});
    var AttemptStatus = /* @__PURE__ */ ((AttemptStatus2) => {
      AttemptStatus2["ATTEMPTED"] = "ATTEMPTED";
      AttemptStatus2["NOT_ATTEMPTED"] = "NOT_ATTEMPTED";
      return AttemptStatus2;
    })(AttemptStatus || {});
    var QuestionDifficulty2 = /* @__PURE__ */ ((QuestionDifficulty22) => {
      QuestionDifficulty22["Easy"] = "Easy";
      QuestionDifficulty22["Medium"] = "Medium";
      QuestionDifficulty22["Hard"] = "Hard";
      return QuestionDifficulty22;
    })(QuestionDifficulty2 || {});
    var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
      PaymentStatus2["Requested"] = "Requested";
      PaymentStatus2["Success"] = "Success";
      PaymentStatus2["Failed"] = "Failed";
      return PaymentStatus2;
    })(PaymentStatus || {});
    var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
      PaymentType2["Jap"] = "Jap";
      PaymentType2["Map"] = "Map";
      PaymentType2["Plan"] = "Plan";
      PaymentType2["PrepPlanCompletion"] = "PrepPlanCompletion";
      PaymentType2["InterviewBooking"] = "InterviewBooking";
      PaymentType2["BenchmarkingTest"] = "BenchmarkingTest";
      PaymentType2["Drive"] = "Drive";
      PaymentType2["Assessment"] = "Assessment";
      return PaymentType2;
    })(PaymentType || {});
    var WhatsappMessageType = /* @__PURE__ */ ((WhatsappMessageType2) => {
      WhatsappMessageType2["MeetingReminder"] = "MeetingReminder";
      WhatsappMessageType2["ApplicationOpen"] = "ApplicationOpen";
      WhatsappMessageType2["ScreeningRoundCompletion"] = "ScreeningRoundCompletion";
      WhatsappMessageType2["MeetingScheduleAfterScreeningReminder"] = "MeetingScheduleAfterScreeningReminder";
      WhatsappMessageType2["JobSeekerGetsShortlisted"] = "JobSeekerGetsShortlisted";
      WhatsappMessageType2["JobSeekerGetsShortlistedAfterApplying"] = "JobSeekerGetsShortlistedAfterApplying";
      WhatsappMessageType2["JobSeekerMovedToNextRound"] = "JobSeekerMovedToNextRound";
      WhatsappMessageType2["JobSeekerMovedToLastRound"] = "JobSeekerMovedToLastRound";
      WhatsappMessageType2["AssignmentSentToJobSeeker"] = "AssignmentSentToJobSeeker";
      WhatsappMessageType2["CaseStudySentToJobSeeker"] = "CaseStudySentToJobSeeker";
      WhatsappMessageType2["InterviewSchdeuledWithJobSeeker"] = "InterviewSchdeuledWithJobSeeker";
      WhatsappMessageType2["MessageSentToJobSeeker"] = "MessageSentToJobSeeker";
      WhatsappMessageType2["OfferLetterSentToJobSeeker"] = "OfferLetterSentToJobSeeker";
      WhatsappMessageType2["NewOpportunityAlert"] = "NewOpportunityAlert";
      WhatsappMessageType2["PositionRecommendationAlert"] = "PositionRecommendationAlert";
      WhatsappMessageType2["NewPositionCreatedByAccountManager"] = "NewPositionCreatedByAccountManager";
      WhatsappMessageType2["TestBookingReminder"] = "TestBookingReminder";
      WhatsappMessageType2["SendOneDayTestRemainder"] = "SendOneDayTestRemainder";
      WhatsappMessageType2["SendThirtyMinutesBeforeOrAfterTestRemainder"] = "SendThirtyMinutesBeforeOrAfterTestRemainder";
      WhatsappMessageType2["SendCounsellingBookingRemainder"] = "SendCounsellingBookingRemainder";
      WhatsappMessageType2["SendTwentyMinutesCounsellingRemainder"] = "SendTwentyMinutesCounsellingRemainder";
      WhatsappMessageType2["ApplicationInactiveReminder"] = "ApplicationInactiveReminder";
      WhatsappMessageType2["ApplicationExpiryReminder"] = "ApplicationExpiryReminder";
      WhatsappMessageType2["ManualRecommendedWhatsappReminder"] = "ManualRecommendedWhatsappReminder";
      WhatsappMessageType2["CandidateRejected"] = "CandidateRejected";
      return WhatsappMessageType2;
    })(WhatsappMessageType || {});
    var SerriTemplateType = /* @__PURE__ */ ((SerriTemplateType2) => {
      SerriTemplateType2["NEW_POSITION_ALERT"] = "new_position_alert";
      SerriTemplateType2["APPLICATION_INACTIVE"] = "application_inactive";
      SerriTemplateType2["APPLICATION_EXPIRY"] = "application_expiry";
      SerriTemplateType2["SHORTLISTED_AFTER_APPLYING"] = "shortlisted_after_applying";
      SerriTemplateType2["ASSIGNMENT_SENT"] = "assignment_sent";
      SerriTemplateType2["CASE_STUDY_SENT"] = "case_study_sent";
      SerriTemplateType2["ONLINE_TEST_SENT"] = "online_test_sent";
      SerriTemplateType2["INTERVIEW_SCHEDULED"] = "interview_scheduled";
      SerriTemplateType2["CANDIDATE_REJECTED"] = "candidate_rejected";
      SerriTemplateType2["OFFER_ROLLED_OUT"] = "offer_rolled_out";
      return SerriTemplateType2;
    })(SerriTemplateType || {});
    var RewardActivityType = /* @__PURE__ */ ((RewardActivityType2) => {
      RewardActivityType2["Practice"] = "Practice";
      RewardActivityType2["Quiz"] = "Quiz";
      RewardActivityType2["Streak"] = "Streak";
      RewardActivityType2["Register"] = "Register";
      RewardActivityType2["ProfileCompletion"] = "ProfileCompletion";
      RewardActivityType2["FirstMeetingCompletion"] = "FirstMeetingCompletion";
      RewardActivityType2["RefereeFirstMeetingCompletion"] = "RefereeFirstMeetingCompletion";
      return RewardActivityType2;
    })(RewardActivityType || {});
    var RewardType = /* @__PURE__ */ ((RewardType2) => {
      RewardType2["Level"] = "Level";
      RewardType2["LevelCoin"] = "LevelCoin";
      return RewardType2;
    })(RewardType || {});
    var TrackingType = /* @__PURE__ */ ((TrackingType2) => {
      TrackingType2["FLYWHEEL_MAIL_SENT"] = "FLYWHEEL_MAIL_SENT";
      TrackingType2["FLYWHEEL_MAIL_OPENED"] = "FLYWHEEL_MAIL_OPENED";
      TrackingType2["FLYWHEEL_LEAD_LANDED_ON_BOOK_A_DEMO"] = "FLYWHEEL_LEAD_LANDED_ON_BOOK_A_DEMO";
      TrackingType2["FLYWHEEL_CLICKED_BOOK_A_DEMO"] = "FLYWHEEL_CLICKED_BOOK_A_DEMO";
      TrackingType2["FLYWHEEL_LEAD_LANDED_ON_SIGN_IN"] = "FLYWHEEL_LEAD_LANDED_ON_SIGN_IN";
      TrackingType2["RECEIVED_VALID_SCRAPED_LEADS"] = "RECEIVED_VALID_SCRAPED_LEADS";
      TrackingType2["CODE_BLACK_SCRAPE_POSITIONS"] = "CODE_BLACK_SCRAPE_POSITIONS";
      TrackingType2["RECRUITER_SIGNED_UP"] = "RECRUITER_SIGNED_UP";
      TrackingType2["USER_SIGNED_UP"] = "USER_SIGNED_UP";
      TrackingType2["USER_SIGNED_IN"] = "USER_SIGNED_IN";
      TrackingType2["USER_SIGN_IN"] = "USER_SIGN_IN";
      TrackingType2["POSITION_CREATED"] = "POSITION_CREATED";
      TrackingType2["COMPANY_ONBOARDED"] = "COMPANY_ONBOARDED";
      TrackingType2["CANDIDATE_REJECTED"] = "CANDIDATE_REJECTED";
      TrackingType2["RECRUITER_FETCHING_ACC_MANAGER_DETAILS"] = "RECRUITER_FETCHING_ACC_MANAGER_DETAILS";
      TrackingType2["ASSIGMENT_ROLLED_OUT"] = "ASSIGMENT_ROLLED_OUT";
      TrackingType2["OFFER_ROLLED_OUT"] = "OFFER_ROLLED_OUT";
      TrackingType2["INTERVIEW_SCHEDULED"] = "INTERVIEW_SCHEDULED";
      TrackingType2["DOWNLOAD_APPLICANT_DETAILS"] = "DOWNLOAD_APPLICANT_DETAILS";
      TrackingType2["REQUEST_MORE_PROFILES"] = "REQUEST_MORE_PROFILES";
      TrackingType2["CANDIDATE_MOVED_TO_APPLICANT"] = "CANDIDATE_MOVED_TO_APPLICANT";
      TrackingType2["CANDIDATES_PUSHED_IN_POSITION"] = "CANDIDATES_PUSHED_IN_POSITION";
      TrackingType2["CANDIDATE_APPLIED"] = "CANDIDATE_APPLIED";
      TrackingType2["CANDIDATE_SHORTLISTED"] = "CANDIDATE_SHORTLISTED";
      TrackingType2["CANDIDATE_ACCEPTED_OFFER"] = "CANDIDATE_ACCEPTED_OFFER";
      TrackingType2["ROUND_DEADLINE_EXTENDED"] = "ROUND_DEADLINE_EXTENDED";
      TrackingType2["CANDIDATE_NOT_INTERESTED"] = "CANDIDATE_NOT_INTERESTED";
      TrackingType2["CANDIDATE_OPTED_OUT"] = "CANDIDATE_OPTED_OUT";
      TrackingType2["ACTIVE_COMPANIES_ON_LEVELUP"] = "ACTIVE_COMPANIES_ON_LEVELUP";
      TrackingType2["ASSIGNMENT_APPROVED"] = "ASSIGNMENT_APPROVED";
      TrackingType2["SCHEDULED_HUMAN_INTERVIEW"] = "SCHEDULED_HUMAN_INTERVIEW";
      TrackingType2["SCHEDULED_AI_INTERVIEW"] = "SCHEDULED_AI_INTERVIEW";
      TrackingType2["STARTED_AI_INTERVIEW"] = "STARTED_AI_INTERVIEW";
      TrackingType2["STARTED_HUMAN_INTERVIEW"] = "STARTED_HUMAN_INTERVIEW";
      TrackingType2["COMPLETED_AI_INTERVIEW"] = "COMPLETED_AI_INTERVIEW";
      TrackingType2["COMPLETED_HUMAN_INTERVIEW"] = "COMPLETED_HUMAN_INTERVIEW";
      TrackingType2["QUALIFIED_FOR_MDP"] = "QUALIFIED_FOR_MDP";
      TrackingType2["VISITED_ALUM_PAGE"] = "VISITED_ALUM_PAGE";
      TrackingType2["OPENED_ALUM_DRAWER"] = "OPENED_ALUM_DRAWER";
      TrackingType2["SCHEDULED_ALUM_CONNECT"] = "SCHEDULED_ALUM_CONNECT";
      TrackingType2["MENTOR_CONNECT_SCHEDULED"] = "MENTOR_CONNECT_SCHEDULED";
      TrackingType2["MENTOR_CONNECT_COMPLETED"] = "MENTOR_CONNECT_COMPLETED";
      TrackingType2["COMPLETED_ALUM_CONNECT"] = "COMPLETED_ALUM_CONNECT";
      TrackingType2["VISITED_ONWARDS_JOBS_PAGE"] = "VISITED_ONWARDS_JOBS_PAGE";
      TrackingType2["CLICKED_TAKE_INTERVIEW_ONWARDS"] = "CLICKED_TAKE_INTERVIEW_ONWARDS";
      TrackingType2["BRIEF_DEBRIEF_CALL"] = "BRIEF_DEBRIEF_CALL";
      TrackingType2["CONTEST_PARTICIPATE"] = "CONTEST_PARTICIPATE";
      TrackingType2["CONTEST_REGISTERED"] = "CONTEST_REGISTERED";
      TrackingType2["CONTEST_VIEW_RESULTES"] = "CONTEST_VIEW_RESULTES";
      TrackingType2["OPENED_MENTOR_DRAWER"] = "OPENED_MENTOR_DRAWER";
      TrackingType2["CHALLENGE_STARTED"] = "CHALLENGE_STARTED";
      TrackingType2["CHALLENGE_QUESTION_COMPLETED"] = "CHALLENGE_QUESTION_COMPLETED";
      TrackingType2["CHALLENGE_QUESTION_SUBMITTED"] = "CHALLENGE_QUESTION_SUBMITTED";
      TrackingType2["USER_REGISTERED"] = "USER_REGISTERED";
      TrackingType2["RECRUITER_INVITED"] = "RECRUITER_INVITED";
      TrackingType2["RECRUITER_INVITED_ON_POSITION"] = "RECRUITER_INVITED_ON_POSITION";
      TrackingType2["CLICKED_BOOK_A_DEMO_SIGN_UP"] = "CLICKED_BOOK_A_DEMO_SIGN_UP";
      TrackingType2["FLYWHEEL_LANDED_ON_CANDIDATE_PROFILE_PAGE"] = "FLYWHEEL_LANDED_ON_CANDIDATE_PROFILE_PAGE";
      TrackingType2["FLYWHEEL_CLICKED_BOOK_A_DEMO_BANNER"] = "FLYWHEEL_CLICKED_BOOK_A_DEMO_BANNER";
      TrackingType2["FLYWHEEL_CLICKED_BOOK_A_DEMO_ON_MODAL"] = "FLYWHEEL_CLICKED_BOOK_A_DEMO_ON_MODAL";
      TrackingType2["FLYWHEEL_CLICKED_ON_VIEW_PROFILE"] = "FLYWHEEL_CLICKED_ON_VIEW_PROFILE";
      TrackingType2["FLYWHEEL_CLICKED_ON_SHORTLIST"] = "FLYWHEEL_CLICKED_ON_SHORTLIST";
      TrackingType2["FLYWHEEL_CLICKED_ON_JD"] = "FLYWHEEL_CLICKED_ON_JD";
      TrackingType2["SCHEDULED_ASSESSMENT"] = "SCHEDULED_ASSESSMENT";
      TrackingType2["STARTED_ASSESSMENT"] = "STARTED_ASSESSMENT";
      TrackingType2["RESET_LEVEL"] = "RESET_LEVEL";
      TrackingType2["COPY_HIRING_ASSESSMENT_LINK"] = "COPY_HIRING_ASSESSMENT_LINK";
      TrackingType2["COPY_HIRING_ASSESSMENT_MESSAGE"] = "COPY_HIRING_ASSESSMENT_MESSAGE";
      return TrackingType2;
    })(TrackingType || {});
    var UITrackingType = /* @__PURE__ */ ((UITrackingType2) => {
      UITrackingType2["COMPANY_ONBOARDED"] = "COMPANY_ONBOARDED";
      UITrackingType2["POSITION_CREATED"] = "POSITION_CREATED";
      UITrackingType2["RECRUITER_SIGNED_UP"] = "RECRUITER_SIGNED_UP";
      UITrackingType2["CANDIDATE_MOVED_TO_APPLICANT"] = "CANDIDATE_MOVED_TO_APPLICANT";
      UITrackingType2["CANDIDATES_PUSHED_IN_POSITION"] = "CANDIDATES_PUSHED_IN_POSITION";
      UITrackingType2["CANDIDATE_APPLIED"] = "CANDIDATE_APPLIED";
      UITrackingType2["CANDIDATE_SHORTLISTED"] = "CANDIDATE_SHORTLISTED";
      UITrackingType2["ACTIVE_COMPANIES_ON_LEVELUP"] = "ACTIVE_COMPANIES_ON_LEVELUP";
      UITrackingType2["CONTEST_PARTICIPATE"] = "CONTEST_PARTICIPATE";
      UITrackingType2["CONTEST_REGISTERED"] = "CONTEST_REGISTERED";
      UITrackingType2["CONTEST_VIEW_RESULTES"] = "CONTEST_VIEW_RESULTES";
      return UITrackingType2;
    })(UITrackingType || {});
    var TrackingContent = /* @__PURE__ */ ((TrackingContent2) => {
      TrackingContent2["CONTEST"] = "CONTEST";
      return TrackingContent2;
    })(TrackingContent || {});
    var SessionJoineeStatus = /* @__PURE__ */ ((SessionJoineeStatus2) => {
      SessionJoineeStatus2["JOINED"] = "Joined";
      SessionJoineeStatus2["LEFT"] = "Left";
      return SessionJoineeStatus2;
    })(SessionJoineeStatus || {});
    var SessionStatus3 = /* @__PURE__ */ ((SessionStatus22) => {
      SessionStatus22["SCHEDULED"] = "Scheduled";
      SessionStatus22["STARTED"] = "Started";
      SessionStatus22["COMPLETED"] = "Completed";
      SessionStatus22["CANCELLED"] = "Cancelled";
      SessionStatus22["RESCHEDULED"] = "Rescheduled";
      SessionStatus22["ERRORED"] = "Errored";
      SessionStatus22["MENTORCANCELLED"] = "HostCancelled";
      SessionStatus22["PARTICIPANTCANCELLED"] = "ParticipantCancelled";
      SessionStatus22["ADMINCANCELLED"] = "AdminCancelled";
      SessionStatus22["HOSTRESCHEDULED"] = "HostRescheduled";
      SessionStatus22["ADMINRESCHEDULED"] = "AdminRescheduled";
      SessionStatus22["PARTICIPANTRESCHEDULED"] = "ParticipantRescheduled";
      SessionStatus22["PARTICIPANTNOSHOW"] = "ParticipantNoShow";
      SessionStatus22["HOSTNOSHOW"] = "HostNoShow";
      return SessionStatus22;
    })(SessionStatus3 || {});
    var SessionSuccessStatus = /* @__PURE__ */ ((SessionSuccessStatus2) => {
      SessionSuccessStatus2["SUCCESSFUL"] = "Successful";
      SessionSuccessStatus2["PARTIALLYSUCCESSFUL"] = "PartiallySuccessful";
      SessionSuccessStatus2["UNSUCCESSFUL"] = "Unsuccessful";
      return SessionSuccessStatus2;
    })(SessionSuccessStatus || {});
    var SessionType = /* @__PURE__ */ ((SessionType2) => {
      SessionType2["MENTOR_SESSION"] = "Mentor_Session";
      SessionType2["ALUMNI_SESSION"] = "Alumni_Session";
      return SessionType2;
    })(SessionType || {});
    var SessionRecordingStatus = /* @__PURE__ */ ((SessionRecordingStatus2) => {
      SessionRecordingStatus2["INPROGRESS"] = "InProgress";
      SessionRecordingStatus2["UPLOADING"] = "Uploading";
      SessionRecordingStatus2["COMPLETED"] = "Completed";
      return SessionRecordingStatus2;
    })(SessionRecordingStatus || {});
    var ContestRewardTypes = /* @__PURE__ */ ((ContestRewardTypes2) => {
      ContestRewardTypes2["MONEY"] = "money";
      ContestRewardTypes2["LEVELUP_COINS"] = "levelup_coins";
      return ContestRewardTypes2;
    })(ContestRewardTypes || {});
    var ContestStatus = /* @__PURE__ */ ((ContestStatus2) => {
      ContestStatus2["REGISTERED"] = "registered";
      ContestStatus2["STARTED"] = "started";
      ContestStatus2["JOINED"] = "joined";
      ContestStatus2["ENDED"] = "ended";
      ContestStatus2["GRADED"] = "graded";
      return ContestStatus2;
    })(ContestStatus || {});
    var NbfcDetailStatus = /* @__PURE__ */ ((NbfcDetailStatus2) => {
      NbfcDetailStatus2["DISBURSAL_DONE"] = "disbursal-done";
      NbfcDetailStatus2["ADDED_TO_AUDIT"] = "added-to-audit";
      NbfcDetailStatus2["DISBURSAL_PENDING"] = "disbursal-pending";
      NbfcDetailStatus2["DISBURSAL_NOT_NEEDED"] = "disbursal-not-needed";
      NbfcDetailStatus2["STUDENT_NOT_COMPLYING"] = "student-not-complying";
      NbfcDetailStatus2["FORCLOSED"] = "forclosed";
      NbfcDetailStatus2["MORAT_DISBURSAL_PENDING"] = "morat-disbursal-pending";
      NbfcDetailStatus2["FORECLOSED_ADDED_TO_AUDIT"] = "foreclosed-added-to-audit";
      NbfcDetailStatus2["FORECLOSED_STUDENT_NOT_COMPLYING"] = "foreclosed-student-not-complying";
      NbfcDetailStatus2["FORECLOSED_MORAT_DISBURSAL_PENDING"] = "foreclosed-morat-disbursal-pending";
      NbfcDetailStatus2["DISBURSAL_DONE_CFRS"] = "disbursal-done-cfrs";
      return NbfcDetailStatus2;
    })(NbfcDetailStatus || {});
    var SlackWorkspaceType = /* @__PURE__ */ ((SlackWorkspaceType2) => {
      SlackWorkspaceType2["MASAI_SCHOOL"] = "MASAI_SCHOOL";
      SlackWorkspaceType2["PLACEMENT_MASTER"] = "PLACEMENT_MASTER";
      return SlackWorkspaceType2;
    })(SlackWorkspaceType || {});
    var SlackMessageHistoryStatusEnums = /* @__PURE__ */ ((SlackMessageHistoryStatusEnums2) => {
      SlackMessageHistoryStatusEnums2["SUCCESS"] = "success";
      SlackMessageHistoryStatusEnums2["FAILED"] = "failed";
      return SlackMessageHistoryStatusEnums2;
    })(SlackMessageHistoryStatusEnums || {});
    var SlackMessageHistoryErrorEnums = /* @__PURE__ */ ((SlackMessageHistoryErrorEnums2) => {
      SlackMessageHistoryErrorEnums2["DELETED"] = "Deleted";
      SlackMessageHistoryErrorEnums2["TIME_IN_PAST"] = "time_in_past";
      SlackMessageHistoryErrorEnums2["TIME_TOO_FAR"] = "time_too_far";
      SlackMessageHistoryErrorEnums2["ALREADY_SENT_IN_PAST"] = "already_sent_in_past";
      return SlackMessageHistoryErrorEnums2;
    })(SlackMessageHistoryErrorEnums || {});
    var SlackMessageTypeEnums = /* @__PURE__ */ ((SlackMessageTypeEnums2) => {
      SlackMessageTypeEnums2["SCHEDULE"] = "schedule";
      SlackMessageTypeEnums2["INSTANT"] = "instant";
      return SlackMessageTypeEnums2;
    })(SlackMessageTypeEnums || {});
    var SlackWorkspaceEnvironment = /* @__PURE__ */ ((SlackWorkspaceEnvironment2) => {
      SlackWorkspaceEnvironment2["DEVELOPMENT"] = "development";
      SlackWorkspaceEnvironment2["PRODUCTION"] = "production";
      return SlackWorkspaceEnvironment2;
    })(SlackWorkspaceEnvironment || {});
    var PIFReviewStatusType = /* @__PURE__ */ ((PIFReviewStatusType2) => {
      PIFReviewStatusType2["NotApproved"] = "NotApproved";
      PIFReviewStatusType2["Approved"] = "Approved";
      return PIFReviewStatusType2;
    })(PIFReviewStatusType || {});
    var CampusApplicationStatus = /* @__PURE__ */ ((CampusApplicationStatus2) => {
      CampusApplicationStatus2["SHORTLISTED"] = "shortlisted";
      CampusApplicationStatus2["REJECTED"] = "rejected";
      CampusApplicationStatus2["HIRED"] = "hired";
      return CampusApplicationStatus2;
    })(CampusApplicationStatus || {});
    var matchedPercentileType = /* @__PURE__ */ ((matchedPercentileType2) => {
      matchedPercentileType2["EXCELLENT"] = "excellent";
      matchedPercentileType2["GOOD"] = "good";
      matchedPercentileType2["MODERATE"] = "moderate";
      matchedPercentileType2["LOW"] = "low";
      return matchedPercentileType2;
    })(matchedPercentileType || {});
    var CampusRoundStatus = /* @__PURE__ */ ((CampusRoundStatus2) => {
      CampusRoundStatus2["STARTED"] = "started";
      CampusRoundStatus2["COMPLETED"] = "completed";
      CampusRoundStatus2["CLOSED"] = "closed";
      CampusRoundStatus2["CANCELLED"] = "cancelled";
      return CampusRoundStatus2;
    })(CampusRoundStatus || {});
    var CampusRoundType = /* @__PURE__ */ ((CampusRoundType2) => {
      CampusRoundType2["INTERVIEW"] = "interview";
      return CampusRoundType2;
    })(CampusRoundType || {});
    var OfflineDocumentsTypes = /* @__PURE__ */ ((OfflineDocumentsTypes2) => {
      OfflineDocumentsTypes2["AADHAR_CARD"] = "aadhar_card";
      OfflineDocumentsTypes2["LAPTOP"] = "laptop";
      OfflineDocumentsTypes2["RESUME"] = "resume";
      return OfflineDocumentsTypes2;
    })(OfflineDocumentsTypes || {});
    var DriveInviteeStatus = /* @__PURE__ */ ((DriveInviteeStatus2) => {
      DriveInviteeStatus2["PENDING"] = "pending";
      DriveInviteeStatus2["ACCEPT"] = "accept";
      DriveInviteeStatus2["REJECT"] = "reject";
      DriveInviteeStatus2["REGISTER"] = "register";
      return DriveInviteeStatus2;
    })(DriveInviteeStatus || {});
    var DriveRoundType = /* @__PURE__ */ ((DriveRoundType2) => {
      DriveRoundType2["ASSIGNMENT"] = "assignment";
      DriveRoundType2["INTERVIEW"] = "interview";
      DriveRoundType2["FINAL_ROUND"] = "final_round";
      return DriveRoundType2;
    })(DriveRoundType || {});
    var OfflineTechStackType = /* @__PURE__ */ ((OfflineTechStackType2) => {
      OfflineTechStackType2["FRONTEND"] = "Frontend";
      OfflineTechStackType2["BACKEND"] = "Backend";
      OfflineTechStackType2["FULLSTACK"] = "Fullstack";
      OfflineTechStackType2["QualityAnalysis"] = "Quality Analysis";
      OfflineTechStackType2["DataAnalysis"] = "Data Analysis";
      return OfflineTechStackType2;
    })(OfflineTechStackType || {});
    var JobseekerFormJobType = /* @__PURE__ */ ((JobseekerFormJobType2) => {
      JobseekerFormJobType2["TECH_JOBS"] = "Tech_Jobs";
      JobseekerFormJobType2["NON_TECH_JOBS"] = "Non_Tech_Jobs";
      return JobseekerFormJobType2;
    })(JobseekerFormJobType || {});
    var DriveInviteeType = /* @__PURE__ */ ((DriveInviteeType2) => {
      DriveInviteeType2["JOBSEEKER"] = "JobSeeker";
      DriveInviteeType2["RECRUITER"] = "Recruiter";
      DriveInviteeType2["COMPANY"] = "Company";
      return DriveInviteeType2;
    })(DriveInviteeType || {});
    var DriveInviteeApplicationStatus2 = /* @__PURE__ */ ((DriveInviteeApplicationStatus22) => {
      DriveInviteeApplicationStatus22["PENDING_PAYMENT"] = "pending_payment";
      DriveInviteeApplicationStatus22["PAYMENT_FAILED"] = "payment_failed";
      DriveInviteeApplicationStatus22["PAYMENT_SUCCESS"] = "payment_success";
      DriveInviteeApplicationStatus22["ASSESSMENT"] = "assessment";
      DriveInviteeApplicationStatus22["ASSESSMENT_PENDING_RESULTS"] = "assessment_pending_results";
      DriveInviteeApplicationStatus22["ASSESSMENT_FAILED"] = "assessment_failed";
      DriveInviteeApplicationStatus22["COUNSELLING"] = "counseling";
      DriveInviteeApplicationStatus22["COUNSELLING_PENDING_RESULTS"] = "counseling_pending_results";
      DriveInviteeApplicationStatus22["COUNSELLING_FAILED"] = "counseling_failed";
      DriveInviteeApplicationStatus22["PENDING_FINAL_PAYMENT"] = "pending_final_payment";
      DriveInviteeApplicationStatus22["FINAL_PAYMENT_FAILED"] = "final_payment_failed";
      DriveInviteeApplicationStatus22["ACCEPT"] = "accept";
      DriveInviteeApplicationStatus22["REJECT"] = "reject";
      return DriveInviteeApplicationStatus22;
    })(DriveInviteeApplicationStatus2 || {});
    var DriveInviteeTestStatusType = /* @__PURE__ */ ((DriveInviteeTestStatusType2) => {
      DriveInviteeTestStatusType2["PENDING"] = "PENDING";
      DriveInviteeTestStatusType2["COMPLETED"] = "COMPLETED";
      DriveInviteeTestStatusType2["ENDED"] = "ENDED";
      return DriveInviteeTestStatusType2;
    })(DriveInviteeTestStatusType || {});
    var OfflineDriveCandidateStatus = /* @__PURE__ */ ((OfflineDriveCandidateStatus2) => {
      OfflineDriveCandidateStatus2["ATTENDANCE_NOT_MARKED"] = "attendance_not_marked";
      OfflineDriveCandidateStatus2["BUSY"] = "busy";
      OfflineDriveCandidateStatus2["IDLE"] = "idle";
      OfflineDriveCandidateStatus2["HIRED"] = "hired";
      OfflineDriveCandidateStatus2["PRESENT"] = "present";
      OfflineDriveCandidateStatus2["ASSIGN"] = "assign";
      OfflineDriveCandidateStatus2["OUT_OF_DRIVE"] = "out_of_drive";
      return OfflineDriveCandidateStatus2;
    })(OfflineDriveCandidateStatus || {});
    var OFFLINE_DRIVE_CITY = /* @__PURE__ */ ((OFFLINE_DRIVE_CITY2) => {
      OFFLINE_DRIVE_CITY2["BANGALORE"] = "bangalore";
      OFFLINE_DRIVE_CITY2["MUMBAI"] = "mumbai";
      OFFLINE_DRIVE_CITY2["NEW_DELHI"] = "new-delhi";
      OFFLINE_DRIVE_CITY2["CHENNAI"] = "chennai";
      OFFLINE_DRIVE_CITY2["KOLKATA"] = "kolkata";
      OFFLINE_DRIVE_CITY2["HYDERABAD"] = "hyderabad";
      OFFLINE_DRIVE_CITY2["PUNE"] = "pune";
      OFFLINE_DRIVE_CITY2["CHANDIGARH"] = "chandigarh";
      OFFLINE_DRIVE_CITY2["NOIDA"] = "noida";
      OFFLINE_DRIVE_CITY2["GURGAON"] = "gurgaon";
      OFFLINE_DRIVE_CITY2["JAIPUR"] = "jaipur";
      OFFLINE_DRIVE_CITY2["DEHRADUN"] = "dehradun";
      OFFLINE_DRIVE_CITY2["DELHINCR"] = "delhincr";
      OFFLINE_DRIVE_CITY2["Hosur"] = "hosur";
      return OFFLINE_DRIVE_CITY2;
    })(OFFLINE_DRIVE_CITY || {});
    var Status = /* @__PURE__ */ ((Status2) => {
      Status2["New"] = "New";
      Status2["NotConnected"] = "Not Connected";
      Status2["DNP"] = "DNP";
      Status2["Positive"] = "Positive";
      Status2["FutureProspect"] = "Future Prospect";
      Status2["Qualified"] = "Qualified";
      Status2["Unqualified"] = "Unqualified";
      Status2["NotHiring"] = "Not Hiring";
      return Status2;
    })(Status || {});
    var CallLogsDispositions = /* @__PURE__ */ ((CallLogsDispositions2) => {
      CallLogsDispositions2["AllLeadsNewByDefault"] = "All leads new by default";
      CallLogsDispositions2["NoPOC"] = "No POC";
      CallLogsDispositions2["POCNumberNotFound"] = "POC Number not found";
      CallLogsDispositions2["NoIncoming"] = "No Incoming";
      CallLogsDispositions2["IncorrectNumber"] = "Incorrect Number";
      CallLogsDispositions2["NotRightPOC"] = "Not right POC";
      CallLogsDispositions2["DNP1"] = "DNP 1";
      CallLogsDispositions2["DNP2"] = "DNP 2";
      CallLogsDispositions2["Busy"] = "Busy";
      CallLogsDispositions2["Hiring"] = "Hiring";
      CallLogsDispositions2["NotHiring"] = "Not Hiring";
      CallLogsDispositions2["CallBackLater"] = "Call Back later";
      CallLogsDispositions2["WillDiscussAndBack"] = "Will discuss and back";
      CallLogsDispositions2["WillHireLater"] = "Will Hire Later";
      CallLogsDispositions2["PositionClosed"] = "Position Closed";
      CallLogsDispositions2["Qualified"] = "Qualified";
      CallLogsDispositions2["DNP3"] = "DNP 3";
      CallLogsDispositions2["NotHiringExternally"] = "Not Hiring Externally";
      CallLogsDispositions2["TechStackMismatch"] = "Tech Stack Mismatch";
      CallLogsDispositions2["Consultancy"] = "Consultancy";
      CallLogsDispositions2["LowCTC"] = "Low CTC";
      CallLogsDispositions2["ExperienceMismatch"] = "Experience Mismatch";
      CallLogsDispositions2["Employees1000Plus"] = "1000+ Employees";
      CallLogsDispositions2["JunkLead"] = "Junk Lead";
      return CallLogsDispositions2;
    })(CallLogsDispositions || {});
    var Source = /* @__PURE__ */ ((Source2) => {
      Source2["WebsiteGeneric"] = "Website Generic";
      Source2["JobPortals"] = "Job Portals";
      Source2["Referral"] = "Referral";
      Source2["MassMailers"] = "Mass Mailers";
      Source2["LinkedInAds"] = "LinkedIn Ads";
      Source2["InshortsAds"] = "Inshorts Ads";
      Source2["GoogleAds"] = "Google Ads";
      Source2["TalentCircle"] = "Talent Circle";
      Source2["OtherMarketingCampaigns"] = "Other Marketing Campaigns";
      Source2["Hubspot"] = "Hubspot";
      Source2["SelfSourced"] = "Self Sourced";
      return Source2;
    })(Source || {});
    var HighestQualification = /* @__PURE__ */ ((HighestQualification2) => {
      HighestQualification2["TWELVE_PASS_OR_DIPLOMA"] = "12th_pass_or_diploma";
      HighestQualification2["UNDERGRADUATE"] = "undergraduate";
      HighestQualification2["GRADUATE"] = "graduate";
      return HighestQualification2;
    })(HighestQualification || {});
    var SupportQuestionCategory = /* @__PURE__ */ ((SupportQuestionCategory2) => {
      SupportQuestionCategory2["GENERAL"] = "general";
      SupportQuestionCategory2["COMPANY"] = "company";
      return SupportQuestionCategory2;
    })(SupportQuestionCategory || {});
    var SupportTicketStatus = /* @__PURE__ */ ((SupportTicketStatus2) => {
      SupportTicketStatus2["OPEN"] = "open";
      SupportTicketStatus2["RESOLVED"] = "resolved";
      return SupportTicketStatus2;
    })(SupportTicketStatus || {});
    var EscalationLevel = /* @__PURE__ */ ((EscalationLevel2) => {
      EscalationLevel2["L1"] = "L1";
      EscalationLevel2["L2"] = "L2";
      EscalationLevel2["L3"] = "L3";
      EscalationLevel2["L4"] = "L4";
      return EscalationLevel2;
    })(EscalationLevel || {});
    var MessageSenderType = /* @__PURE__ */ ((MessageSenderType2) => {
      MessageSenderType2["USER"] = "user";
      MessageSenderType2["ASSIGN"] = "assign";
      MessageSenderType2["AGENT"] = "agent";
      MessageSenderType2["SYSTEM"] = "system";
      return MessageSenderType2;
    })(MessageSenderType || {});
    var VoteType = /* @__PURE__ */ ((VoteType2) => {
      VoteType2["UPVOTE"] = "upvote";
      VoteType2["DOWNVOTE"] = "downvote";
      return VoteType2;
    })(VoteType || {});
  }
});

// ../../node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var require_moment = __commonJS({
  "../../node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js"(exports, module2) {
    init_cjs_shims();
    (function(global, factory) {
      typeof exports === "object" && typeof module2 !== "undefined" ? module2.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global.moment = factory();
    })(exports, function() {
      "use strict";
      var hookCallback;
      function hooks() {
        return hookCallback.apply(null, arguments);
      }
      function setHookCallback(callback) {
        hookCallback = callback;
      }
      function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
      }
      function isObject(input) {
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
      }
      function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
      }
      function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
          return Object.getOwnPropertyNames(obj).length === 0;
        } else {
          var k;
          for (k in obj) {
            if (hasOwnProp(obj, k)) {
              return false;
            }
          }
          return true;
        }
      }
      function isUndefined(input) {
        return input === void 0;
      }
      function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
      }
      function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
      }
      function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
          res.push(fn(arr[i], i));
        }
        return res;
      }
      function extend(a, b) {
        for (var i in b) {
          if (hasOwnProp(b, i)) {
            a[i] = b[i];
          }
        }
        if (hasOwnProp(b, "toString")) {
          a.toString = b.toString;
        }
        if (hasOwnProp(b, "valueOf")) {
          a.valueOf = b.valueOf;
        }
        return a;
      }
      function createUTC(input, format2, locale2, strict) {
        return createLocalOrUTC(input, format2, locale2, strict, true).utc();
      }
      function defaultParsingFlags() {
        return {
          empty: false,
          unusedTokens: [],
          unusedInput: [],
          overflow: -2,
          charsLeftOver: 0,
          nullInput: false,
          invalidEra: null,
          invalidMonth: null,
          invalidFormat: false,
          userInvalidated: false,
          iso: false,
          parsedDateParts: [],
          era: null,
          meridiem: null,
          rfc2822: false,
          weekdayMismatch: false
        };
      }
      function getParsingFlags(m) {
        if (m._pf == null) {
          m._pf = defaultParsingFlags();
        }
        return m._pf;
      }
      var some;
      if (Array.prototype.some) {
        some = Array.prototype.some;
      } else {
        some = function(fun) {
          var t = Object(this), len = t.length >>> 0, i;
          for (i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
              return true;
            }
          }
          return false;
        };
      }
      function isValid(m) {
        if (m._isValid == null) {
          var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
            return i != null;
          }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
          if (m._strict) {
            isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
          }
          if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
          } else {
            return isNowValid;
          }
        }
        return m._isValid;
      }
      function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
          extend(getParsingFlags(m), flags);
        } else {
          getParsingFlags(m).userInvalidated = true;
        }
        return m;
      }
      var momentProperties = hooks.momentProperties = [], updateInProgress = false;
      function copyConfig(to2, from2) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from2._isAMomentObject)) {
          to2._isAMomentObject = from2._isAMomentObject;
        }
        if (!isUndefined(from2._i)) {
          to2._i = from2._i;
        }
        if (!isUndefined(from2._f)) {
          to2._f = from2._f;
        }
        if (!isUndefined(from2._l)) {
          to2._l = from2._l;
        }
        if (!isUndefined(from2._strict)) {
          to2._strict = from2._strict;
        }
        if (!isUndefined(from2._tzm)) {
          to2._tzm = from2._tzm;
        }
        if (!isUndefined(from2._isUTC)) {
          to2._isUTC = from2._isUTC;
        }
        if (!isUndefined(from2._offset)) {
          to2._offset = from2._offset;
        }
        if (!isUndefined(from2._pf)) {
          to2._pf = getParsingFlags(from2);
        }
        if (!isUndefined(from2._locale)) {
          to2._locale = from2._locale;
        }
        if (momentPropertiesLen > 0) {
          for (i = 0; i < momentPropertiesLen; i++) {
            prop = momentProperties[i];
            val = from2[prop];
            if (!isUndefined(val)) {
              to2[prop] = val;
            }
          }
        }
        return to2;
      }
      function Moment2(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
          this._d = new Date(NaN);
        }
        if (updateInProgress === false) {
          updateInProgress = true;
          hooks.updateOffset(this);
          updateInProgress = false;
        }
      }
      function isMoment(obj) {
        return obj instanceof Moment2 || obj != null && obj._isAMomentObject != null;
      }
      function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
          console.warn("Deprecation warning: " + msg);
        }
      }
      function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
          if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
          }
          if (firstTime) {
            var args = [], arg, i, key, argLen = arguments.length;
            for (i = 0; i < argLen; i++) {
              arg = "";
              if (typeof arguments[i] === "object") {
                arg += "\n[" + i + "] ";
                for (key in arguments[0]) {
                  if (hasOwnProp(arguments[0], key)) {
                    arg += key + ": " + arguments[0][key] + ", ";
                  }
                }
                arg = arg.slice(0, -2);
              } else {
                arg = arguments[i];
              }
              args.push(arg);
            }
            warn(
              msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
            );
            firstTime = false;
          }
          return fn.apply(this, arguments);
        }, fn);
      }
      var deprecations = {};
      function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
          warn(msg);
          deprecations[name] = true;
        }
      }
      hooks.suppressDeprecationWarnings = false;
      hooks.deprecationHandler = null;
      function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
      }
      function set(config) {
        var prop, i;
        for (i in config) {
          if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) {
              this[i] = prop;
            } else {
              this["_" + i] = prop;
            }
          }
        }
        this._config = config;
        this._dayOfMonthOrdinalParseLenient = new RegExp(
          (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
        );
      }
      function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
          if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
              res[prop] = {};
              extend(res[prop], parentConfig[prop]);
              extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
              res[prop] = childConfig[prop];
            } else {
              delete res[prop];
            }
          }
        }
        for (prop in parentConfig) {
          if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
            res[prop] = extend({}, res[prop]);
          }
        }
        return res;
      }
      function Locale(config) {
        if (config != null) {
          this.set(config);
        }
      }
      var keys;
      if (Object.keys) {
        keys = Object.keys;
      } else {
        keys = function(obj) {
          var i, res = [];
          for (i in obj) {
            if (hasOwnProp(obj, i)) {
              res.push(i);
            }
          }
          return res;
        };
      }
      var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      };
      function calendar(key, mom, now2) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now2) : output;
      }
      function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
        return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
      }
      var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
      function addFormatToken(token2, padded, ordinal2, callback) {
        var func = callback;
        if (typeof callback === "string") {
          func = function() {
            return this[callback]();
          };
        }
        if (token2) {
          formatTokenFunctions[token2] = func;
        }
        if (padded) {
          formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
          };
        }
        if (ordinal2) {
          formatTokenFunctions[ordinal2] = function() {
            return this.localeData().ordinal(
              func.apply(this, arguments),
              token2
            );
          };
        }
      }
      function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
          return input.replace(/^\[|\]$/g, "");
        }
        return input.replace(/\\/g, "");
      }
      function makeFormatFunction(format2) {
        var array = format2.match(formattingTokens), i, length;
        for (i = 0, length = array.length; i < length; i++) {
          if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
          } else {
            array[i] = removeFormattingTokens(array[i]);
          }
        }
        return function(mom) {
          var output = "", i2;
          for (i2 = 0; i2 < length; i2++) {
            output += isFunction(array[i2]) ? array[i2].call(mom, format2) : array[i2];
          }
          return output;
        };
      }
      function formatMoment(m, format2) {
        if (!m.isValid()) {
          return m.localeData().invalidDate();
        }
        format2 = expandFormat(format2, m.localeData());
        formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
        return formatFunctions[format2](m);
      }
      function expandFormat(format2, locale2) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
          return locale2.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format2)) {
          format2 = format2.replace(
            localFormattingTokens,
            replaceLongDateFormatTokens
          );
          localFormattingTokens.lastIndex = 0;
          i -= 1;
        }
        return format2;
      }
      var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
      };
      function longDateFormat(key) {
        var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format2 || !formatUpper) {
          return format2;
        }
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
          if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
            return tok.slice(1);
          }
          return tok;
        }).join("");
        return this._longDateFormat[key];
      }
      var defaultInvalidDate = "Invalid date";
      function invalidDate() {
        return this._invalidDate;
      }
      var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
      function ordinal(number) {
        return this._ordinal.replace("%d", number);
      }
      var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      };
      function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
      }
      function pastFuture(diff2, output) {
        var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
        return isFunction(format2) ? format2(output) : format2.replace(/%s/i, output);
      }
      var aliases = {};
      function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
      }
      function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
      }
      function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for (prop in inputObject) {
          if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
              normalizedInput[normalizedProp] = inputObject[prop];
            }
          }
        }
        return normalizedInput;
      }
      var priorities = {};
      function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
      }
      function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for (u in unitsObj) {
          if (hasOwnProp(unitsObj, u)) {
            units.push({ unit: u, priority: priorities[u] });
          }
        }
        units.sort(function(a, b) {
          return a.priority - b.priority;
        });
        return units;
      }
      function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }
      function absFloor(number) {
        if (number < 0) {
          return Math.ceil(number) || 0;
        } else {
          return Math.floor(number);
        }
      }
      function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
          value = absFloor(coercedNumber);
        }
        return value;
      }
      function makeGetSet(unit, keepTime) {
        return function(value) {
          if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
          } else {
            return get(this, unit);
          }
        };
      }
      function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
      }
      function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
          if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            value = toInt(value);
            mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
              value,
              mom.month(),
              daysInMonth(value, mom.month())
            );
          } else {
            mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
          }
        }
      }
      function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units]();
        }
        return this;
      }
      function stringSet(units, value) {
        if (typeof units === "object") {
          units = normalizeObjectUnits(units);
          var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
          for (i = 0; i < prioritizedLen; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
          }
        } else {
          units = normalizeUnits(units);
          if (isFunction(this[units])) {
            return this[units](value);
          }
        }
        return this;
      }
      var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
      regexes = {};
      function addRegexToken(token2, regex, strictRegex) {
        regexes[token2] = isFunction(regex) ? regex : function(isStrict, localeData2) {
          return isStrict && strictRegex ? strictRegex : regex;
        };
      }
      function getParseRegexForToken(token2, config) {
        if (!hasOwnProp(regexes, token2)) {
          return new RegExp(unescapeFormat(token2));
        }
        return regexes[token2](config._strict, config._locale);
      }
      function unescapeFormat(s) {
        return regexEscape(
          s.replace("\\", "").replace(
            /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
            function(matched, p1, p2, p3, p4) {
              return p1 || p2 || p3 || p4;
            }
          )
        );
      }
      function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      var tokens = {};
      function addParseToken(token2, callback) {
        var i, func = callback, tokenLen;
        if (typeof token2 === "string") {
          token2 = [token2];
        }
        if (isNumber(callback)) {
          func = function(input, array) {
            array[callback] = toInt(input);
          };
        }
        tokenLen = token2.length;
        for (i = 0; i < tokenLen; i++) {
          tokens[token2[i]] = func;
        }
      }
      function addWeekParseToken(token2, callback) {
        addParseToken(token2, function(input, array, config, token3) {
          config._w = config._w || {};
          callback(input, config._w, config, token3);
        });
      }
      function addTimeToArrayFromToken(token2, input, config) {
        if (input != null && hasOwnProp(tokens, token2)) {
          tokens[token2](input, config._a, config, token2);
        }
      }
      var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
      function mod(n, x) {
        return (n % x + x) % x;
      }
      var indexOf;
      if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
      } else {
        indexOf = function(o) {
          var i;
          for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
              return i;
            }
          }
          return -1;
        };
      }
      function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
          return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
      }
      addFormatToken("M", ["MM", 2], "Mo", function() {
        return this.month() + 1;
      });
      addFormatToken("MMM", 0, 0, function(format2) {
        return this.localeData().monthsShort(this, format2);
      });
      addFormatToken("MMMM", 0, 0, function(format2) {
        return this.localeData().months(this, format2);
      });
      addUnitAlias("month", "M");
      addUnitPriority("month", 8);
      addRegexToken("M", match1to2);
      addRegexToken("MM", match1to2, match2);
      addRegexToken("MMM", function(isStrict, locale2) {
        return locale2.monthsShortRegex(isStrict);
      });
      addRegexToken("MMMM", function(isStrict, locale2) {
        return locale2.monthsRegex(isStrict);
      });
      addParseToken(["M", "MM"], function(input, array) {
        array[MONTH] = toInt(input) - 1;
      });
      addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
        var month = config._locale.monthsParse(input, token2, config._strict);
        if (month != null) {
          array[MONTH] = month;
        } else {
          getParsingFlags(config).invalidMonth = input;
        }
      });
      var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
        "_"
      ), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
      function localeMonths(m, format2) {
        if (!m) {
          return isArray(this._months) ? this._months : this._months["standalone"];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
      }
      function localeMonthsShort(m, format2) {
        if (!m) {
          return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
      }
      function handleStrictParse(monthName, format2, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
          this._monthsParse = [];
          this._longMonthsParse = [];
          this._shortMonthsParse = [];
          for (i = 0; i < 12; ++i) {
            mom = createUTC([2e3, i]);
            this._shortMonthsParse[i] = this.monthsShort(
              mom,
              ""
            ).toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
          }
        }
        if (strict) {
          if (format2 === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
          }
        } else {
          if (format2 === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
          }
        }
      }
      function localeMonthsParse(monthName, format2, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) {
          return handleStrictParse.call(this, monthName, format2, strict);
        }
        if (!this._monthsParse) {
          this._monthsParse = [];
          this._longMonthsParse = [];
          this._shortMonthsParse = [];
        }
        for (i = 0; i < 12; i++) {
          mom = createUTC([2e3, i]);
          if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp(
              "^" + this.months(mom, "").replace(".", "") + "$",
              "i"
            );
            this._shortMonthsParse[i] = new RegExp(
              "^" + this.monthsShort(mom, "").replace(".", "") + "$",
              "i"
            );
          }
          if (!strict && !this._monthsParse[i]) {
            regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
            this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
          }
          if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
            return i;
          } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
            return i;
          } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
          }
        }
      }
      function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) {
          return mom;
        }
        if (typeof value === "string") {
          if (/^\d+$/.test(value)) {
            value = toInt(value);
          } else {
            value = mom.localeData().monthsParse(value);
            if (!isNumber(value)) {
              return mom;
            }
          }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
      }
      function getSetMonth(value) {
        if (value != null) {
          setMonth(this, value);
          hooks.updateOffset(this, true);
          return this;
        } else {
          return get(this, "Month");
        }
      }
      function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
      }
      function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
          if (!hasOwnProp(this, "_monthsRegex")) {
            computeMonthsParse.call(this);
          }
          if (isStrict) {
            return this._monthsShortStrictRegex;
          } else {
            return this._monthsShortRegex;
          }
        } else {
          if (!hasOwnProp(this, "_monthsShortRegex")) {
            this._monthsShortRegex = defaultMonthsShortRegex;
          }
          return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
      }
      function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
          if (!hasOwnProp(this, "_monthsRegex")) {
            computeMonthsParse.call(this);
          }
          if (isStrict) {
            return this._monthsStrictRegex;
          } else {
            return this._monthsRegex;
          }
        } else {
          if (!hasOwnProp(this, "_monthsRegex")) {
            this._monthsRegex = defaultMonthsRegex;
          }
          return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
      }
      function computeMonthsParse() {
        function cmpLenRev(a, b) {
          return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for (i = 0; i < 12; i++) {
          mom = createUTC([2e3, i]);
          shortPieces.push(this.monthsShort(mom, ""));
          longPieces.push(this.months(mom, ""));
          mixedPieces.push(this.months(mom, ""));
          mixedPieces.push(this.monthsShort(mom, ""));
        }
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
          shortPieces[i] = regexEscape(shortPieces[i]);
          longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
          mixedPieces[i] = regexEscape(mixedPieces[i]);
        }
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
          "^(" + longPieces.join("|") + ")",
          "i"
        );
        this._monthsShortStrictRegex = new RegExp(
          "^(" + shortPieces.join("|") + ")",
          "i"
        );
      }
      addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
      });
      addFormatToken(0, ["YY", 2], 0, function() {
        return this.year() % 100;
      });
      addFormatToken(0, ["YYYY", 4], 0, "year");
      addFormatToken(0, ["YYYYY", 5], 0, "year");
      addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
      addUnitAlias("year", "y");
      addUnitPriority("year", 1);
      addRegexToken("Y", matchSigned);
      addRegexToken("YY", match1to2, match2);
      addRegexToken("YYYY", match1to4, match4);
      addRegexToken("YYYYY", match1to6, match6);
      addRegexToken("YYYYYY", match1to6, match6);
      addParseToken(["YYYYY", "YYYYYY"], YEAR);
      addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
      });
      addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
      });
      addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
      });
      function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
      }
      hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
      };
      var getSetYear = makeGetSet("FullYear", true);
      function getIsLeapYear() {
        return isLeapYear(this.year());
      }
      function createDate(y, m, d, h, M, s, ms) {
        var date;
        if (y < 100 && y >= 0) {
          date = new Date(y + 400, m, d, h, M, s, ms);
          if (isFinite(date.getFullYear())) {
            date.setFullYear(y);
          }
        } else {
          date = new Date(y, m, d, h, M, s, ms);
        }
        return date;
      }
      function createUTCDate(y) {
        var date, args;
        if (y < 100 && y >= 0) {
          args = Array.prototype.slice.call(arguments);
          args[0] = y + 400;
          date = new Date(Date.UTC.apply(null, args));
          if (isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
          }
        } else {
          date = new Date(Date.UTC.apply(null, arguments));
        }
        return date;
      }
      function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
      }
      function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
          resYear = year - 1;
          resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
          resYear = year + 1;
          resDayOfYear = dayOfYear - daysInYear(year);
        } else {
          resYear = year;
          resDayOfYear = dayOfYear;
        }
        return {
          year: resYear,
          dayOfYear: resDayOfYear
        };
      }
      function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
          resYear = mom.year() - 1;
          resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
          resWeek = week - weeksInYear(mom.year(), dow, doy);
          resYear = mom.year() + 1;
        } else {
          resYear = mom.year();
          resWeek = week;
        }
        return {
          week: resWeek,
          year: resYear
        };
      }
      function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
      }
      addFormatToken("w", ["ww", 2], "wo", "week");
      addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
      addUnitAlias("week", "w");
      addUnitAlias("isoWeek", "W");
      addUnitPriority("week", 5);
      addUnitPriority("isoWeek", 5);
      addRegexToken("w", match1to2);
      addRegexToken("ww", match1to2, match2);
      addRegexToken("W", match1to2);
      addRegexToken("WW", match1to2, match2);
      addWeekParseToken(
        ["w", "ww", "W", "WW"],
        function(input, week, config, token2) {
          week[token2.substr(0, 1)] = toInt(input);
        }
      );
      function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
      }
      var defaultLocaleWeek = {
        dow: 0,
        doy: 6
      };
      function localeFirstDayOfWeek() {
        return this._week.dow;
      }
      function localeFirstDayOfYear() {
        return this._week.doy;
      }
      function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
      }
      function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
      }
      addFormatToken("d", 0, "do", "day");
      addFormatToken("dd", 0, 0, function(format2) {
        return this.localeData().weekdaysMin(this, format2);
      });
      addFormatToken("ddd", 0, 0, function(format2) {
        return this.localeData().weekdaysShort(this, format2);
      });
      addFormatToken("dddd", 0, 0, function(format2) {
        return this.localeData().weekdays(this, format2);
      });
      addFormatToken("e", 0, 0, "weekday");
      addFormatToken("E", 0, 0, "isoWeekday");
      addUnitAlias("day", "d");
      addUnitAlias("weekday", "e");
      addUnitAlias("isoWeekday", "E");
      addUnitPriority("day", 11);
      addUnitPriority("weekday", 11);
      addUnitPriority("isoWeekday", 11);
      addRegexToken("d", match1to2);
      addRegexToken("e", match1to2);
      addRegexToken("E", match1to2);
      addRegexToken("dd", function(isStrict, locale2) {
        return locale2.weekdaysMinRegex(isStrict);
      });
      addRegexToken("ddd", function(isStrict, locale2) {
        return locale2.weekdaysShortRegex(isStrict);
      });
      addRegexToken("dddd", function(isStrict, locale2) {
        return locale2.weekdaysRegex(isStrict);
      });
      addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
        var weekday = config._locale.weekdaysParse(input, token2, config._strict);
        if (weekday != null) {
          week.d = weekday;
        } else {
          getParsingFlags(config).invalidWeekday = input;
        }
      });
      addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
        week[token2] = toInt(input);
      });
      function parseWeekday(input, locale2) {
        if (typeof input !== "string") {
          return input;
        }
        if (!isNaN(input)) {
          return parseInt(input, 10);
        }
        input = locale2.weekdaysParse(input);
        if (typeof input === "number") {
          return input;
        }
        return null;
      }
      function parseIsoWeekday(input, locale2) {
        if (typeof input === "string") {
          return locale2.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
      }
      function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
      }
      var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
      function localeWeekdays(m, format2) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
      }
      function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
      }
      function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
      }
      function handleStrictParse$1(weekdayName, format2, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
          this._weekdaysParse = [];
          this._shortWeekdaysParse = [];
          this._minWeekdaysParse = [];
          for (i = 0; i < 7; ++i) {
            mom = createUTC([2e3, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(
              mom,
              ""
            ).toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(
              mom,
              ""
            ).toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
          }
        }
        if (strict) {
          if (format2 === "dddd") {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else if (format2 === "ddd") {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          }
        } else {
          if (format2 === "dddd") {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else if (format2 === "ddd") {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
              return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
          }
        }
      }
      function localeWeekdaysParse(weekdayName, format2, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) {
          return handleStrictParse$1.call(this, weekdayName, format2, strict);
        }
        if (!this._weekdaysParse) {
          this._weekdaysParse = [];
          this._minWeekdaysParse = [];
          this._shortWeekdaysParse = [];
          this._fullWeekdaysParse = [];
        }
        for (i = 0; i < 7; i++) {
          mom = createUTC([2e3, 1]).day(i);
          if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp(
              "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
              "i"
            );
            this._shortWeekdaysParse[i] = new RegExp(
              "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
              "i"
            );
            this._minWeekdaysParse[i] = new RegExp(
              "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
              "i"
            );
          }
          if (!this._weekdaysParse[i]) {
            regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
            this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
          }
          if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
          } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
          } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
          } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
          }
        }
      }
      function getSetDayOfWeek(input) {
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
          input = parseWeekday(input, this.localeData());
          return this.add(input - day, "d");
        } else {
          return day;
        }
      }
      function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
      }
      function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        if (input != null) {
          var weekday = parseIsoWeekday(input, this.localeData());
          return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
          return this.day() || 7;
        }
      }
      function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            computeWeekdaysParse.call(this);
          }
          if (isStrict) {
            return this._weekdaysStrictRegex;
          } else {
            return this._weekdaysRegex;
          }
        } else {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            this._weekdaysRegex = defaultWeekdaysRegex;
          }
          return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
      }
      function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            computeWeekdaysParse.call(this);
          }
          if (isStrict) {
            return this._weekdaysShortStrictRegex;
          } else {
            return this._weekdaysShortRegex;
          }
        } else {
          if (!hasOwnProp(this, "_weekdaysShortRegex")) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
          }
          return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
      }
      function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
          if (!hasOwnProp(this, "_weekdaysRegex")) {
            computeWeekdaysParse.call(this);
          }
          if (isStrict) {
            return this._weekdaysMinStrictRegex;
          } else {
            return this._weekdaysMinRegex;
          }
        } else {
          if (!hasOwnProp(this, "_weekdaysMinRegex")) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
          }
          return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
      }
      function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
          return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
          mom = createUTC([2e3, 1]).day(i);
          minp = regexEscape(this.weekdaysMin(mom, ""));
          shortp = regexEscape(this.weekdaysShort(mom, ""));
          longp = regexEscape(this.weekdays(mom, ""));
          minPieces.push(minp);
          shortPieces.push(shortp);
          longPieces.push(longp);
          mixedPieces.push(minp);
          mixedPieces.push(shortp);
          mixedPieces.push(longp);
        }
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp(
          "^(" + longPieces.join("|") + ")",
          "i"
        );
        this._weekdaysShortStrictRegex = new RegExp(
          "^(" + shortPieces.join("|") + ")",
          "i"
        );
        this._weekdaysMinStrictRegex = new RegExp(
          "^(" + minPieces.join("|") + ")",
          "i"
        );
      }
      function hFormat() {
        return this.hours() % 12 || 12;
      }
      function kFormat() {
        return this.hours() || 24;
      }
      addFormatToken("H", ["HH", 2], 0, "hour");
      addFormatToken("h", ["hh", 2], 0, hFormat);
      addFormatToken("k", ["kk", 2], 0, kFormat);
      addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
      });
      addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
      });
      addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
      });
      addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
      });
      function meridiem(token2, lowercase) {
        addFormatToken(token2, 0, 0, function() {
          return this.localeData().meridiem(
            this.hours(),
            this.minutes(),
            lowercase
          );
        });
      }
      meridiem("a", true);
      meridiem("A", false);
      addUnitAlias("hour", "h");
      addUnitPriority("hour", 13);
      function matchMeridiem(isStrict, locale2) {
        return locale2._meridiemParse;
      }
      addRegexToken("a", matchMeridiem);
      addRegexToken("A", matchMeridiem);
      addRegexToken("H", match1to2);
      addRegexToken("h", match1to2);
      addRegexToken("k", match1to2);
      addRegexToken("HH", match1to2, match2);
      addRegexToken("hh", match1to2, match2);
      addRegexToken("kk", match1to2, match2);
      addRegexToken("hmm", match3to4);
      addRegexToken("hmmss", match5to6);
      addRegexToken("Hmm", match3to4);
      addRegexToken("Hmmss", match5to6);
      addParseToken(["H", "HH"], HOUR);
      addParseToken(["k", "kk"], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
      });
      addParseToken(["a", "A"], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
      });
      addParseToken(["h", "hh"], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
      });
      addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
      });
      addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
      });
      addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
      });
      addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
      });
      function localeIsPM(input) {
        return (input + "").toLowerCase().charAt(0) === "p";
      }
      var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
      function localeMeridiem(hours2, minutes2, isLower) {
        if (hours2 > 11) {
          return isLower ? "pm" : "PM";
        } else {
          return isLower ? "am" : "AM";
        }
      }
      var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
      };
      var locales = {}, localeFamilies = {}, globalLocale;
      function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
          if (arr1[i] !== arr2[i]) {
            return i;
          }
        }
        return minl;
      }
      function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
      }
      function chooseLocale(names) {
        var i = 0, j, next, locale2, split;
        while (i < names.length) {
          split = normalizeLocale(names[i]).split("-");
          j = split.length;
          next = normalizeLocale(names[i + 1]);
          next = next ? next.split("-") : null;
          while (j > 0) {
            locale2 = loadLocale(split.slice(0, j).join("-"));
            if (locale2) {
              return locale2;
            }
            if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
              break;
            }
            j--;
          }
          i++;
        }
        return globalLocale;
      }
      function isLocaleNameSane(name) {
        return name.match("^[^/\\\\]*$") != null;
      }
      function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        if (locales[name] === void 0 && typeof module2 !== "undefined" && module2 && module2.exports && isLocaleNameSane(name)) {
          try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = require;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
          } catch (e) {
            locales[name] = null;
          }
        }
        return locales[name];
      }
      function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
          if (isUndefined(values)) {
            data = getLocale(key);
          } else {
            data = defineLocale(key, values);
          }
          if (data) {
            globalLocale = data;
          } else {
            if (typeof console !== "undefined" && console.warn) {
              console.warn(
                "Locale " + key + " not found. Did you forget to load it?"
              );
            }
          }
        }
        return globalLocale._abbr;
      }
      function defineLocale(name, config) {
        if (config !== null) {
          var locale2, parentConfig = baseConfig;
          config.abbr = name;
          if (locales[name] != null) {
            deprecateSimple(
              "defineLocaleOverride",
              "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
            );
            parentConfig = locales[name]._config;
          } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
              parentConfig = locales[config.parentLocale]._config;
            } else {
              locale2 = loadLocale(config.parentLocale);
              if (locale2 != null) {
                parentConfig = locale2._config;
              } else {
                if (!localeFamilies[config.parentLocale]) {
                  localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                  name,
                  config
                });
                return null;
              }
            }
          }
          locales[name] = new Locale(mergeConfigs(parentConfig, config));
          if (localeFamilies[name]) {
            localeFamilies[name].forEach(function(x) {
              defineLocale(x.name, x.config);
            });
          }
          getSetGlobalLocale(name);
          return locales[name];
        } else {
          delete locales[name];
          return null;
        }
      }
      function updateLocale(name, config) {
        if (config != null) {
          var locale2, tmpLocale, parentConfig = baseConfig;
          if (locales[name] != null && locales[name].parentLocale != null) {
            locales[name].set(mergeConfigs(locales[name]._config, config));
          } else {
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
              parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            if (tmpLocale == null) {
              config.abbr = name;
            }
            locale2 = new Locale(config);
            locale2.parentLocale = locales[name];
            locales[name] = locale2;
          }
          getSetGlobalLocale(name);
        } else {
          if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
              locales[name] = locales[name].parentLocale;
              if (name === getSetGlobalLocale()) {
                getSetGlobalLocale(name);
              }
            } else if (locales[name] != null) {
              delete locales[name];
            }
          }
        }
        return locales[name];
      }
      function getLocale(key) {
        var locale2;
        if (key && key._locale && key._locale._abbr) {
          key = key._locale._abbr;
        }
        if (!key) {
          return globalLocale;
        }
        if (!isArray(key)) {
          locale2 = loadLocale(key);
          if (locale2) {
            return locale2;
          }
          key = [key];
        }
        return chooseLocale(key);
      }
      function listLocales() {
        return keys(locales);
      }
      function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
          overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
          if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
          }
          if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
          }
          if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
          }
          getParsingFlags(m).overflow = overflow;
        }
        return m;
      }
      var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
        ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
        ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
        ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
        ["YYYY-DDD", /\d{4}-\d{3}/],
        ["YYYY-MM", /\d{4}-\d\d/, false],
        ["YYYYYYMMDD", /[+-]\d{10}/],
        ["YYYYMMDD", /\d{8}/],
        ["GGGG[W]WWE", /\d{4}W\d{3}/],
        ["GGGG[W]WW", /\d{4}W\d{2}/, false],
        ["YYYYDDD", /\d{7}/],
        ["YYYYMM", /\d{6}/, false],
        ["YYYY", /\d{4}/, false]
      ], isoTimes = [
        ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
        ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
        ["HH:mm:ss", /\d\d:\d\d:\d\d/],
        ["HH:mm", /\d\d:\d\d/],
        ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
        ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
        ["HHmmss", /\d\d\d\d\d\d/],
        ["HHmm", /\d\d\d\d/],
        ["HH", /\d\d/]
      ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
      function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
          getParsingFlags(config).iso = true;
          for (i = 0, l = isoDatesLen; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
              dateFormat = isoDates[i][0];
              allowTime = isoDates[i][2] !== false;
              break;
            }
          }
          if (dateFormat == null) {
            config._isValid = false;
            return;
          }
          if (match[3]) {
            for (i = 0, l = isoTimesLen; i < l; i++) {
              if (isoTimes[i][1].exec(match[3])) {
                timeFormat = (match[2] || " ") + isoTimes[i][0];
                break;
              }
            }
            if (timeFormat == null) {
              config._isValid = false;
              return;
            }
          }
          if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
          }
          if (match[4]) {
            if (tzRegex.exec(match[4])) {
              tzFormat = "Z";
            } else {
              config._isValid = false;
              return;
            }
          }
          config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
          configFromStringAndFormat(config);
        } else {
          config._isValid = false;
        }
      }
      function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
          untruncateYear(yearStr),
          defaultLocaleMonthsShort.indexOf(monthStr),
          parseInt(dayStr, 10),
          parseInt(hourStr, 10),
          parseInt(minuteStr, 10)
        ];
        if (secondStr) {
          result.push(parseInt(secondStr, 10));
        }
        return result;
      }
      function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
          return 2e3 + year;
        } else if (year <= 999) {
          return 1900 + year;
        }
        return year;
      }
      function preprocessRFC2822(s) {
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
      }
      function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
          var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
            parsedInput[0],
            parsedInput[1],
            parsedInput[2]
          ).getDay();
          if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
          }
        }
        return true;
      }
      function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
          return obsOffsets[obsOffset];
        } else if (militaryOffset) {
          return 0;
        } else {
          var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
          return h * 60 + m;
        }
      }
      function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
          parsedArray = extractFromRFC2822Strings(
            match[4],
            match[3],
            match[2],
            match[5],
            match[6],
            match[7]
          );
          if (!checkWeekday(match[1], parsedArray, config)) {
            return;
          }
          config._a = parsedArray;
          config._tzm = calculateOffset(match[8], match[9], match[10]);
          config._d = createUTCDate.apply(null, config._a);
          config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
          getParsingFlags(config).rfc2822 = true;
        } else {
          config._isValid = false;
        }
      }
      function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
          config._d = new Date(+matched[1]);
          return;
        }
        configFromISO(config);
        if (config._isValid === false) {
          delete config._isValid;
        } else {
          return;
        }
        configFromRFC2822(config);
        if (config._isValid === false) {
          delete config._isValid;
        } else {
          return;
        }
        if (config._strict) {
          config._isValid = false;
        } else {
          hooks.createFromInputFallback(config);
        }
      }
      hooks.createFromInputFallback = deprecate(
        "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
        function(config) {
          config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
        }
      );
      function defaults(a, b, c) {
        if (a != null) {
          return a;
        }
        if (b != null) {
          return b;
        }
        return c;
      }
      function currentDateArray(config) {
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
          return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
          ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
      }
      function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) {
          return;
        }
        currentDate = currentDateArray(config);
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
          dayOfYearFromWeekInfo(config);
        }
        if (config._dayOfYear != null) {
          yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
          if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
          }
          date = createUTCDate(yearToUse, 0, config._dayOfYear);
          config._a[MONTH] = date.getUTCMonth();
          config._a[DATE] = date.getUTCDate();
        }
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
          config._a[i] = input[i] = currentDate[i];
        }
        for (; i < 7; i++) {
          config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
          config._nextDay = true;
          config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(
          null,
          input
        );
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        if (config._tzm != null) {
          config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }
        if (config._nextDay) {
          config._a[HOUR] = 24;
        }
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
          getParsingFlags(config).weekdayMismatch = true;
        }
      }
      function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
          dow = 1;
          doy = 4;
          weekYear = defaults(
            w.GG,
            config._a[YEAR],
            weekOfYear(createLocal(), 1, 4).year
          );
          week = defaults(w.W, 1);
          weekday = defaults(w.E, 1);
          if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
          }
        } else {
          dow = config._locale._week.dow;
          doy = config._locale._week.doy;
          curWeek = weekOfYear(createLocal(), dow, doy);
          weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
          week = defaults(w.w, curWeek.week);
          if (w.d != null) {
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
              weekdayOverflow = true;
            }
          } else if (w.e != null) {
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
              weekdayOverflow = true;
            }
          } else {
            weekday = dow;
          }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
          getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
          getParsingFlags(config)._overflowWeekday = true;
        } else {
          temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
          config._a[YEAR] = temp.year;
          config._dayOfYear = temp.dayOfYear;
        }
      }
      hooks.ISO_8601 = function() {
      };
      hooks.RFC_2822 = function() {
      };
      function configFromStringAndFormat(config) {
        if (config._f === hooks.ISO_8601) {
          configFromISO(config);
          return;
        }
        if (config._f === hooks.RFC_2822) {
          configFromRFC2822(config);
          return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens2.length;
        for (i = 0; i < tokenLen; i++) {
          token2 = tokens2[i];
          parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
          if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
              getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(
              string.indexOf(parsedInput) + parsedInput.length
            );
            totalParsedInputLength += parsedInput.length;
          }
          if (formatTokenFunctions[token2]) {
            if (parsedInput) {
              getParsingFlags(config).empty = false;
            } else {
              getParsingFlags(config).unusedTokens.push(token2);
            }
            addTimeToArrayFromToken(token2, parsedInput, config);
          } else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token2);
          }
        }
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
          getParsingFlags(config).unusedInput.push(string);
        }
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
          getParsingFlags(config).bigHour = void 0;
        }
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        config._a[HOUR] = meridiemFixWrap(
          config._locale,
          config._a[HOUR],
          config._meridiem
        );
        era = getParsingFlags(config).era;
        if (era !== null) {
          config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }
        configFromArray(config);
        checkOverflow(config);
      }
      function meridiemFixWrap(locale2, hour, meridiem2) {
        var isPm;
        if (meridiem2 == null) {
          return hour;
        }
        if (locale2.meridiemHour != null) {
          return locale2.meridiemHour(hour, meridiem2);
        } else if (locale2.isPM != null) {
          isPm = locale2.isPM(meridiem2);
          if (isPm && hour < 12) {
            hour += 12;
          }
          if (!isPm && hour === 12) {
            hour = 0;
          }
          return hour;
        } else {
          return hour;
        }
      }
      function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
          getParsingFlags(config).invalidFormat = true;
          config._d = new Date(NaN);
          return;
        }
        for (i = 0; i < configfLen; i++) {
          currentScore = 0;
          validFormatFound = false;
          tempConfig = copyConfig({}, config);
          if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
          }
          tempConfig._f = config._f[i];
          configFromStringAndFormat(tempConfig);
          if (isValid(tempConfig)) {
            validFormatFound = true;
          }
          currentScore += getParsingFlags(tempConfig).charsLeftOver;
          currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
          getParsingFlags(tempConfig).score = currentScore;
          if (!bestFormatIsValid) {
            if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
              scoreToBeat = currentScore;
              bestMoment = tempConfig;
              if (validFormatFound) {
                bestFormatIsValid = true;
              }
            }
          } else {
            if (currentScore < scoreToBeat) {
              scoreToBeat = currentScore;
              bestMoment = tempConfig;
            }
          }
        }
        extend(config, bestMoment || tempConfig);
      }
      function configFromObject(config) {
        if (config._d) {
          return;
        }
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
        config._a = map(
          [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
          function(obj) {
            return obj && parseInt(obj, 10);
          }
        );
        configFromArray(config);
      }
      function createFromConfig(config) {
        var res = new Moment2(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
          res.add(1, "d");
          res._nextDay = void 0;
        }
        return res;
      }
      function prepareConfig(config) {
        var input = config._i, format2 = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format2 === void 0 && input === "") {
          return createInvalid({ nullInput: true });
        }
        if (typeof input === "string") {
          config._i = input = config._locale.preparse(input);
        }
        if (isMoment(input)) {
          return new Moment2(checkOverflow(input));
        } else if (isDate(input)) {
          config._d = input;
        } else if (isArray(format2)) {
          configFromStringAndArray(config);
        } else if (format2) {
          configFromStringAndFormat(config);
        } else {
          configFromInput(config);
        }
        if (!isValid(config)) {
          config._d = null;
        }
        return config;
      }
      function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
          config._d = new Date(hooks.now());
        } else if (isDate(input)) {
          config._d = new Date(input.valueOf());
        } else if (typeof input === "string") {
          configFromString(config);
        } else if (isArray(input)) {
          config._a = map(input.slice(0), function(obj) {
            return parseInt(obj, 10);
          });
          configFromArray(config);
        } else if (isObject(input)) {
          configFromObject(config);
        } else if (isNumber(input)) {
          config._d = new Date(input);
        } else {
          hooks.createFromInputFallback(config);
        }
      }
      function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
        var c = {};
        if (format2 === true || format2 === false) {
          strict = format2;
          format2 = void 0;
        }
        if (locale2 === true || locale2 === false) {
          strict = locale2;
          locale2 = void 0;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
          input = void 0;
        }
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale2;
        c._i = input;
        c._f = format2;
        c._strict = strict;
        return createFromConfig(c);
      }
      function createLocal(input, format2, locale2, strict) {
        return createLocalOrUTC(input, format2, locale2, strict, false);
      }
      var prototypeMin = deprecate(
        "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
        function() {
          var other = createLocal.apply(null, arguments);
          if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
          } else {
            return createInvalid();
          }
        }
      ), prototypeMax = deprecate(
        "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
        function() {
          var other = createLocal.apply(null, arguments);
          if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
          } else {
            return createInvalid();
          }
        }
      );
      function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
          moments = moments[0];
        }
        if (!moments.length) {
          return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
          if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
          }
        }
        return res;
      }
      function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
      }
      function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
      }
      var now = function() {
        return Date.now ? Date.now() : +new Date();
      };
      var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
      ];
      function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for (key in m) {
          if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
          }
        }
        for (i = 0; i < orderLen; ++i) {
          if (m[ordering[i]]) {
            if (unitHasDecimal) {
              return false;
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
              unitHasDecimal = true;
            }
          }
        }
        return true;
      }
      function isValid$1() {
        return this._isValid;
      }
      function createInvalid$1() {
        return createDuration(NaN);
      }
      function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        this._milliseconds = +milliseconds2 + seconds2 * 1e3 + minutes2 * 6e4 + hours2 * 1e3 * 60 * 60;
        this._days = +days2 + weeks2 * 7;
        this._months = +months2 + quarters * 3 + years2 * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
      }
      function isDuration(obj) {
        return obj instanceof Duration;
      }
      function absRound(number) {
        if (number < 0) {
          return Math.round(-1 * number) * -1;
        } else {
          return Math.round(number);
        }
      }
      function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for (i = 0; i < len; i++) {
          if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
            diffs++;
          }
        }
        return diffs + lengthDiff;
      }
      function offset(token2, separator) {
        addFormatToken(token2, 0, 0, function() {
          var offset2 = this.utcOffset(), sign2 = "+";
          if (offset2 < 0) {
            offset2 = -offset2;
            sign2 = "-";
          }
          return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
        });
      }
      offset("Z", ":");
      offset("ZZ", "");
      addRegexToken("Z", matchShortOffset);
      addRegexToken("ZZ", matchShortOffset);
      addParseToken(["Z", "ZZ"], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
      });
      var chunkOffset = /([\+\-]|\d\d)/gi;
      function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes2;
        if (matches === null) {
          return null;
        }
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
        minutes2 = +(parts[1] * 60) + toInt(parts[2]);
        return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
      }
      function cloneWithOffset(input, model) {
        var res, diff2;
        if (model._isUTC) {
          res = model.clone();
          diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
          res._d.setTime(res._d.valueOf() + diff2);
          hooks.updateOffset(res, false);
          return res;
        } else {
          return createLocal(input).local();
        }
      }
      function getDateOffset(m) {
        return -Math.round(m._d.getTimezoneOffset());
      }
      hooks.updateOffset = function() {
      };
      function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset2 = this._offset || 0, localAdjust;
        if (!this.isValid()) {
          return input != null ? this : NaN;
        }
        if (input != null) {
          if (typeof input === "string") {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
              return this;
            }
          } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
          }
          if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
          }
          this._offset = input;
          this._isUTC = true;
          if (localAdjust != null) {
            this.add(localAdjust, "m");
          }
          if (offset2 !== input) {
            if (!keepLocalTime || this._changeInProgress) {
              addSubtract(
                this,
                createDuration(input - offset2, "m"),
                1,
                false
              );
            } else if (!this._changeInProgress) {
              this._changeInProgress = true;
              hooks.updateOffset(this, true);
              this._changeInProgress = null;
            }
          }
          return this;
        } else {
          return this._isUTC ? offset2 : getDateOffset(this);
        }
      }
      function getSetZone(input, keepLocalTime) {
        if (input != null) {
          if (typeof input !== "string") {
            input = -input;
          }
          this.utcOffset(input, keepLocalTime);
          return this;
        } else {
          return -this.utcOffset();
        }
      }
      function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
      }
      function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
          this.utcOffset(0, keepLocalTime);
          this._isUTC = false;
          if (keepLocalTime) {
            this.subtract(getDateOffset(this), "m");
          }
        }
        return this;
      }
      function setOffsetToParsedOffset() {
        if (this._tzm != null) {
          this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === "string") {
          var tZone = offsetFromString(matchOffset, this._i);
          if (tZone != null) {
            this.utcOffset(tZone);
          } else {
            this.utcOffset(0, true);
          }
        }
        return this;
      }
      function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
          return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
      }
      function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
      }
      function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
          return this._isDSTShifted;
        }
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
          other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
          this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
          this._isDSTShifted = false;
        }
        return this._isDSTShifted;
      }
      function isLocal() {
        return this.isValid() ? !this._isUTC : false;
      }
      function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
      }
      function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
      }
      var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
      function createDuration(input, key) {
        var duration = input, match = null, sign2, ret, diffRes;
        if (isDuration(input)) {
          duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
          };
        } else if (isNumber(input) || !isNaN(+input)) {
          duration = {};
          if (key) {
            duration[key] = +input;
          } else {
            duration.milliseconds = +input;
          }
        } else if (match = aspNetRegex.exec(input)) {
          sign2 = match[1] === "-" ? -1 : 1;
          duration = {
            y: 0,
            d: toInt(match[DATE]) * sign2,
            h: toInt(match[HOUR]) * sign2,
            m: toInt(match[MINUTE]) * sign2,
            s: toInt(match[SECOND]) * sign2,
            ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
          };
        } else if (match = isoRegex.exec(input)) {
          sign2 = match[1] === "-" ? -1 : 1;
          duration = {
            y: parseIso(match[2], sign2),
            M: parseIso(match[3], sign2),
            w: parseIso(match[4], sign2),
            d: parseIso(match[5], sign2),
            h: parseIso(match[6], sign2),
            m: parseIso(match[7], sign2),
            s: parseIso(match[8], sign2)
          };
        } else if (duration == null) {
          duration = {};
        } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
          diffRes = momentsDifference(
            createLocal(duration.from),
            createLocal(duration.to)
          );
          duration = {};
          duration.ms = diffRes.milliseconds;
          duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) {
          ret._locale = input._locale;
        }
        if (isDuration(input) && hasOwnProp(input, "_isValid")) {
          ret._isValid = input._isValid;
        }
        return ret;
      }
      createDuration.fn = Duration.prototype;
      createDuration.invalid = createInvalid$1;
      function parseIso(inp, sign2) {
        var res = inp && parseFloat(inp.replace(",", "."));
        return (isNaN(res) ? 0 : res) * sign2;
      }
      function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) {
          --res.months;
        }
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
      }
      function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
          return { milliseconds: 0, months: 0 };
        }
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
          res = positiveMomentsDifference(base, other);
        } else {
          res = positiveMomentsDifference(other, base);
          res.milliseconds = -res.milliseconds;
          res.months = -res.months;
        }
        return res;
      }
      function createAdder(direction, name) {
        return function(val, period) {
          var dur, tmp;
          if (period !== null && !isNaN(+period)) {
            deprecateSimple(
              name,
              "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
            );
            tmp = val;
            val = period;
            period = tmp;
          }
          dur = createDuration(val, period);
          addSubtract(this, dur, direction);
          return this;
        };
      }
      function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
        if (!mom.isValid()) {
          return;
        }
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months2) {
          setMonth(mom, get(mom, "Month") + months2 * isAdding);
        }
        if (days2) {
          set$1(mom, "Date", get(mom, "Date") + days2 * isAdding);
        }
        if (milliseconds2) {
          mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
        }
        if (updateOffset) {
          hooks.updateOffset(mom, days2 || months2);
        }
      }
      var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
      function isString(input) {
        return typeof input === "string" || input instanceof String;
      }
      function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
      }
      function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
          "years",
          "year",
          "y",
          "months",
          "month",
          "M",
          "days",
          "day",
          "d",
          "dates",
          "date",
          "D",
          "hours",
          "hour",
          "h",
          "minutes",
          "minute",
          "m",
          "seconds",
          "second",
          "s",
          "milliseconds",
          "millisecond",
          "ms"
        ], i, property, propertyLen = properties.length;
        for (i = 0; i < propertyLen; i += 1) {
          property = properties[i];
          propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
      }
      function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) {
          dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
          }).length === 0;
        }
        return arrayTest && dataTypeTest;
      }
      function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
          "sameDay",
          "nextDay",
          "lastDay",
          "nextWeek",
          "lastWeek",
          "sameElse"
        ], i, property;
        for (i = 0; i < properties.length; i += 1) {
          property = properties[i];
          propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
      }
      function getCalendarFormat(myMoment, now2) {
        var diff2 = myMoment.diff(now2, "days", true);
        return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
      }
      function calendar$1(time, formats) {
        if (arguments.length === 1) {
          if (!arguments[0]) {
            time = void 0;
            formats = void 0;
          } else if (isMomentInput(arguments[0])) {
            time = arguments[0];
            formats = void 0;
          } else if (isCalendarSpec(arguments[0])) {
            formats = arguments[0];
            time = void 0;
          }
        }
        var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
        return this.format(
          output || this.localeData().calendar(format2, this, createLocal(now2))
        );
      }
      function clone() {
        return new Moment2(this);
      }
      function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
          return false;
        }
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") {
          return this.valueOf() > localInput.valueOf();
        } else {
          return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
      }
      function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
          return false;
        }
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") {
          return this.valueOf() < localInput.valueOf();
        } else {
          return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
      }
      function isBetween(from2, to2, units, inclusivity) {
        var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
          return false;
        }
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
      }
      function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) {
          return false;
        }
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") {
          return this.valueOf() === localInput.valueOf();
        } else {
          inputMs = localInput.valueOf();
          return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
      }
      function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
      }
      function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
      }
      function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) {
          return NaN;
        }
        that = cloneWithOffset(input, this);
        if (!that.isValid()) {
          return NaN;
        }
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch (units) {
          case "year":
            output = monthDiff(this, that) / 12;
            break;
          case "month":
            output = monthDiff(this, that);
            break;
          case "quarter":
            output = monthDiff(this, that) / 3;
            break;
          case "second":
            output = (this - that) / 1e3;
            break;
          case "minute":
            output = (this - that) / 6e4;
            break;
          case "hour":
            output = (this - that) / 36e5;
            break;
          case "day":
            output = (this - that - zoneDelta) / 864e5;
            break;
          case "week":
            output = (this - that - zoneDelta) / 6048e5;
            break;
          default:
            output = this - that;
        }
        return asFloat ? output : absFloor(output);
      }
      function monthDiff(a, b) {
        if (a.date() < b.date()) {
          return -monthDiff(b, a);
        }
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
          anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
          adjust = (b - anchor) / (anchor - anchor2);
        } else {
          anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
          adjust = (b - anchor) / (anchor2 - anchor);
        }
        return -(wholeMonthDiff + adjust) || 0;
      }
      hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
      hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
      function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
      }
      function toISOString(keepOffset) {
        if (!this.isValid()) {
          return null;
        }
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
          return formatMoment(
            m,
            utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
          );
        }
        if (isFunction(Date.prototype.toISOString)) {
          if (utc) {
            return this.toDate().toISOString();
          } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
          }
        }
        return formatMoment(
          m,
          utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      function inspect() {
        if (!this.isValid()) {
          return "moment.invalid(/* " + this._i + " */)";
        }
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
          func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
          zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
      }
      function format(inputString) {
        if (!inputString) {
          inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
      }
      function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
          return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
          return this.localeData().invalidDate();
        }
      }
      function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
      }
      function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
          return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
          return this.localeData().invalidDate();
        }
      }
      function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
      }
      function locale(key) {
        var newLocaleData;
        if (key === void 0) {
          return this._locale._abbr;
        } else {
          newLocaleData = getLocale(key);
          if (newLocaleData != null) {
            this._locale = newLocaleData;
          }
          return this;
        }
      }
      var lang = deprecate(
        "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
        function(key) {
          if (key === void 0) {
            return this.localeData();
          } else {
            return this.locale(key);
          }
        }
      );
      function localeData() {
        return this._locale;
      }
      var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
      function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
      }
      function localStartOfDate(y, m, d) {
        if (y < 100 && y >= 0) {
          return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
          return new Date(y, m, d).valueOf();
        }
      }
      function utcStartOfDate(y, m, d) {
        if (y < 100 && y >= 0) {
          return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
          return Date.UTC(y, m, d);
        }
      }
      function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === void 0 || units === "millisecond" || !this.isValid()) {
          return this;
        }
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch (units) {
          case "year":
            time = startOfDate(this.year(), 0, 1);
            break;
          case "quarter":
            time = startOfDate(
              this.year(),
              this.month() - this.month() % 3,
              1
            );
            break;
          case "month":
            time = startOfDate(this.year(), this.month(), 1);
            break;
          case "week":
            time = startOfDate(
              this.year(),
              this.month(),
              this.date() - this.weekday()
            );
            break;
          case "isoWeek":
            time = startOfDate(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1)
            );
            break;
          case "day":
          case "date":
            time = startOfDate(this.year(), this.month(), this.date());
            break;
          case "hour":
            time = this._d.valueOf();
            time -= mod$1(
              time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
              MS_PER_HOUR
            );
            break;
          case "minute":
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_MINUTE);
            break;
          case "second":
            time = this._d.valueOf();
            time -= mod$1(time, MS_PER_SECOND);
            break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
      }
      function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === void 0 || units === "millisecond" || !this.isValid()) {
          return this;
        }
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch (units) {
          case "year":
            time = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
          case "quarter":
            time = startOfDate(
              this.year(),
              this.month() - this.month() % 3 + 3,
              1
            ) - 1;
            break;
          case "month":
            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
          case "week":
            time = startOfDate(
              this.year(),
              this.month(),
              this.date() - this.weekday() + 7
            ) - 1;
            break;
          case "isoWeek":
            time = startOfDate(
              this.year(),
              this.month(),
              this.date() - (this.isoWeekday() - 1) + 7
            ) - 1;
            break;
          case "day":
          case "date":
            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
          case "hour":
            time = this._d.valueOf();
            time += MS_PER_HOUR - mod$1(
              time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
              MS_PER_HOUR
            ) - 1;
            break;
          case "minute":
            time = this._d.valueOf();
            time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
            break;
          case "second":
            time = this._d.valueOf();
            time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
            break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
      }
      function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 6e4;
      }
      function unix() {
        return Math.floor(this.valueOf() / 1e3);
      }
      function toDate() {
        return new Date(this.valueOf());
      }
      function toArray() {
        var m = this;
        return [
          m.year(),
          m.month(),
          m.date(),
          m.hour(),
          m.minute(),
          m.second(),
          m.millisecond()
        ];
      }
      function toObject() {
        var m = this;
        return {
          years: m.year(),
          months: m.month(),
          date: m.date(),
          hours: m.hours(),
          minutes: m.minutes(),
          seconds: m.seconds(),
          milliseconds: m.milliseconds()
        };
      }
      function toJSON() {
        return this.isValid() ? this.toISOString() : null;
      }
      function isValid$2() {
        return isValid(this);
      }
      function parsingFlags() {
        return extend({}, getParsingFlags(this));
      }
      function invalidAt() {
        return getParsingFlags(this).overflow;
      }
      function creationData() {
        return {
          input: this._i,
          format: this._f,
          locale: this._locale,
          isUTC: this._isUTC,
          strict: this._strict
        };
      }
      addFormatToken("N", 0, 0, "eraAbbr");
      addFormatToken("NN", 0, 0, "eraAbbr");
      addFormatToken("NNN", 0, 0, "eraAbbr");
      addFormatToken("NNNN", 0, 0, "eraName");
      addFormatToken("NNNNN", 0, 0, "eraNarrow");
      addFormatToken("y", ["y", 1], "yo", "eraYear");
      addFormatToken("y", ["yy", 2], 0, "eraYear");
      addFormatToken("y", ["yyy", 3], 0, "eraYear");
      addFormatToken("y", ["yyyy", 4], 0, "eraYear");
      addRegexToken("N", matchEraAbbr);
      addRegexToken("NN", matchEraAbbr);
      addRegexToken("NNN", matchEraAbbr);
      addRegexToken("NNNN", matchEraName);
      addRegexToken("NNNNN", matchEraNarrow);
      addParseToken(
        ["N", "NN", "NNN", "NNNN", "NNNNN"],
        function(input, array, config, token2) {
          var era = config._locale.erasParse(input, token2, config._strict);
          if (era) {
            getParsingFlags(config).era = era;
          } else {
            getParsingFlags(config).invalidEra = input;
          }
        }
      );
      addRegexToken("y", matchUnsigned);
      addRegexToken("yy", matchUnsigned);
      addRegexToken("yyy", matchUnsigned);
      addRegexToken("yyyy", matchUnsigned);
      addRegexToken("yo", matchEraYearOrdinal);
      addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
      addParseToken(["yo"], function(input, array, config, token2) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
          match = input.match(config._locale._eraYearOrdinalRegex);
        }
        if (config._locale.eraYearOrdinalParse) {
          array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
          array[YEAR] = parseInt(input, 10);
        }
      });
      function localeEras(m, format2) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
          switch (typeof eras[i].since) {
            case "string":
              date = hooks(eras[i].since).startOf("day");
              eras[i].since = date.valueOf();
              break;
          }
          switch (typeof eras[i].until) {
            case "undefined":
              eras[i].until = Infinity;
              break;
            case "string":
              date = hooks(eras[i].until).startOf("day").valueOf();
              eras[i].until = date.valueOf();
              break;
          }
        }
        return eras;
      }
      function localeErasParse(eraName, format2, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for (i = 0, l = eras.length; i < l; ++i) {
          name = eras[i].name.toUpperCase();
          abbr = eras[i].abbr.toUpperCase();
          narrow = eras[i].narrow.toUpperCase();
          if (strict) {
            switch (format2) {
              case "N":
              case "NN":
              case "NNN":
                if (abbr === eraName) {
                  return eras[i];
                }
                break;
              case "NNNN":
                if (name === eraName) {
                  return eras[i];
                }
                break;
              case "NNNNN":
                if (narrow === eraName) {
                  return eras[i];
                }
                break;
            }
          } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
            return eras[i];
          }
        }
      }
      function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === void 0) {
          return hooks(era.since).year();
        } else {
          return hooks(era.since).year() + (year - era.offset) * dir;
        }
      }
      function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].name;
          }
          if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].name;
          }
        }
        return "";
      }
      function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].narrow;
          }
          if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].narrow;
          }
        }
        return "";
      }
      function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].abbr;
          }
          if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].abbr;
          }
        }
        return "";
      }
      function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          dir = eras[i].since <= eras[i].until ? 1 : -1;
          val = this.clone().startOf("day").valueOf();
          if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
            return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
          }
        }
        return this.year();
      }
      function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) {
          computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
      }
      function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) {
          computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
      }
      function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) {
          computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
      }
      function matchEraAbbr(isStrict, locale2) {
        return locale2.erasAbbrRegex(isStrict);
      }
      function matchEraName(isStrict, locale2) {
        return locale2.erasNameRegex(isStrict);
      }
      function matchEraNarrow(isStrict, locale2) {
        return locale2.erasNarrowRegex(isStrict);
      }
      function matchEraYearOrdinal(isStrict, locale2) {
        return locale2._eraYearOrdinalRegex || matchUnsigned;
      }
      function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for (i = 0, l = eras.length; i < l; ++i) {
          namePieces.push(regexEscape(eras[i].name));
          abbrPieces.push(regexEscape(eras[i].abbr));
          narrowPieces.push(regexEscape(eras[i].narrow));
          mixedPieces.push(regexEscape(eras[i].name));
          mixedPieces.push(regexEscape(eras[i].abbr));
          mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp(
          "^(" + narrowPieces.join("|") + ")",
          "i"
        );
      }
      addFormatToken(0, ["gg", 2], 0, function() {
        return this.weekYear() % 100;
      });
      addFormatToken(0, ["GG", 2], 0, function() {
        return this.isoWeekYear() % 100;
      });
      function addWeekYearFormatToken(token2, getter) {
        addFormatToken(0, [token2, token2.length], 0, getter);
      }
      addWeekYearFormatToken("gggg", "weekYear");
      addWeekYearFormatToken("ggggg", "weekYear");
      addWeekYearFormatToken("GGGG", "isoWeekYear");
      addWeekYearFormatToken("GGGGG", "isoWeekYear");
      addUnitAlias("weekYear", "gg");
      addUnitAlias("isoWeekYear", "GG");
      addUnitPriority("weekYear", 1);
      addUnitPriority("isoWeekYear", 1);
      addRegexToken("G", matchSigned);
      addRegexToken("g", matchSigned);
      addRegexToken("GG", match1to2, match2);
      addRegexToken("gg", match1to2, match2);
      addRegexToken("GGGG", match1to4, match4);
      addRegexToken("gggg", match1to4, match4);
      addRegexToken("GGGGG", match1to6, match6);
      addRegexToken("ggggg", match1to6, match6);
      addWeekParseToken(
        ["gggg", "ggggg", "GGGG", "GGGGG"],
        function(input, week, config, token2) {
          week[token2.substr(0, 2)] = toInt(input);
        }
      );
      addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
        week[token2] = hooks.parseTwoDigitYear(input);
      });
      function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
          this,
          input,
          this.week(),
          this.weekday(),
          this.localeData()._week.dow,
          this.localeData()._week.doy
        );
      }
      function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
          this,
          input,
          this.isoWeek(),
          this.isoWeekday(),
          1,
          4
        );
      }
      function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
      }
      function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
      }
      function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
      }
      function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
      }
      function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
          return weekOfYear(this, dow, doy).year;
        } else {
          weeksTarget = weeksInYear(input, dow, doy);
          if (week > weeksTarget) {
            week = weeksTarget;
          }
          return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
      }
      function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
      }
      addFormatToken("Q", 0, "Qo", "quarter");
      addUnitAlias("quarter", "Q");
      addUnitPriority("quarter", 7);
      addRegexToken("Q", match1);
      addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
      });
      function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
      }
      addFormatToken("D", ["DD", 2], "Do", "date");
      addUnitAlias("date", "D");
      addUnitPriority("date", 9);
      addRegexToken("D", match1to2);
      addRegexToken("DD", match1to2, match2);
      addRegexToken("Do", function(isStrict, locale2) {
        return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
      });
      addParseToken(["D", "DD"], DATE);
      addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
      });
      var getSetDayOfMonth = makeGetSet("Date", true);
      addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
      addUnitAlias("dayOfYear", "DDD");
      addUnitPriority("dayOfYear", 4);
      addRegexToken("DDD", match1to3);
      addRegexToken("DDDD", match3);
      addParseToken(["DDD", "DDDD"], function(input, array, config) {
        config._dayOfYear = toInt(input);
      });
      function getSetDayOfYear(input) {
        var dayOfYear = Math.round(
          (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
        ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
      }
      addFormatToken("m", ["mm", 2], 0, "minute");
      addUnitAlias("minute", "m");
      addUnitPriority("minute", 14);
      addRegexToken("m", match1to2);
      addRegexToken("mm", match1to2, match2);
      addParseToken(["m", "mm"], MINUTE);
      var getSetMinute = makeGetSet("Minutes", false);
      addFormatToken("s", ["ss", 2], 0, "second");
      addUnitAlias("second", "s");
      addUnitPriority("second", 15);
      addRegexToken("s", match1to2);
      addRegexToken("ss", match1to2, match2);
      addParseToken(["s", "ss"], SECOND);
      var getSetSecond = makeGetSet("Seconds", false);
      addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
      });
      addFormatToken(0, ["SS", 2], 0, function() {
        return ~~(this.millisecond() / 10);
      });
      addFormatToken(0, ["SSS", 3], 0, "millisecond");
      addFormatToken(0, ["SSSS", 4], 0, function() {
        return this.millisecond() * 10;
      });
      addFormatToken(0, ["SSSSS", 5], 0, function() {
        return this.millisecond() * 100;
      });
      addFormatToken(0, ["SSSSSS", 6], 0, function() {
        return this.millisecond() * 1e3;
      });
      addFormatToken(0, ["SSSSSSS", 7], 0, function() {
        return this.millisecond() * 1e4;
      });
      addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
        return this.millisecond() * 1e5;
      });
      addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
        return this.millisecond() * 1e6;
      });
      addUnitAlias("millisecond", "ms");
      addUnitPriority("millisecond", 16);
      addRegexToken("S", match1to3, match1);
      addRegexToken("SS", match1to3, match2);
      addRegexToken("SSS", match1to3, match3);
      var token, getSetMillisecond;
      for (token = "SSSS"; token.length <= 9; token += "S") {
        addRegexToken(token, matchUnsigned);
      }
      function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1e3);
      }
      for (token = "S"; token.length <= 9; token += "S") {
        addParseToken(token, parseMs);
      }
      getSetMillisecond = makeGetSet("Milliseconds", false);
      addFormatToken("z", 0, 0, "zoneAbbr");
      addFormatToken("zz", 0, 0, "zoneName");
      function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
      }
      function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
      }
      var proto = Moment2.prototype;
      proto.add = add;
      proto.calendar = calendar$1;
      proto.clone = clone;
      proto.diff = diff;
      proto.endOf = endOf;
      proto.format = format;
      proto.from = from;
      proto.fromNow = fromNow;
      proto.to = to;
      proto.toNow = toNow;
      proto.get = stringGet;
      proto.invalidAt = invalidAt;
      proto.isAfter = isAfter;
      proto.isBefore = isBefore;
      proto.isBetween = isBetween;
      proto.isSame = isSame;
      proto.isSameOrAfter = isSameOrAfter;
      proto.isSameOrBefore = isSameOrBefore;
      proto.isValid = isValid$2;
      proto.lang = lang;
      proto.locale = locale;
      proto.localeData = localeData;
      proto.max = prototypeMax;
      proto.min = prototypeMin;
      proto.parsingFlags = parsingFlags;
      proto.set = stringSet;
      proto.startOf = startOf;
      proto.subtract = subtract;
      proto.toArray = toArray;
      proto.toObject = toObject;
      proto.toDate = toDate;
      proto.toISOString = toISOString;
      proto.inspect = inspect;
      if (typeof Symbol !== "undefined" && Symbol.for != null) {
        proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
          return "Moment<" + this.format() + ">";
        };
      }
      proto.toJSON = toJSON;
      proto.toString = toString;
      proto.unix = unix;
      proto.valueOf = valueOf;
      proto.creationData = creationData;
      proto.eraName = getEraName;
      proto.eraNarrow = getEraNarrow;
      proto.eraAbbr = getEraAbbr;
      proto.eraYear = getEraYear;
      proto.year = getSetYear;
      proto.isLeapYear = getIsLeapYear;
      proto.weekYear = getSetWeekYear;
      proto.isoWeekYear = getSetISOWeekYear;
      proto.quarter = proto.quarters = getSetQuarter;
      proto.month = getSetMonth;
      proto.daysInMonth = getDaysInMonth;
      proto.week = proto.weeks = getSetWeek;
      proto.isoWeek = proto.isoWeeks = getSetISOWeek;
      proto.weeksInYear = getWeeksInYear;
      proto.weeksInWeekYear = getWeeksInWeekYear;
      proto.isoWeeksInYear = getISOWeeksInYear;
      proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
      proto.date = getSetDayOfMonth;
      proto.day = proto.days = getSetDayOfWeek;
      proto.weekday = getSetLocaleDayOfWeek;
      proto.isoWeekday = getSetISODayOfWeek;
      proto.dayOfYear = getSetDayOfYear;
      proto.hour = proto.hours = getSetHour;
      proto.minute = proto.minutes = getSetMinute;
      proto.second = proto.seconds = getSetSecond;
      proto.millisecond = proto.milliseconds = getSetMillisecond;
      proto.utcOffset = getSetOffset;
      proto.utc = setOffsetToUTC;
      proto.local = setOffsetToLocal;
      proto.parseZone = setOffsetToParsedOffset;
      proto.hasAlignedHourOffset = hasAlignedHourOffset;
      proto.isDST = isDaylightSavingTime;
      proto.isLocal = isLocal;
      proto.isUtcOffset = isUtcOffset;
      proto.isUtc = isUtc;
      proto.isUTC = isUtc;
      proto.zoneAbbr = getZoneAbbr;
      proto.zoneName = getZoneName;
      proto.dates = deprecate(
        "dates accessor is deprecated. Use date instead.",
        getSetDayOfMonth
      );
      proto.months = deprecate(
        "months accessor is deprecated. Use month instead",
        getSetMonth
      );
      proto.years = deprecate(
        "years accessor is deprecated. Use year instead",
        getSetYear
      );
      proto.zone = deprecate(
        "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
        getSetZone
      );
      proto.isDSTShifted = deprecate(
        "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
        isDaylightSavingTimeShifted
      );
      function createUnix(input) {
        return createLocal(input * 1e3);
      }
      function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
      }
      function preParsePostFormat(string) {
        return string;
      }
      var proto$1 = Locale.prototype;
      proto$1.calendar = calendar;
      proto$1.longDateFormat = longDateFormat;
      proto$1.invalidDate = invalidDate;
      proto$1.ordinal = ordinal;
      proto$1.preparse = preParsePostFormat;
      proto$1.postformat = preParsePostFormat;
      proto$1.relativeTime = relativeTime;
      proto$1.pastFuture = pastFuture;
      proto$1.set = set;
      proto$1.eras = localeEras;
      proto$1.erasParse = localeErasParse;
      proto$1.erasConvertYear = localeErasConvertYear;
      proto$1.erasAbbrRegex = erasAbbrRegex;
      proto$1.erasNameRegex = erasNameRegex;
      proto$1.erasNarrowRegex = erasNarrowRegex;
      proto$1.months = localeMonths;
      proto$1.monthsShort = localeMonthsShort;
      proto$1.monthsParse = localeMonthsParse;
      proto$1.monthsRegex = monthsRegex;
      proto$1.monthsShortRegex = monthsShortRegex;
      proto$1.week = localeWeek;
      proto$1.firstDayOfYear = localeFirstDayOfYear;
      proto$1.firstDayOfWeek = localeFirstDayOfWeek;
      proto$1.weekdays = localeWeekdays;
      proto$1.weekdaysMin = localeWeekdaysMin;
      proto$1.weekdaysShort = localeWeekdaysShort;
      proto$1.weekdaysParse = localeWeekdaysParse;
      proto$1.weekdaysRegex = weekdaysRegex;
      proto$1.weekdaysShortRegex = weekdaysShortRegex;
      proto$1.weekdaysMinRegex = weekdaysMinRegex;
      proto$1.isPM = localeIsPM;
      proto$1.meridiem = localeMeridiem;
      function get$1(format2, index, field, setter) {
        var locale2 = getLocale(), utc = createUTC().set(setter, index);
        return locale2[field](utc, format2);
      }
      function listMonthsImpl(format2, index, field) {
        if (isNumber(format2)) {
          index = format2;
          format2 = void 0;
        }
        format2 = format2 || "";
        if (index != null) {
          return get$1(format2, index, field, "month");
        }
        var i, out = [];
        for (i = 0; i < 12; i++) {
          out[i] = get$1(format2, i, field, "month");
        }
        return out;
      }
      function listWeekdaysImpl(localeSorted, format2, index, field) {
        if (typeof localeSorted === "boolean") {
          if (isNumber(format2)) {
            index = format2;
            format2 = void 0;
          }
          format2 = format2 || "";
        } else {
          format2 = localeSorted;
          index = format2;
          localeSorted = false;
          if (isNumber(format2)) {
            index = format2;
            format2 = void 0;
          }
          format2 = format2 || "";
        }
        var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
        if (index != null) {
          return get$1(format2, (index + shift) % 7, field, "day");
        }
        for (i = 0; i < 7; i++) {
          out[i] = get$1(format2, (i + shift) % 7, field, "day");
        }
        return out;
      }
      function listMonths(format2, index) {
        return listMonthsImpl(format2, index, "months");
      }
      function listMonthsShort(format2, index) {
        return listMonthsImpl(format2, index, "monthsShort");
      }
      function listWeekdays(localeSorted, format2, index) {
        return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
      }
      function listWeekdaysShort(localeSorted, format2, index) {
        return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
      }
      function listWeekdaysMin(localeSorted, format2, index) {
        return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
      }
      getSetGlobalLocale("en", {
        eras: [
          {
            since: "0001-01-01",
            until: Infinity,
            offset: 1,
            name: "Anno Domini",
            narrow: "AD",
            abbr: "AD"
          },
          {
            since: "0000-12-31",
            until: -Infinity,
            offset: 1,
            name: "Before Christ",
            narrow: "BC",
            abbr: "BC"
          }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
          var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
          return number + output;
        }
      });
      hooks.lang = deprecate(
        "moment.lang is deprecated. Use moment.locale instead.",
        getSetGlobalLocale
      );
      hooks.langData = deprecate(
        "moment.langData is deprecated. Use moment.localeData instead.",
        getLocale
      );
      var mathAbs = Math.abs;
      function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
      }
      function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
      }
      function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
      }
      function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
      }
      function absCeil(number) {
        if (number < 0) {
          return Math.floor(number);
        } else {
          return Math.ceil(number);
        }
      }
      function bubble() {
        var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
        if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
          milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
          days2 = 0;
          months2 = 0;
        }
        data.milliseconds = milliseconds2 % 1e3;
        seconds2 = absFloor(milliseconds2 / 1e3);
        data.seconds = seconds2 % 60;
        minutes2 = absFloor(seconds2 / 60);
        data.minutes = minutes2 % 60;
        hours2 = absFloor(minutes2 / 60);
        data.hours = hours2 % 24;
        days2 += absFloor(hours2 / 24);
        monthsFromDays = absFloor(daysToMonths(days2));
        months2 += monthsFromDays;
        days2 -= absCeil(monthsToDays(monthsFromDays));
        years2 = absFloor(months2 / 12);
        months2 %= 12;
        data.days = days2;
        data.months = months2;
        data.years = years2;
        return this;
      }
      function daysToMonths(days2) {
        return days2 * 4800 / 146097;
      }
      function monthsToDays(months2) {
        return months2 * 146097 / 4800;
      }
      function as(units) {
        if (!this.isValid()) {
          return NaN;
        }
        var days2, months2, milliseconds2 = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
          days2 = this._days + milliseconds2 / 864e5;
          months2 = this._months + daysToMonths(days2);
          switch (units) {
            case "month":
              return months2;
            case "quarter":
              return months2 / 3;
            case "year":
              return months2 / 12;
          }
        } else {
          days2 = this._days + Math.round(monthsToDays(this._months));
          switch (units) {
            case "week":
              return days2 / 7 + milliseconds2 / 6048e5;
            case "day":
              return days2 + milliseconds2 / 864e5;
            case "hour":
              return days2 * 24 + milliseconds2 / 36e5;
            case "minute":
              return days2 * 1440 + milliseconds2 / 6e4;
            case "second":
              return days2 * 86400 + milliseconds2 / 1e3;
            case "millisecond":
              return Math.floor(days2 * 864e5) + milliseconds2;
            default:
              throw new Error("Unknown unit " + units);
          }
        }
      }
      function valueOf$1() {
        if (!this.isValid()) {
          return NaN;
        }
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
      }
      function makeAs(alias) {
        return function() {
          return this.as(alias);
        };
      }
      var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
      function clone$1() {
        return createDuration(this);
      }
      function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
      }
      function makeGetter(name) {
        return function() {
          return this.isValid() ? this._data[name] : NaN;
        };
      }
      var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
      function weeks() {
        return absFloor(this.days() / 7);
      }
      var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
      function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
        return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
      }
      function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
        var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
        if (thresholds2.w != null) {
          a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
        }
        a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale2;
        return substituteTimeAgo.apply(null, a);
      }
      function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === void 0) {
          return round;
        }
        if (typeof roundingFunction === "function") {
          round = roundingFunction;
          return true;
        }
        return false;
      }
      function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === void 0) {
          return false;
        }
        if (limit === void 0) {
          return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === "s") {
          thresholds.ss = limit - 1;
        }
        return true;
      }
      function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
          return this.localeData().invalidDate();
        }
        var withSuffix = false, th = thresholds, locale2, output;
        if (typeof argWithSuffix === "object") {
          argThresholds = argWithSuffix;
          argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") {
          withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === "object") {
          th = Object.assign({}, thresholds, argThresholds);
          if (argThresholds.s != null && argThresholds.ss == null) {
            th.ss = argThresholds.s - 1;
          }
        }
        locale2 = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale2);
        if (withSuffix) {
          output = locale2.pastFuture(+this, output);
        }
        return locale2.postformat(output);
      }
      var abs$1 = Math.abs;
      function sign(x) {
        return (x > 0) - (x < 0) || +x;
      }
      function toISOString$1() {
        if (!this.isValid()) {
          return this.localeData().invalidDate();
        }
        var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) {
          return "P0D";
        }
        minutes2 = absFloor(seconds2 / 60);
        hours2 = absFloor(minutes2 / 60);
        seconds2 %= 60;
        minutes2 %= 60;
        years2 = absFloor(months2 / 12);
        months2 %= 12;
        s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
      }
      var proto$2 = Duration.prototype;
      proto$2.isValid = isValid$1;
      proto$2.abs = abs;
      proto$2.add = add$1;
      proto$2.subtract = subtract$1;
      proto$2.as = as;
      proto$2.asMilliseconds = asMilliseconds;
      proto$2.asSeconds = asSeconds;
      proto$2.asMinutes = asMinutes;
      proto$2.asHours = asHours;
      proto$2.asDays = asDays;
      proto$2.asWeeks = asWeeks;
      proto$2.asMonths = asMonths;
      proto$2.asQuarters = asQuarters;
      proto$2.asYears = asYears;
      proto$2.valueOf = valueOf$1;
      proto$2._bubble = bubble;
      proto$2.clone = clone$1;
      proto$2.get = get$2;
      proto$2.milliseconds = milliseconds;
      proto$2.seconds = seconds;
      proto$2.minutes = minutes;
      proto$2.hours = hours;
      proto$2.days = days;
      proto$2.weeks = weeks;
      proto$2.months = months;
      proto$2.years = years;
      proto$2.humanize = humanize;
      proto$2.toISOString = toISOString$1;
      proto$2.toString = toISOString$1;
      proto$2.toJSON = toISOString$1;
      proto$2.locale = locale;
      proto$2.localeData = localeData;
      proto$2.toIsoString = deprecate(
        "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
        toISOString$1
      );
      proto$2.lang = lang;
      addFormatToken("X", 0, 0, "unix");
      addFormatToken("x", 0, 0, "valueOf");
      addRegexToken("x", matchSigned);
      addRegexToken("X", matchTimestamp);
      addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1e3);
      });
      addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
      });
      hooks.version = "2.29.4";
      setHookCallback(createLocal);
      hooks.fn = proto;
      hooks.min = min;
      hooks.max = max;
      hooks.now = now;
      hooks.utc = createUTC;
      hooks.unix = createUnix;
      hooks.months = listMonths;
      hooks.isDate = isDate;
      hooks.locale = getSetGlobalLocale;
      hooks.invalid = createInvalid;
      hooks.duration = createDuration;
      hooks.isMoment = isMoment;
      hooks.weekdays = listWeekdays;
      hooks.parseZone = createInZone;
      hooks.localeData = getLocale;
      hooks.isDuration = isDuration;
      hooks.monthsShort = listMonthsShort;
      hooks.weekdaysMin = listWeekdaysMin;
      hooks.defineLocale = defineLocale;
      hooks.updateLocale = updateLocale;
      hooks.locales = listLocales;
      hooks.weekdaysShort = listWeekdaysShort;
      hooks.normalizeUnits = normalizeUnits;
      hooks.relativeTimeRounding = getSetRelativeTimeRounding;
      hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
      hooks.calendarFormat = getCalendarFormat;
      hooks.prototype = proto;
      hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
      };
      return hooks;
    });
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS: () => ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS,
  ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY: () => ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY,
  ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS: () => ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS,
  DURATION_OPTIONS: () => DURATION_OPTIONS,
  MAX_GRAD_YEAR: () => MAX_GRAD_YEAR,
  MAX_LEVEL: () => MAX_LEVEL,
  MAX_PREDICTED_SALARY: () => MAX_PREDICTED_SALARY,
  MIN_GRAD_YEAR: () => MIN_GRAD_YEAR,
  MIN_LEVEL: () => MIN_LEVEL,
  MIN_PREDICTED_SALARY: () => MIN_PREDICTED_SALARY,
  POSITION_CLOSURE_INELIGIBLE_APPLICANTS_MESSAGE: () => POSITION_CLOSURE_INELIGIBLE_APPLICANTS_MESSAGE,
  POSITION_CLOSURE_MIA_OTHER_ACCESS_MESSAGE: () => POSITION_CLOSURE_MIA_OTHER_ACCESS_MESSAGE,
  POSITION_CLOSURE_REASON: () => POSITION_CLOSURE_REASON,
  PROCESS_NOT_STARTED: () => PROCESS_NOT_STARTED,
  RESTRICTED_POSITION_CLOSURE_REASONS: () => RESTRICTED_POSITION_CLOSURE_REASONS,
  SUPER_ADMIN_ONLY_POSITION_CLOSURE_REASONS: () => SUPER_ADMIN_ONLY_POSITION_CLOSURE_REASONS,
  TopCardChildComponentOptions: () => TopCardChildComponentOptions,
  accountManagerRoleOptions: () => accountManagerRoleOptions,
  activeApplicantStatuses: () => activeApplicantStatuses,
  activeApplicantsTabApplicationWhereClause: () => activeApplicantsTabApplicationWhereClause,
  adminRoleOptions: () => adminRoleOptions,
  allDegrees: () => allDegrees,
  allSkillsDropdownForPosition: () => allSkillsDropdownForPosition,
  allSpecializations: () => allSpecializations,
  allWeekDays: () => allWeekDays,
  allowFirstPayment: () => allowFirstPayment,
  allowPaymentForDriveApplication: () => allowPaymentForDriveApplication,
  allowSecondPayment: () => allowSecondPayment,
  allowedMoveToNextRoundApplicationStatuses: () => allowedMoveToNextRoundApplicationStatuses,
  allowedRecruiterRoundActionApplicationStatuses: () => allowedRecruiterRoundActionApplicationStatuses,
  allowedSendOfferLetterApplicationStatuses: () => allowedSendOfferLetterApplicationStatuses,
  allowedUpdateOfferLetterApplicationStatuses: () => allowedUpdateOfferLetterApplicationStatuses,
  alumniUserRoleOptions: () => alumniUserRoleOptions,
  applicantsTabApplicationWhereClause: () => applicantsTabApplicationWhereClause,
  backLogsOptions: () => backLogsOptions,
  behaviouralFlagsOptions: () => behaviouralFlagsOptions,
  boards: () => boards,
  buildAssignmentSubmissionFields: () => buildAssignmentSubmissionFields,
  calculateMedian: () => calculateMedian,
  camelCaseToSpace: () => camelCaseToSpace,
  canClosePositionWithMIAOrOther: () => canClosePositionWithMIAOrOther,
  canRegularRejectApplication: () => canRegularRejectApplication,
  canScreenRejectApplication: () => canScreenRejectApplication,
  canUndoScreenRejection: () => canUndoScreenRejection,
  canUserSelectPositionClosureReason: () => canUserSelectPositionClosureReason,
  capitalize: () => capitalize,
  checkDisplayUserEmail: () => checkDisplayUserEmail,
  checkIfUserFilledForm: () => checkIfUserFilledForm,
  checkInPipelineApplication: () => checkInPipelineApplication,
  checkIsConnectedApplicant: () => checkIsConnectedApplicant,
  checkIsFutureDate: () => checkIsFutureDate,
  checkUserEligibilityForSecondRound: () => checkUserEligibilityForSecondRound,
  cleanStringForRegex: () => cleanStringForRegex,
  closedApplicationRoundStatuses: () => closedApplicationRoundStatuses,
  closedApplicationStatuses: () => closedApplicationStatuses,
  companyNatureOptions: () => companyNatureOptions,
  companyTypeOptions: () => companyTypeOptions,
  completedMeetingStatuses: () => completedMeetingStatuses,
  conditionsOptions: () => conditionsOptions,
  convertDays: () => convertDays,
  convertDifficulty: () => convertDifficulty,
  convertEnumToTitleCaseProfileTab: () => convertEnumToTitleCaseProfileTab,
  convertTimeToMonthYearString: () => convertTimeToMonthYearString,
  convertedDateFromDateType: () => convertedDateFromDateType,
  createItemsById: () => createItemsById,
  csvToJson: () => csvToJson,
  designationMappingWithTechStack: () => designationMappingWithTechStack,
  difficultyNumberToTextMapping: () => difficultyNumberToTextMapping,
  displayApplicationStatus: () => displayApplicationStatus,
  displaySkillListForRecruiter: () => displaySkillListForRecruiter,
  dontAllowDirectOptOutApplicationStatuses: () => dontAllowDirectOptOutApplicationStatuses,
  expectedJoiningOptions: () => expectedJoiningOptions,
  fileSubmissionColumnKey: () => fileSubmissionColumnKey,
  findCombinations: () => findCombinations,
  findPaths: () => findPaths,
  findRemainingAttempts: () => findRemainingAttempts,
  formatCareerPathType: () => formatCareerPathType,
  formatNumberWithSuffix: () => formatNumberWithSuffix,
  formatTime: () => formatTime,
  formatTimeDifference: () => formatTimeDifference,
  genderOptions: () => genderOptions,
  generateCareerPathTypeOptions: () => generateCareerPathTypeOptions,
  generateDevelopmentRoleTypeOptions: () => generateDevelopmentRoleTypeOptions,
  generatePositionTitle: () => generatePositionTitle,
  generateProductSkillsForDisplayNames: () => generateProductSkillsForDisplayNames,
  generateRangeValuesArray: () => generateRangeValuesArray,
  generateTechStackName: () => generateTechStackName,
  generateTechStackTypeOptions: () => generateTechStackTypeOptions,
  generateUniqueHandler: () => generateUniqueHandler,
  generateUserExperienceLevelTypeOptions: () => generateUserExperienceLevelTypeOptions,
  getAllDatesInRange: () => getAllDatesInRange,
  getAssignmentSubmissionsDownloadColumns: () => getAssignmentSubmissionsDownloadColumns,
  getBUPriority: () => getBUPriority,
  getConnectedApplicantsDownloadColumns: () => getConnectedApplicantsDownloadColumns,
  getCtaTextAndActionForRecruiterForPipeLineUser: () => getCtaTextAndActionForRecruiterForPipeLineUser,
  getDateValues: () => getDateValues,
  getDecayFactor: () => getDecayFactor,
  getDevelopmentRoleUIConfig: () => getDevelopmentRoleUIConfig,
  getDumnyUser: () => getDumnyUser,
  getExpiryDateInWorkingHours: () => getExpiryDateInWorkingHours,
  getJobSeekerAssignmentExpiry: () => getJobSeekerAssignmentExpiry,
  getLastStringOfId: () => getLastStringOfId,
  getLatestInterview: () => getLatestInterview,
  getMonthName: () => getMonthName,
  getNextAssessmentTokenDetails: () => getNextAssessmentTokenDetails,
  getPositionClosureReasonOptions: () => getPositionClosureReasonOptions,
  getRecommendedUsersDownloadColumns: () => getRecommendedUsersDownloadColumns,
  getResumeLinkFromUser: () => getResumeLinkFromUser,
  getScreenRejectRoundNameFromApplicationStatus: () => getScreenRejectRoundNameFromApplicationStatus,
  getSubmissionColumnsForAssignmentType: () => getSubmissionColumnsForAssignmentType,
  getTimeScore: () => getTimeScore,
  getTodaysDate: () => getTodaysDate,
  getUserPreferenceUIConfig: () => getUserPreferenceUIConfig,
  getValidJapAmount: () => getValidJapAmount,
  gradYearOptions: () => gradYearOptions,
  groupAvailabilityByDurationAndDate: () => groupAvailabilityByDurationAndDate,
  hasAnyApplicationRoundStarted: () => hasAnyApplicationRoundStarted,
  hideCtaToRecruiterCard: () => hideCtaToRecruiterCard,
  highestQualifications: () => highestQualifications,
  inProgressApplicationStatuses: () => inProgressApplicationStatuses,
  isApplicantsTabApplication: () => isApplicantsTabApplication,
  isApplicationExpiredForPositionClosure: () => isApplicationExpiredForPositionClosure,
  isApplicationRejectionStatus: () => isApplicationRejectionStatus,
  isCancelledMeeting: () => isCancelledMeeting,
  isCancelledOrRescheduledMeeting: () => isCancelledOrRescheduledMeeting,
  isDecimal: () => isDecimal,
  isMIAOrOtherClosureReason: () => isMIAOrOtherClosureReason,
  isMIAOtherClosureEligibleApplication: () => isMIAOtherClosureEligibleApplication,
  isMandatoryFormFilled: () => isMandatoryFormFilled,
  isNoActionAfterShortlistApplication: () => isNoActionAfterShortlistApplication,
  isPhoneOrEmail: () => isPhoneOrEmail,
  isPlacedElsewhereWithVerballyPlacedStudentEligibleForClosure: () => isPlacedElsewhereWithVerballyPlacedStudentEligibleForClosure,
  isPositionClosed: () => isPositionClosed,
  isPositionClosureEligibleApplication: () => isPositionClosureEligibleApplication,
  isPositionClosureEligibleApplicationStatus: () => isPositionClosureEligibleApplicationStatus,
  isRescheduledMeeting: () => isRescheduledMeeting,
  isRestrictedPositionClosureReason: () => isRestrictedPositionClosureReason,
  isScheduledOrOngoingMeeting: () => isScheduledOrOngoingMeeting,
  isScheduledOrOngoingSession: () => isScheduledOrOngoingSession,
  isScoreRangeValid: () => isScoreRangeValid,
  isSellableOptions: () => isSellableOptions,
  isSuperAdminOnlyPositionClosureReason: () => isSuperAdminOnlyPositionClosureReason,
  isUserAccountManager: () => isUserAccountManager,
  isUserAdmin: () => isUserAdmin,
  isUserAllowedToApply: () => isUserAllowedToApply,
  isUserAlumniConnect: () => isUserAlumniConnect,
  isUserCollegeUser: () => isUserCollegeUser,
  isUserDriveAdmin: () => isUserDriveAdmin,
  isUserJobseeker: () => isUserJobseeker,
  isUserLeadGen: () => isUserLeadGen,
  isUserMentor: () => isUserMentor,
  isUserPreferenceFilled: () => isUserPreferenceFilled,
  isUserRecruiter: () => isUserRecruiter,
  isUserSuperAccountManager: () => isUserSuperAccountManager,
  isUserSuperAdmin: () => isUserSuperAdmin,
  isUserSuperLeadGen: () => isUserSuperLeadGen,
  isUserUniversityManager: () => isUserUniversityManager,
  isVerballyPlacedApplicationBlockingClosure: () => isVerballyPlacedApplicationBlockingClosure,
  leadGenRoleOptions: () => leadGenRoleOptions,
  linkSubmissionColumnKey: () => linkSubmissionColumnKey,
  locationPreferenceOptions: () => locationPreferenceOptions,
  mapPositionTitlesToDropdownOptions: () => mapPositionTitlesToDropdownOptions,
  maxAttemptsOptions: () => maxAttemptsOptions,
  meetingTypeOptions: () => meetingTypeOptions,
  mentorJobRoleOptions: () => mentorJobRoleOptions,
  mentorUserRoleOptions: () => mentorUserRoleOptions,
  mustHaveSkillsIrrespectiveOfPosition: () => mustHaveSkillsIrrespectiveOfPosition,
  natureOfBusinessOptions: () => natureOfBusinessOptions,
  neighbourStatesMapping: () => neighbourStatesMapping,
  ordinalSuffixOf: () => ordinalSuffixOf,
  outOfPlacementTags: () => outOfPlacementTags,
  ownershipOptions: () => ownershipOptions,
  partitionApplicationsByClosedPosition: () => partitionApplicationsByClosedPosition,
  positionClosureEligibleApplicationStatuses: () => positionClosureEligibleApplicationStatuses,
  positionStatusOptions: () => positionStatusOptions,
  positionTitleOptions: () => positionTitleOptions,
  positionTypeOptions: () => positionTypeOptions,
  postgraduateDegrees: () => postgraduateDegrees,
  regionStateMapping: () => regionStateMapping,
  requiresApplicantStatusValidationForPositionClosure: () => requiresApplicantStatusValidationForPositionClosure,
  resolveClosingPositionReason: () => resolveClosingPositionReason,
  resolveReopenedApplicationStatus: () => resolveReopenedApplicationStatus,
  revertPositionTitle: () => revertPositionTitle,
  revertPositionTitleV2: () => revertPositionTitleV2,
  sanitizeContactInformationOfUser: () => sanitizeContactInformationOfUser,
  sendMessageToJSApplicationStatuses: () => sendMessageToJSApplicationStatuses,
  sendMessageToParent: () => sendMessageToParent,
  sessionMeetingStatuses: () => sessionMeetingStatuses,
  showApplicationStatusToRecruiterCard: () => showApplicationStatusToRecruiterCard,
  skillNameToIdMapping: () => skillNameToIdMapping,
  skillTypeOptions: () => skillTypeOptions,
  stateCityOptions: () => stateCityOptions,
  stringAvatar: () => stringAvatar,
  techStackMappingWithSkills: () => techStackMappingWithSkills,
  timeGapConvertor: () => timeGapConvertor,
  undergraduateDegrees: () => undergraduateDegrees,
  uniqueDegrees: () => uniqueDegrees,
  uniqueSpecializations: () => uniqueSpecializations,
  validateEmailAddress: () => validateEmailAddress,
  validateLinkedInProfileUrl: () => validateLinkedInProfileUrl,
  validateName: () => validateName,
  validatePhoneNumber: () => validatePhoneNumber,
  validateUrl: () => validateUrl,
  visibilityTypeOptions: () => visibilityTypeOptions,
  wasApplicationShortlisted: () => wasApplicationShortlisted,
  workingModeOptions: () => workingModeOptions
});
module.exports = __toCommonJS(src_exports);
init_cjs_shims();

// src/stringAvatar.ts
init_cjs_shims();
var stringAvatar = (name) => {
  var _a, _b;
  if (!name)
    return "";
  const strgs = (_b = (_a = name == null ? void 0 : name.trim()) == null ? void 0 : _a.replace(/\s+/g, " ")) == null ? void 0 : _b.split(" ");
  return `${strgs.length > 1 ? strgs[0][0] + strgs[1][0] : strgs[0][0]}`;
};

// src/dataValidation.ts
init_cjs_shims();
var validatePhoneNumber = (phone) => {
  const regex = /^[0-9]{10}$/;
  return regex.test(phone);
};
var validateName = (name) => {
  const regex = /^([a-zA-Z]{3,} *?)+([a-zA-Z]+ *?)$/;
  return name.match(regex);
};
var validateEmailAddress = (email) => {
  const regex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};
var isPhoneOrEmail = (emailOrPhone) => {
  let type = null;
  let email = void 0, phone = void 0;
  if (validatePhoneNumber(emailOrPhone)) {
    phone = emailOrPhone.trim();
  } else if (validateEmailAddress(emailOrPhone)) {
    email = emailOrPhone.toLowerCase().trim();
  }
  if (phone) {
    type = "Phone";
  } else if (email) {
    type = "Email";
  }
  return type;
};
var validateLinkedInProfileUrl = (url) => {
  const regex = /^https?:\/\/(?:www\.)?(?:in\.)?(?:linkedin\.com\/(?:in|pub|profile|company)\/[\w-]+\/?|lnkd\.in\/[\w-]+)$/;
  return regex.test(url);
};
var validateUrl = (url) => {
  const regex = /\b(?:https?|ftp):\/\/[-\w+&@#/%?=~|$!:,.;]*[\w+&@#/%=~|$]/;
  return regex.test(url);
};
var isDecimal = (value) => {
  return !(value % 1 === 0);
};

// src/items.ts
init_cjs_shims();
var import_types3 = __toESM(require_dist());

// src/position.ts
init_cjs_shims();
var import_types = __toESM(require_dist());
var getLastStringOfId = (id) => {
  return id.substring((id == null ? void 0 : id.length) - 4);
};
var isUserAllowedToApply = ({
  isUserPlaced,
  activeApplicantCount
}) => {
  if (isUserPlaced) {
    return false;
  }
  return true;
};
var generatePositionTitle = (title) => {
  switch (title) {
    case import_types.PositionTitle.SDE_ONE:
      return "SDE 1";
    case import_types.PositionTitle.SDE_TWO:
      return "SDE 2";
    case import_types.PositionTitle.SDE_THREE:
      return "SDE 3";
    case import_types.PositionTitle.SENIOR_SOFTWARE_ENGINEER:
      return "Senior Software Engineer";
    case import_types.PositionTitle.BACKEND_ENGINEER:
      return "Backend Engineer";
    case import_types.PositionTitle.FRONTEND_ENGINEER:
      return "Frontend Engineer";
    case import_types.PositionTitle.FULL_STACK_ENGINEER:
      return "Full Stack Engineer";
    case import_types.PositionTitle.TECH_LEAD:
      return "Tech Lead";
    case import_types.PositionTitle.ASSOCIATE_SOFTWARE_ENGINEER:
      return "Associate Software Engineer";
    case import_types.PositionTitle.ENGINEERING_LEAD:
      return "Engineering Lead";
    case import_types.PositionTitle.ENGINEERING_MANAGER:
      return "Engineering Manager";
    case import_types.PositionTitle.GRADUATE_ENGINEER_TRAINEE:
      return "Graduate Engineer Trainee";
    case import_types.PositionTitle.LEAD_DEVELOPER:
      return "Lead Developer";
    case import_types.PositionTitle.SOFTWARE_ENGINEER:
      return "Software Engineer";
    case import_types.PositionTitle.JUNIOR_SOFTWARE_TESTER:
      return "Junior Software Tester";
    case import_types.PositionTitle.JUNIOR_QA_TESTER:
      return "Junior QA Tester";
    case import_types.PositionTitle.QA_TESTER:
      return "QA Tester";
    case import_types.PositionTitle.TEST_ANALYST:
      return "Test Analyst";
    case import_types.PositionTitle.SOFTWARE_TESTER:
      return "Software Tester";
    case import_types.PositionTitle.AUTOMATION_ENGINEER:
      return "Automation Engineer";
    case import_types.PositionTitle.QA_ENGINEER:
      return "QA Engineer";
    case import_types.PositionTitle.MANUAL_TESTER:
      return "Manual Tester";
    case import_types.PositionTitle.TECH_SUPPORT:
      return "Tech Support";
    case import_types.PositionTitle.SOLUTION_ENGINEER:
      return "Solution Engineer";
    case import_types.PositionTitle.MENTOR_ENGINEER:
      return "Mentor Engineer";
    case import_types.PositionTitle.DATA_ANALYST:
      return "Data Analyst";
    case import_types.PositionTitle.BUSINESS_ANALYST:
      return "Business Analyst";
    case import_types.PositionTitle.MIS_EXECUTIVE:
      return "MIS Executive";
    case import_types.PositionTitle.DATA_SCIENTIST:
      return "Data Scientist";
    case import_types.PositionTitle.INSTRUCTIONAL_ASSOCIATE_DA:
      return "Instructional Associate DA";
    case import_types.PositionTitle.TAG_IMPLEMENTATION:
      return "Tag Implementation";
    case import_types.PositionTitle.INSTRUCTIONAL_ASSOCIATE:
      return "Instructional Associate";
    case import_types.PositionTitle.CUSTOMER_SUPPORT_ENGINEER:
      return "Customer Support Engineer";
    case import_types.PositionTitle.ML_ENGINEER:
      return "ML Engineer";
    case import_types.PositionTitle.AI_DEVELOPER:
      return "AI Developer";
    case import_types.PositionTitle.PROMPT_ENGINEER:
      return "Prompt Engineer";
    case import_types.PositionTitle.OPERATION_EXECUTIVE:
      return "Operation Executive";
    case import_types.PositionTitle.EMAILS_EXECUTION:
      return "Emails Execution";
    case import_types.PositionTitle.EVENTS_EXECUTION:
      return "Events Execution";
    case import_types.PositionTitle.CONTENT_PUBLISHER:
      return "Content Publisher";
    case import_types.PositionTitle.MARKETING:
      return "Marketing";
    case import_types.PositionTitle.SALES:
      return "Sales";
    case import_types.PositionTitle.OPERATIONS:
      return "Operations";
    case import_types.PositionTitle.MANAGEMENT_TRAINEE:
      return "Management Trainee";
    case import_types.PositionTitle.AI_ENGINEER:
      return "AI Engineer";
    case import_types.PositionTitle.LLM_ENGINEER:
      return "LLM Engineer";
    case import_types.PositionTitle.RESEARCH_ANALYST_INTERN:
      return "Research Analyst Intern";
    case import_types.PositionTitle.DIGITAL_MARKETING:
      return "Digital Marketing";
    case import_types.PositionTitle.DOT_NET_DEVELOPER:
      return ".Net Developer";
    case import_types.PositionTitle.CONTENT_CREATOR:
      return "Content Creator";
    case import_types.PositionTitle.SOCIAL_MEDIA_EXECUTIVE:
      return "Social Media Executive";
    case import_types.PositionTitle.DATA_ENGINEER:
      return "Data Engineer";
    default:
      return title;
  }
};
var revertPositionTitle = (title) => {
  switch (title) {
    case "sde 1":
      return import_types.PositionTitle.SDE_ONE;
    case "sde 2":
      return import_types.PositionTitle.SDE_TWO;
    case "sde 3":
      return import_types.PositionTitle.SDE_THREE;
    case "senior software engineer":
      return import_types.PositionTitle.SENIOR_SOFTWARE_ENGINEER;
    case "backend engineer":
      return import_types.PositionTitle.BACKEND_ENGINEER;
    case "frontend engineer":
      return import_types.PositionTitle.FRONTEND_ENGINEER;
    case "full stack engineer":
      return import_types.PositionTitle.FULL_STACK_ENGINEER;
    case "tech lead":
      return import_types.PositionTitle.TECH_LEAD;
    case "associate software engineer":
      return import_types.PositionTitle.ASSOCIATE_SOFTWARE_ENGINEER;
    case "engineering lead":
      return import_types.PositionTitle.ENGINEERING_LEAD;
    case "engineering manager":
      return import_types.PositionTitle.ENGINEERING_MANAGER;
    case "graduate engineer trainee":
      return import_types.PositionTitle.GRADUATE_ENGINEER_TRAINEE;
    case "lead developer":
      return import_types.PositionTitle.LEAD_DEVELOPER;
    case "software engineer":
      return import_types.PositionTitle.SOFTWARE_ENGINEER;
    case import_types.PositionTitle.TECH_SUPPORT:
      return "tech support";
    case import_types.PositionTitle.CONTENT_PUBLISHER:
      return "content publisher";
    case import_types.PositionTitle.MARKETING:
      return "marketing";
    case import_types.PositionTitle.SALES:
      return "sales";
    case import_types.PositionTitle.OPERATIONS:
      return "operations";
    case import_types.PositionTitle.MENTOR_ENGINEER:
      return "mentor engineer";
    case import_types.PositionTitle.MANAGEMENT_TRAINEE:
      return "management trainee";
    case import_types.PositionTitle.AI_ENGINEER:
      return "ai engineer";
    case import_types.PositionTitle.LLM_ENGINEER:
      return "llm engineer";
    case import_types.PositionTitle.PROMPT_ENGINEER:
      return "prompt engineer";
    case import_types.PositionTitle.RESEARCH_ANALYST_INTERN:
      return "research analyst intern";
    case import_types.PositionTitle.DIGITAL_MARKETING:
      return "digital marketing";
    default:
      return title;
  }
};
var generateTechStackName = (stack) => {
  switch (stack) {
    case import_types.TechStacksForPosition.JAVA:
      return "JAVA";
    case import_types.TechStacksForPosition.MERN:
      return "MERN";
    case import_types.TechStacksForPosition.Java_and_Springboot:
      return "JAVA and Springboot";
    case import_types.TechStacksForPosition.NodeJs:
      return "Node";
    case import_types.TechStacksForPosition.Python_Django:
      return "Python (Django)";
    case import_types.TechStacksForPosition.Python_Flask:
      return "Python (Flask)";
    case import_types.TechStacksForPosition.ReactJs:
      return "React.js";
    case import_types.TechStacksForPosition.React_and_Java:
      return "React.js and JAVA";
    case import_types.TechStacksForPosition.Vanilla_Javascript:
      return "Vanilla Javascript";
    case import_types.TechStacksForPosition.Tech_Agnostic:
      return "Tech Agnostic";
    case import_types.TechStacksForPosition.DATA_ANALYTICS:
      return "Data Analytics";
    case import_types.TechStacksForPosition.NON_TECH:
      return "Non Tech";
    case import_types.TechStacksForPosition.AI_ENGINEER:
      return "AI";
    case import_types.TechStacksForPosition.Python:
      return "Python";
    case import_types.TechStacksForPosition.R:
      return "R";
    case import_types.TechStacksForPosition.MATLAB:
      return "MATLAB";
    case import_types.TechStacksForPosition.Excel:
      return "Excel";
    case import_types.TechStacksForPosition.SQL:
      return "SQL";
    case import_types.TechStacksForPosition.PowerBI:
      return "PowerBI";
    case import_types.TechStacksForPosition.Tableau:
      return "Tableau";
    case import_types.TechStacksForPosition.DIGITAL_MARKETING:
      return "Digital Marketing";
    case import_types.TechStacksForPosition.DOT_NET:
      return ".Net Developer";
    case import_types.TechStacksForPosition.CONTENT_CREATOR:
      return "Content Creator";
    case import_types.TechStacksForPosition.SOCIAL_MEDIA_EXECUTIVE:
      return "Social Media Executive";
    case import_types.TechStacksForPosition.DATA_ENGINEER:
      return "Data Engineer";
    default:
      return stack;
  }
};
var sanitizeContactInformationOfUser = (recommendations) => {
  return recommendations.map((r) => {
    const finalRec = r;
    finalRec.user.email = "";
    finalRec.user.phone = "";
    return finalRec;
  });
};
var designationMappingWithTechStack = {
  [import_types.PositionTitle.FRONTEND_ENGINEER]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.Vanilla_Javascript,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.ASSOCIATE_SOFTWARE_ENGINEER]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.Java_and_Springboot,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.BACKEND_ENGINEER]: [
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Java_and_Springboot,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.SOFTWARE_ENGINEER]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.SDE_ONE]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.FULL_STACK_ENGINEER]: [
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.React_and_Java,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.GRADUATE_ENGINEER_TRAINEE]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.SDE_TWO]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.SENIOR_SOFTWARE_ENGINEER]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.SDE_THREE]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.ENGINEERING_LEAD]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.ENGINEERING_MANAGER]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.TECH_LEAD]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.LEAD_DEVELOPER]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Python_Django,
    import_types.TechStacksForPosition.Python_Flask,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.INSTRUCTIONAL_ASSOCIATE]: [
    import_types.TechStacksForPosition.ReactJs,
    import_types.TechStacksForPosition.MERN,
    import_types.TechStacksForPosition.JAVA,
    import_types.TechStacksForPosition.NodeJs,
    import_types.TechStacksForPosition.Tech_Agnostic
  ],
  [import_types.PositionTitle.JUNIOR_SOFTWARE_TESTER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.JUNIOR_QA_TESTER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.QA_TESTER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.TEST_ANALYST]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.SOFTWARE_TESTER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.AUTOMATION_ENGINEER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.QA_ENGINEER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.MANUAL_TESTER]: [import_types.TechStacksForPosition.SDET],
  [import_types.PositionTitle.DATA_ANALYST]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.BUSINESS_ANALYST]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.MIS_EXECUTIVE]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.DATA_SCIENTIST]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.INSTRUCTIONAL_ASSOCIATE_DA]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.E_COMMERCE_OPERATIONS_ANALYST]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.TAG_IMPLEMENTATION]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.TECH_SUPPORT]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.CUSTOMER_SUPPORT_ENGINEER]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.SOLUTION_ENGINEER]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.MENTOR_ENGINEER]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.PROMPT_ENGINEER]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.ML_ENGINEER]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.AI_DEVELOPER]: [import_types.TechStacksForPosition.DATA_ANALYTICS],
  [import_types.PositionTitle.EVENTS_EXECUTION]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.EMAILS_EXECUTION]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.CONTENT_PUBLISHER]: [import_types.TechStacksForPosition.Tech_Agnostic],
  [import_types.PositionTitle.MARKETING]: [import_types.TechStacksForPosition.NON_TECH],
  [import_types.PositionTitle.SALES]: [import_types.TechStacksForPosition.NON_TECH],
  [import_types.PositionTitle.OPERATIONS]: [import_types.TechStacksForPosition.NON_TECH],
  [import_types.PositionTitle.OPERATION_EXECUTIVE]: [import_types.TechStacksForPosition.NON_TECH],
  [import_types.PositionTitle.MANAGEMENT_TRAINEE]: [import_types.TechStacksForPosition.NON_TECH],
  [import_types.PositionTitle.AI_ENGINEER]: [import_types.TechStacksForPosition.AI_ENGINEER],
  [import_types.PositionTitle.LLM_ENGINEER]: [import_types.TechStacksForPosition.AI_ENGINEER],
  [import_types.PositionTitle.RESEARCH_ANALYST_INTERN]: [
    import_types.TechStacksForPosition.Python,
    import_types.TechStacksForPosition.R,
    import_types.TechStacksForPosition.MATLAB,
    import_types.TechStacksForPosition.Excel,
    import_types.TechStacksForPosition.SQL,
    import_types.TechStacksForPosition.PowerBI,
    import_types.TechStacksForPosition.Tableau
  ],
  [import_types.PositionTitle.DIGITAL_MARKETING]: [import_types.TechStacksForPosition.DIGITAL_MARKETING],
  [import_types.PositionTitle.DOT_NET_DEVELOPER]: [import_types.TechStacksForPosition.DOT_NET],
  [import_types.PositionTitle.CONTENT_CREATOR]: [import_types.TechStacksForPosition.CONTENT_CREATOR],
  [import_types.PositionTitle.SOCIAL_MEDIA_EXECUTIVE]: [import_types.TechStacksForPosition.SOCIAL_MEDIA_EXECUTIVE],
  [import_types.PositionTitle.DATA_ENGINEER]: [import_types.TechStacksForPosition.DATA_ENGINEER]
};
var techStackMappingWithSkills = {
  [import_types.TechStacksForPosition.SDET]: [
    "Selenium",
    "Core Java",
    "Manual Testing",
    "Non Tech - First Impression",
    "Interviewing Skill",
    "Conceptual Understanding",
    "Debugging Skills",
    "Project Presentation"
  ],
  [import_types.TechStacksForPosition.DATA_ANALYTICS]: [
    "Python - Programming Language",
    "Python - EDA",
    "SQL",
    "PowerBI",
    "Excel",
    "Python",
    "Business Understanding",
    "Communication Skills",
    "Problem Solving Skills",
    "Data Science",
    "Dashboarding & Visualization"
  ],
  [import_types.TechStacksForPosition.MERN]: [
    "MongoDB",
    "Node & Express",
    "React",
    "Javascript",
    "HTML & CSS",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills"
  ],
  [import_types.TechStacksForPosition.ReactJs]: [
    "Javascript",
    "React",
    "Redux",
    "HTML & CSS",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "Fundamentals of Backend Dev."
  ],
  [import_types.TechStacksForPosition.JAVA]: [
    "Core Java",
    "SQL",
    "Object Oriented Design",
    "Spring",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "Frontend Framework Knowledge"
  ],
  [import_types.TechStacksForPosition.Java_and_Springboot]: [
    "Core Java",
    "SQL",
    "Object Oriented Design",
    "Spring",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "Frontend Framework Knowledge"
  ],
  [import_types.TechStacksForPosition.NodeJs]: [
    "Node & Express",
    "Javascript",
    "MongoDB",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "Frontend Framework Knowledge ",
    "Basics of Cloud Computing"
  ],
  [import_types.TechStacksForPosition.Vanilla_Javascript]: [
    "HTML & CSS",
    "Javascript",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "Fundamentals of Backend Dev."
  ],
  [import_types.TechStacksForPosition.Python_Django]: [
    "Python",
    "Django (Python)",
    "Django Rest Framework (DRF)",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "High Level Design",
    "Low Level Design"
  ],
  [import_types.TechStacksForPosition.Python_Flask]: [
    "Python",
    "Flask (Python)",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "High Level Design",
    "Low Level Design"
  ],
  [import_types.TechStacksForPosition.React_and_Java]: [
    "Javascript",
    "React",
    "Redux",
    "HTML & CSS",
    "DSA",
    "Problem Solving Skills",
    "Communication Skills",
    "Core Java",
    "SQL",
    "Object Oriented Design",
    "Spring"
  ],
  [import_types.TechStacksForPosition.Tech_Agnostic]: [
    "DSA",
    "Coding Skills",
    "Working Code",
    "Communication Skills",
    "Databases",
    "Non-Tech Communication",
    "Non Tech - First Impression",
    "Project Presentation",
    "Theoretical Skills"
  ],
  [import_types.TechStacksForPosition.NON_TECH]: ["Communication Skills", "Project Presentation", "Non Tech - First Impression"],
  [import_types.TechStacksForPosition.AI_ENGINEER]: ["LLMs", "RAG", "Python", "Prompt Engineering", "DSA", "Problem Solving Skills", "Communication Skills"],
  [import_types.TechStacksForPosition.Python]: [
    "Python",
    "Flask",
    "Django",
    "Quantitative Research",
    "Statistical Analysis",
    "Data Interpretation",
    "Backtesting",
    "Financial Modeling"
  ],
  [import_types.TechStacksForPosition.R]: [
    "R",
    "Statistical Analysis",
    "Quantitative Research",
    "Data Interpretation",
    "Risk Modeling"
  ],
  [import_types.TechStacksForPosition.MATLAB]: [
    "MATLAB",
    "Quantitative Research",
    "Risk Modeling",
    "Financial Modeling",
    "Derivatives",
    "Backtesting"
  ],
  [import_types.TechStacksForPosition.Excel]: [
    "Excel",
    "Financial Modeling",
    "Data Interpretation",
    "Market Analysis",
    "Equity Research"
  ],
  [import_types.TechStacksForPosition.SQL]: [
    "SQL",
    "Data Interpretation",
    "Quantitative Research",
    "Trading Strategies"
  ],
  [import_types.TechStacksForPosition.PowerBI]: [
    "PowerBI",
    "Data Interpretation",
    "Market Analysis",
    "Equity Research",
    "Trading Strategies"
  ],
  [import_types.TechStacksForPosition.Tableau]: [
    "Tableau",
    "Data Interpretation",
    "Market Analysis",
    "Equity Research",
    "Trading Strategies"
  ],
  [import_types.TechStacksForPosition.DIGITAL_MARKETING]: [
    "SEO",
    "SEM",
    "Google Analytics",
    "Data Analysis",
    "Content Management Systems (CMS)",
    "Paid Advertising Platforms",
    "Email Marketing & Marketing Automation",
    "Social Media Marketing",
    "Google Ads",
    "Meta Ads"
  ],
  [import_types.TechStacksForPosition.DOT_NET]: [
    "C#",
    "ASP.Net"
  ],
  [import_types.TechStacksForPosition.CONTENT_CREATOR]: [
    "Copywriting",
    "SEO Writing",
    "Video Editing",
    "Graphic Design",
    "Content Strategy",
    "Storytelling"
  ],
  [import_types.TechStacksForPosition.SOCIAL_MEDIA_EXECUTIVE]: [
    "Social Media Management",
    "Community Management",
    "Content Scheduling",
    "Platform Analytics",
    "Influencer Outreach",
    "Trend Analysis"
  ],
  [import_types.TechStacksForPosition.DATA_ENGINEER]: [
    "ETL",
    "Python",
    "Cloud",
    "SQL"
  ]
};
var generateRangeValuesArray = (range, startingNumber = 1) => {
  const rangeArray = new Array(range).fill(0).map((el, index) => ({
    label: String(startingNumber + index),
    value: String(startingNumber + index)
  }));
  return rangeArray;
};
var mustHaveSkillsIrrespectiveOfPosition = [
  "Communication Skills",
  "Coding Skills",
  "Conceptual Understanding",
  "Debugging Skills",
  "Interviewing Skill",
  "Non Tech - Communication",
  "Non Tech - First Impression",
  "Project Presentation",
  "Theoretical Skills",
  "Working Code"
];
var skillNameToIdMapping = {
  Aptitude: "65933c97cf0b9e8534443028",
  "Architecture Design": "649aa466c1afc4e2b99d97b3",
  "Backend Framework Knowledge": "6595a2503354f98c6a6491fb",
  "Basics of Cloud Computing": "6593447251be94d0b78123fc",
  "Coding Skills": "6454d5cc6f98fbd0a58d8236",
  "Collections (Java)": "659345dc51be94d0b7812d77",
  "Communication Skills": "6455057b6f98fbd0a58d82c7",
  "Complexity Analysis": "65797fff7c5153e799d13d9e",
  "Conceptual Understanding": "6454d5bd6f98fbd0a58d8235",
  "Core Java": "6536d279cde03b58aa151c1b",
  DSA: "64f5b8b9388460aab5631b79",
  Databases: "645505286f98fbd0a58d82c5",
  "Debugging Skills": "6454d59b6f98fbd0a58d8233",
  "Django (Python)": "64539d416f98fbd0a58d81b7",
  "Django Rest Framework (DRF)": "64539d416f98fbd0a58d81b7",
  "Flask (Python)": "64539d8f6f98fbd0a58d81ba",
  "Frontend Framework Knowledge": "6595a273d023df76c1637c22",
  "Fundamentals of Backend Dev.": "6455050e6f98fbd0a58d82c4",
  "HTML & CSS": "645398ab6f98fbd0a58d81ae",
  "In-Depth Knowldege": "65a14d7a91445a66514657c1",
  "Interviewing Skill": "645505536f98fbd0a58d82c6",
  "Java 8 Features": "659345b93b6aa4f3a825521f",
  Javascript: "645399cd6f98fbd0a58d81af",
  MongoDB: "653a8b5e516a8f0f726daa24",
  "Node & Express": "645504fb6f98fbd0a58d82c3",
  "Non Tech - Communication": "6454d60f6f98fbd0a58d8239",
  "Non Tech - First Impression": "6454d6206f98fbd0a58d823a",
  "Object Oriented Design": "649aa4c4a4b3a5b80cbbf63f",
  "Prior Tech Experience": "649aa4b4349a17517fd25b08",
  "Problem Solving Skills": "6454d5ae6f98fbd0a58d8234",
  "Project Presentation": "65933f9fcf0b9e8534443122",
  Python: "64e328c7e8d03e6c729b18fe",
  React: "64539cbc6f98fbd0a58d81b0",
  Redux: "64539cbc6f98fbd0a58d81b0",
  "Requirement Gathering": "649aa4a3c1afc4e2b99d97b7",
  SQL: "6459fffdce04b8b94151e05f",
  Spring: "64539d526f98fbd0a58d81b8",
  Selenium: "660c0d93c691d5fa6d6448ce",
  "System Design": "645a0026ce04b8b94151e060",
  "High Level Design": "645a0026ce04b8b94151e060",
  "Low Level Design": "645a0026ce04b8b94151e060",
  "Technical Communication": "657980128e4c384227861bc0",
  "Theoretical Skills": "652fb3c74b6474c8e83a63a2",
  "Tradeoff Analysis": "649aa494a4b3a5b80cbbf63e",
  "Working Code": "652fb3444b6474c8e83a41ca",
  Excel: "65f6bf3fd601d8ae46da1281",
  "Manual Testing": "660c0da85edd52ca29a0f7ff",
  PowerBI: "65f6c010897e1c6afc8dbb0f",
  "Business Understanding": "65f6bf88897e1c6afc8cdac6",
  "Python - Programming Language": "65f6bfba897e1c6afc8d2ff5",
  "Python - EDA": "65f6bfd6d601d8ae46dabcd1",
  "Data Science": "65f6c05897b8371cf2478095",
  "Dashboarding & Visualization": "65f6bff3897e1c6afc8d9533"
};
var allSkillsDropdownForPosition = Object.keys(skillNameToIdMapping).map((s) => ({
  label: s,
  value: s
}));
var getBUPriority = (positionType, subRole, isMDPOptIn) => {
  if (isMDPOptIn) {
    switch (positionType) {
      case import_types.WorkingMode.FULL_TIME:
        return 1;
      case import_types.WorkingMode.INTERNSHIP:
        return 0;
      case import_types.WorkingMode.INTERNSHIP_TO_FULL_TIME:
        return 1;
    }
  }
  if (positionType === import_types.WorkingMode.FULL_TIME) {
    switch (subRole) {
      case "MasaiStudent":
        return 0;
      case "MasaiTechInterns":
        return 2;
      case "MasaiYodha":
        return 3;
      case "MasaiAlum":
        return 4;
      case "CAP":
        return 5;
      case "MCL_LevelUp":
        return 6;
      case "CN":
        return 7;
      case "LevelUpExternal":
        return 8;
      default:
        return 9;
    }
  } else if (positionType === import_types.WorkingMode.INTERNSHIP_TO_FULL_TIME) {
    switch (subRole) {
      case "MasaiStudent":
        return 0;
      case "MasaiTechInterns":
        return 2;
      case "MasaiYodha":
        return 3;
      case "MCL_LevelUp":
        return 4;
      case "CAP":
        return 5;
      case "MasaiAlum":
        return 6;
      case "CN":
        return 7;
      case "LevelUpExternal":
        return 8;
      default:
        return 9;
    }
  } else {
    switch (subRole) {
      case "MCL_LevelUp":
        return 1;
      case "CAP":
        return 2;
      case "CN":
        return 3;
      case "LevelUpExternal":
        return 4;
      case "MasaiStudent":
        return 5;
      case "MasaiTechInterns":
        return 6;
      case "MasaiAlum":
        return 7;
      case "MasaiYodha":
        return 8;
      default:
        return 9;
    }
  }
};
var neighbourStatesMapping = {
  "Andaman and Nicobar Islands": ["Indian Ocean"],
  "Andhra Pradesh": ["Telangana", "Tamil Nadu", "Karnataka", "Odisha", "Chhattisgarh"],
  "Arunachal Pradesh": ["Assam", "Nagaland", "Myanmar", "Bhutan", "China"],
  Assam: ["Arunachal Pradesh", "Nagaland", "Manipur", "Mizoram", "Tripura", "Meghalaya", "West Bengal"],
  Bihar: ["Uttar Pradesh", "Jharkhand", "West Bengal"],
  Chandigarh: ["Punjab", "Haryana"],
  Chhattisgarh: ["Madhya Pradesh", "Maharashtra", "Telangana", "Odisha", "Jharkhand", "Uttar Pradesh"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Gujarat", "Maharashtra"],
  Delhi: ["Haryana", "Uttar Pradesh", "Rajasthan"],
  Goa: ["Maharashtra", "Karnataka"],
  Gujarat: ["Rajasthan", "Maharashtra", "Madhya Pradesh"],
  Haryana: ["Punjab", "Himachal Pradesh", "Uttarakhand", "Uttar Pradesh", "Rajasthan", "Delhi"],
  "Himachal Pradesh": ["Jammu and Kashmir", "Punjab", "Haryana", "Uttarakhand"],
  "Jammu and Kashmir": ["Punjab", "Himachal Pradesh"],
  Jharkhand: ["Bihar", "West Bengal", "Odisha", "Chhattisgarh"],
  Karnataka: ["Maharashtra", "Goa", "Kerala", "Tamil Nadu", "Telangana", "Andhra Pradesh"],
  Kerala: ["Karnataka", "Tamil Nadu"],
  Ladakh: ["Jammu and Kashmir", "China"],
  Lakshadweep: ["Indian Ocean"],
  "Madhya Pradesh": ["Rajasthan", "Gujarat", "Maharashtra", "Chhattisgarh", "Uttar Pradesh"],
  Maharashtra: ["Gujarat", "Madhya Pradesh", "Chhattisgarh", "Telangana", "Karnataka", "Goa"],
  Manipur: ["Nagaland", "Mizoram", "Assam"],
  Meghalaya: ["Assam", "Bangladesh"],
  Mizoram: ["Manipur", "Tripura", "Assam", "Bangladesh"],
  Nagaland: ["Manipur", "Arunachal Pradesh", "Assam"],
  Odisha: ["Jharkhand", "West Bengal", "Chhattisgarh", "Andhra Pradesh"],
  Puducherry: ["Tamil Nadu"],
  Punjab: ["Jammu and Kashmir", "Himachal Pradesh", "Haryana", "Rajasthan", "Chandigarh"],
  Rajasthan: ["Gujarat", "Madhya Pradesh", "Uttar Pradesh", "Haryana", "Punjab"],
  Sikkim: ["West Bengal", "Nepal", "Bhutan", "China"],
  "Tamil Nadu": ["Kerala", "Karnataka", "Andhra Pradesh"],
  Telangana: ["Maharashtra", "Chhattisgarh", "Karnataka", "Andhra Pradesh"],
  Tripura: ["Mizoram", "Assam", "Bangladesh"],
  "Uttar Pradesh": [
    "Uttarakhand",
    "Haryana",
    "Delhi",
    "Rajasthan",
    "Madhya Pradesh",
    "Chhattisgarh",
    "Bihar",
    "Jharkhand"
  ],
  Uttarakhand: ["Himachal Pradesh", "Haryana", "Uttar Pradesh", "Tibet", "Nepal"],
  "West Bengal": ["Bihar", "Jharkhand", "Odisha", "Sikkim", "Assam", "Bangladesh"]
};
var regionStateMapping = {
  North: [
    "Uttar Pradesh",
    "Haryana",
    "Delhi",
    "West Bengal",
    "Rajasthan",
    "Bihar",
    "Gujarat",
    "dadra and nagar haveli",
    "Jammu & Kashmir",
    "Punjab",
    "Chandigarh",
    "Jharkhand",
    "Uttrakhand",
    "Jammu & Kashmir",
    "Himachal Pradesh",
    "Assam",
    "Tripura"
  ],
  South: ["Karnataka", "Kerala", "Tamil Nadu", "Andhra Pradesh", "Telangana"],
  Central: ["Maharashtra", "Madhya Pradesh", "Odisha", "Chhattisgarh"]
};

// src/meeting.ts
init_cjs_shims();
var import_types2 = __toESM(require_dist());
var findCombinations = ({ templateConfigs }) => {
  const combinations = [];
  const allExperienceLevels = templateConfigs.map((config) => config.experienceLevel);
  allExperienceLevels.forEach((experienceLevel) => {
    const careerPaths = templateConfigs.filter((config) => config.experienceLevel === experienceLevel).map((config) => config.careerPath);
    careerPaths.forEach((careerPath) => {
      const developmentRoles = templateConfigs.filter((config) => config.experienceLevel === experienceLevel && config.careerPath === careerPath).map((config) => config.developmentRole);
      developmentRoles.forEach((developmentRole) => {
        const techStacks = templateConfigs.filter(
          (config) => config.experienceLevel === experienceLevel && config.careerPath === careerPath && config.developmentRole === developmentRole
        );
        techStacks.forEach((techStack) => {
          combinations.push(`${experienceLevel}-${careerPath}-${developmentRole}-${techStack}`);
        });
      });
    });
  });
  combinations.push("fresher-softwareDevelopment-backend-flask");
  combinations.push("twoPlusYears-softwareDevelopment-twoToFourYearsExperience-node");
  combinations.push("twoPlusYears-softwareDevelopment-twoToFourYearsExperience-react");
  combinations.push("twoPlusYears-softwareDevelopment-twoToFourYearsExperience-mern");
  return combinations;
};
var isScheduledOrOngoingMeeting = (status) => {
  return [import_types2.MeetingStatus.SCHEDULED, import_types2.MeetingStatus.STARTED].includes(status);
};
var isScheduledOrOngoingSession = (status) => {
  return [import_types2.SessionStatus.SCHEDULED, import_types2.SessionStatus.STARTED].includes(status);
};
var isCancelledMeeting = (status) => {
  return [
    import_types2.MeetingStatus.ADMINCANCELLED,
    import_types2.MeetingStatus.JOBSEEKERCANCELLED,
    import_types2.MeetingStatus.MENTORCANCELLED,
    import_types2.MeetingStatus.CANCELLED
  ].includes(status);
};
var isRescheduledMeeting = (status) => {
  return [
    import_types2.MeetingStatus.ADMINRESCHEDULED,
    import_types2.MeetingStatus.MENTORRESCHEDULED,
    import_types2.MeetingStatus.JOBSEEKERRESCHEDULED,
    import_types2.MeetingStatus.RESCHEDULED
  ].includes(status);
};
var isCancelledOrRescheduledMeeting = (status) => {
  return [
    import_types2.MeetingStatus.CANCELLED,
    import_types2.MeetingStatus.RESCHEDULED,
    import_types2.MeetingStatus.ADMINCANCELLED,
    import_types2.MeetingStatus.JOBSEEKERCANCELLED,
    import_types2.MeetingStatus.MENTORCANCELLED,
    import_types2.MeetingStatus.ADMINRESCHEDULED,
    import_types2.MeetingStatus.MENTORRESCHEDULED
  ].includes(status);
};
var sendMessageToParent = () => {
  if (window !== window.parent) {
    const message = { type: "levelup-redirect" };
    window.parent.postMessage(message, "*");
  }
};
var convertEnumToTitleCaseProfileTab = (enumValue) => {
  switch (enumValue) {
    case import_types2.UserCareerPathType.SOFTWARE_DEVELOPMENT:
      return "Software Development";
    case import_types2.UserCareerPathType.DATA_ANALYTICS:
      return "Data Analytics";
    case import_types2.UserCareerPathType.SDET:
      return "SDET";
    case import_types2.UserCareerPathType.TECH_SUPPORT:
      return "Tech Support";
    case import_types2.UserCareerPathType.OPERATIONS:
      return "Operations";
    case import_types2.UserCareerPathType.BD_EXECUTIVE:
      return "BD Executive";
    case import_types2.UserCareerPathType.DEV_OPS:
      return "DevOps";
    case import_types2.UserCareerPathType.MATH_ANNOTATIONS_EXPERT:
      return "Math Annotations Expert";
    case import_types2.UserCareerPathType.SITE_RELIABILITY_ENGINEER:
      return "Site Reliability Engineer";
    case import_types2.UserCareerPathType.SALES:
      return "Sales";
    case import_types2.UserCareerPathType.PRODUCT:
      return "Product";
    case import_types2.UserCareerPathType.HUMAN_RESOURCES:
      return "Human Resources";
    case import_types2.UserCareerPathType.MARKETING:
      return "Marketing";
    case import_types2.DevelopmentRoleType.FRONTEND:
      return "Frontend";
    case import_types2.DevelopmentRoleType.BACKEND:
      return "Backend";
    case import_types2.DevelopmentRoleType.FULL_STACK:
      return "Full Stack";
    case import_types2.DevelopmentRoleType.OTHER:
      return "Other";
    case import_types2.DevelopmentRoleType.DATA_ANALYST:
      return "Data Analyst";
    case import_types2.DevelopmentRoleType.DATA_SCIENTIST:
      return "Data Scientist";
    case import_types2.DevelopmentRoleType.TWO_TO_FOUR_YEARS:
      return "Two to Four Years Experience";
    case import_types2.DevelopmentRoleType.FOUR_PLUS_YEARS:
      return "Four Plus Years Experience";
    case import_types2.DevelopmentRoleType.SALES_B2C:
      return "Sales B2C";
    case import_types2.DevelopmentRoleType.SALES_B2B:
      return "Sales B2B";
    case import_types2.DevelopmentRoleType.PRODUCT_MANAGER:
      return "Product Manager";
    case import_types2.DevelopmentRoleType.HR_MANAGER:
      return "HR Manager";
    case import_types2.DevelopmentRoleType.DIGITAL_MARKETING:
      return "Digital Marketing";
    case import_types2.TechStackType.MEAN:
      return "MEAN";
    case import_types2.TechStackType.PYTHON:
      return "Python";
    case import_types2.TechStackType.MERN:
      return "MERN";
    case import_types2.TechStackType.DJANGO:
      return "Django";
    case import_types2.TechStackType.JAVA:
      return "Java";
    case import_types2.TechStackType.NODE:
      return "Node";
    case import_types2.TechStackType.REACT:
      return "React";
    case import_types2.TechStackType.ANGULAR:
      return "Angular";
    case import_types2.TechStackType.VUE:
      return "Vue";
    case import_types2.TechStackType.OTHER:
      return "Other";
    case import_types2.TechStackType.C_SHARP_ENGINEER:
      return "C# Engineer";
    default:
      return enumValue;
  }
};
var generateDevelopmentRoleTypeOptions = (roleType) => {
  switch (roleType) {
    case import_types2.DevelopmentRoleType.FRONTEND:
      return "Frontend";
    case import_types2.DevelopmentRoleType.BACKEND:
      return "Backend";
    case import_types2.DevelopmentRoleType.FULL_STACK:
      return "Full Stack";
    case import_types2.DevelopmentRoleType.OTHER:
      return "Other";
    case import_types2.DevelopmentRoleType.DATA_ANALYST:
      return "Data Analyst";
    case import_types2.DevelopmentRoleType.DATA_SCIENTIST:
      return "Data Scientist";
    case import_types2.DevelopmentRoleType.TWO_TO_FOUR_YEARS:
      return "Two to Four Years Experience";
    case import_types2.DevelopmentRoleType.FOUR_PLUS_YEARS:
      return "Four Plus Years Experience";
    case import_types2.DevelopmentRoleType.SALES_B2C:
      return "Sales B2C";
    case import_types2.DevelopmentRoleType.SALES_B2B:
      return "Sales B2B";
    case import_types2.DevelopmentRoleType.PRODUCT_MANAGER:
      return "Product Manager";
    case import_types2.DevelopmentRoleType.HR_MANAGER:
      return "HR Manager";
    case import_types2.DevelopmentRoleType.DIGITAL_MARKETING:
      return "Digital Marketing";
    case import_types2.DevelopmentRoleType.SENIOR_QA_ENGINEER:
      return "Senior QA Engineer";
    case import_types2.DevelopmentRoleType.SENIOR_HASKELL_ENGINEER:
      return "Senior Haskell Engineer";
    case import_types2.DevelopmentRoleType.SENIOR_REACT_NATIVE_DEVELOPER:
      return "Senior React Native Developer";
    default:
      return roleType;
  }
};
var generateTechStackTypeOptions = (techStackType) => {
  switch (techStackType) {
    case import_types2.TechStackType.MEAN:
      return "MEAN";
    case import_types2.TechStackType.PYTHON:
      return "Python";
    case import_types2.TechStackType.MERN:
      return "MERN";
    case import_types2.TechStackType.DJANGO:
      return "Django";
    case import_types2.TechStackType.JAVA:
      return "Java";
    case import_types2.TechStackType.NODE:
      return "Node";
    case import_types2.TechStackType.REACT:
      return "React";
    case import_types2.TechStackType.ANGULAR:
      return "Angular";
    case import_types2.TechStackType.VUE:
      return "Vue";
    case import_types2.TechStackType.FLASK:
      return "Flask";
    case import_types2.TechStackType.OTHER:
      return "Other";
    default:
      return techStackType;
  }
};
var generateCareerPathTypeOptions = (careerPathType) => {
  switch (careerPathType) {
    case import_types2.UserCareerPathType.SOFTWARE_DEVELOPMENT:
      return "Software Development";
    case import_types2.UserCareerPathType.DATA_ANALYTICS:
      return "Data Analytics";
    case import_types2.UserCareerPathType.SDET:
      return "SDET";
    case import_types2.UserCareerPathType.TECH_SUPPORT:
      return "Tech Support";
    case import_types2.UserCareerPathType.OPERATIONS:
      return "Operations";
    case import_types2.UserCareerPathType.BD_EXECUTIVE:
      return "BD Executive";
    case import_types2.UserCareerPathType.DEV_OPS:
      return "DevOps";
    case import_types2.UserCareerPathType.MATH_ANNOTATIONS_EXPERT:
      return "Math Annotations Expert";
    case import_types2.UserCareerPathType.SITE_RELIABILITY_ENGINEER:
      return "Site Reliability Engineer";
    case import_types2.UserCareerPathType.SALES:
      return "Sales";
    case import_types2.UserCareerPathType.PRODUCT:
      return "Product";
    case import_types2.UserCareerPathType.HUMAN_RESOURCES:
      return "Human Resources";
    case import_types2.UserCareerPathType.MARKETING:
      return "Marketing";
    case import_types2.UserCareerPathType.HASKELL:
      return "Haskell";
    case import_types2.UserCareerPathType.REACT_NATIVE:
      return "React Native";
    default:
      return careerPathType;
  }
};
var generateUserExperienceLevelTypeOptions = (experienceLevelType) => {
  switch (experienceLevelType) {
    case import_types2.UserExperienceLevelType.FINAL_YEAR_STUDENT:
      return "Final Year Student";
    case import_types2.UserExperienceLevelType.FRESHER:
      return "Fresher";
    case import_types2.UserExperienceLevelType.OneToTwoYears:
      return "1-2 Years";
    case import_types2.UserExperienceLevelType.TwoPlusYears:
      return "2+ Years";
    default:
      return experienceLevelType;
  }
};

// src/items.ts
var maxAttemptsOptions = new Array(11).fill(1).map((a, ind) => ({ value: String(ind), label: String(ind) }));
var skillTypeOptions = Object.values(import_types3.SkillType).map((s) => ({
  label: s,
  value: s
}));
var isSellableOptions = [
  {
    value: false,
    label: "No"
  },
  {
    value: true,
    label: "Yes"
  }
];
var adminRoleOptions = [
  { value: import_types3.UserRole.ADMIN, label: import_types3.UserRole.ADMIN },
  { value: import_types3.UserRole.SUPER_ADMIN, label: import_types3.UserRole.SUPER_ADMIN }
];
var accountManagerRoleOptions = [
  { value: import_types3.UserRole.ACCOUNT_MANAGER, label: import_types3.UserRole.ACCOUNT_MANAGER },
  { value: import_types3.UserRole.SUPER_ACCOUNT_MANAGER, label: import_types3.UserRole.SUPER_ACCOUNT_MANAGER }
];
var leadGenRoleOptions = [
  { value: import_types3.UserRole.LEAD_GEN, label: import_types3.UserRole.LEAD_GEN },
  { value: import_types3.UserRole.SUPER_LEAD_GEN, label: import_types3.UserRole.SUPER_LEAD_GEN }
];
var mentorUserRoleOptions = [
  {
    label: import_types3.UserRole.MENTOR,
    value: import_types3.UserRole.MENTOR
  },
  {
    label: import_types3.UserRole.AI_INTERVIEWER,
    value: import_types3.UserRole.AI_INTERVIEWER
  }
];
var alumniUserRoleOptions = [
  {
    label: import_types3.UserRole.ALUMNI_CONNECT,
    value: import_types3.UserRole.ALUMNI_CONNECT
  }
];
var mentorJobRoleOptions = [
  { value: "Full Stack Engineer", label: "Full Stack Engineer" },
  { value: "Frontend Engineer", label: "Frontend Engineer" },
  { value: "Backend Engineer", label: "Backend Engineer" },
  { value: "DSA", label: "DSA" },
  { value: "Data Analyst", label: "Data Analyst" },
  { value: "Data Scientist", label: "Data Scientist" }
];
var companyTypeOptions = [
  {
    label: "Large Enterprise (> 15 Yrs of existence)",
    value: import_types3.CompanyType.LARGE_ENTERPRISE
  },
  {
    label: "Medium Enterprise (> 10 Yrs of existence)",
    value: import_types3.CompanyType.MEDIUM_ENTERPRISE
  },
  {
    label: "Small Enterprise (> 5 Yrs of existence)",
    value: import_types3.CompanyType.SMALL_ENTERPRISE
  },
  {
    label: "Pre-Seed Or Bootstrap Or Seed Funded Startup",
    value: import_types3.CompanyType.PRE_SEED_OR_BOOTSTRAP_OR_SEED_FUNDED_STARTUP
  },
  {
    label: "Series A/B Funded Startup",
    value: import_types3.CompanyType.SERIES_AB_FUNDED_STARTUP
  },
  {
    label: "Sonicorn Or Unicorn Startup",
    value: import_types3.CompanyType.SONICORN_OR_UNICORN_STARTUP
  }
];
var companyNatureOptions = [
  {
    label: "Product",
    value: import_types3.CompanyNature.PRODUCT
  },
  {
    label: "Service",
    value: import_types3.CompanyNature.SERVICE
  }
];
var DURATION_OPTIONS = [
  { value: 100, label: 100 },
  { value: 120, label: 120 },
  { value: 75, label: 75 },
  { value: 60, label: 60 },
  { value: 45, label: 45 },
  { value: 30, label: 30 },
  { value: 15, label: 15 }
];
var allWeekDays = [
  import_types3.WeekDay.Sunday,
  import_types3.WeekDay.Monday,
  import_types3.WeekDay.Tuesday,
  import_types3.WeekDay.Wednesday,
  import_types3.WeekDay.Thursday,
  import_types3.WeekDay.Friday,
  import_types3.WeekDay.Saturday
];
var workingModeOptions = [
  {
    label: "Internship",
    value: import_types3.WorkingMode.INTERNSHIP
  },
  {
    label: "FullTime",
    value: import_types3.WorkingMode.FULL_TIME
  },
  {
    label: "InternshipToFullTime",
    value: import_types3.WorkingMode.INTERNSHIP_TO_FULL_TIME
  }
];
var positionTypeOptions = [
  {
    label: "Remote",
    value: import_types3.PositionType.REMOTE
  },
  {
    label: "Hybrid",
    value: import_types3.PositionType.HYBRID
  },
  {
    label: "Office",
    value: import_types3.PositionType.OFFICE
  }
];
var positionStatusOptions = [
  {
    label: "Open",
    value: import_types3.PositionStatus.OPEN
  },
  {
    label: "Closed",
    value: import_types3.PositionStatus.CLOSED
  }
];
var visibilityTypeOptions = Object.values(import_types3.VisibilityType).map((v) => ({
  label: v,
  value: v
}));
var completedMeetingStatuses = Object.values(import_types3.MeetingStatus).filter((s) => !isScheduledOrOngoingMeeting(s));
var sessionMeetingStatuses = Object.values(import_types3.SessionStatus).filter((s) => !isScheduledOrOngoingSession(s));
var conditionsOptions = [
  {
    value: "<",
    label: "<"
  },
  {
    value: "<=",
    label: "<="
  },
  {
    value: ">",
    label: ">"
  },
  {
    value: ">=",
    label: ">="
  },
  {
    value: "=",
    label: "="
  }
];
var gradYearOptions = new Array(31).fill(0).map((_, i) => {
  return { label: `${2e3 + i}`, value: `${2e3 + i}` };
});
var allowedRecruiterRoundActionApplicationStatuses = [
  import_types3.ApplicationStatus.SHORTLISTED,
  import_types3.ApplicationStatus.WAITING_FOR_RECRUITER_ACTION
];
var allowedMoveToNextRoundApplicationStatuses = [
  import_types3.ApplicationStatus.INTERVIEW_SCHEDULED,
  import_types3.ApplicationStatus.ASSIGNMENT_IN_PROGRESS,
  import_types3.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.CASE_STUDY_IN_PROGRESS,
  import_types3.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL
];
var allowedSendOfferLetterApplicationStatuses = [
  import_types3.ApplicationStatus.QUALIFIED_ALL_ROUNDS,
  import_types3.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
  import_types3.ApplicationStatus.OFFER_ROLLED_OUT,
  import_types3.ApplicationStatus.CHANGED_OFFER_TERMS,
  import_types3.ApplicationStatus.VERBALLY_PLACED,
  import_types3.ApplicationStatus.PLACED,
  import_types3.ApplicationStatus.OFFER_REVOKED
];
var allowedUpdateOfferLetterApplicationStatuses = [
  import_types3.ApplicationStatus.OFFER_ROLLED_OUT,
  import_types3.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
  import_types3.ApplicationStatus.CHANGED_OFFER_TERMS,
  import_types3.ApplicationStatus.PLACED
];
var activeApplicantStatuses = [
  import_types3.ApplicationStatus.SHORTLISTED,
  import_types3.ApplicationStatus.INTERVIEW_SCHEDULED,
  import_types3.ApplicationStatus.ASSIGNMENT_IN_PROGRESS,
  import_types3.ApplicationStatus.CASE_STUDY_IN_PROGRESS,
  import_types3.ApplicationStatus.OFFER_ROLLED_OUT,
  import_types3.ApplicationStatus.WAITING_FOR_RECRUITER_ACTION,
  import_types3.ApplicationStatus.QUALIFIED_ALL_ROUNDS,
  import_types3.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL,
  import_types3.ApplicationStatus.CHANGED_OFFER_TERMS
];
var inProgressApplicationStatuses = [
  import_types3.ApplicationStatus.INTERVIEW_SCHEDULED,
  import_types3.ApplicationStatus.ASSIGNMENT_IN_PROGRESS,
  import_types3.ApplicationStatus.CASE_STUDY_IN_PROGRESS,
  import_types3.ApplicationStatus.OFFER_ROLLED_OUT,
  import_types3.ApplicationStatus.WAITING_FOR_RECRUITER_ACTION,
  import_types3.ApplicationStatus.QUALIFIED_ALL_ROUNDS,
  import_types3.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL,
  import_types3.ApplicationStatus.CHANGED_OFFER_TERMS
];
var sendMessageToJSApplicationStatuses = [
  import_types3.ApplicationStatus.SHORTLISTED,
  import_types3.ApplicationStatus.INTERVIEW_SCHEDULED,
  import_types3.ApplicationStatus.ASSIGNMENT_IN_PROGRESS,
  import_types3.ApplicationStatus.CASE_STUDY_IN_PROGRESS,
  import_types3.ApplicationStatus.OFFER_ROLLED_OUT,
  import_types3.ApplicationStatus.QUALIFIED_ALL_ROUNDS,
  import_types3.ApplicationStatus.WAITING_FOR_RECRUITER_ACTION,
  import_types3.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL
];
var closedApplicationStatuses = [
  import_types3.ApplicationStatus.CLOSED_BY_ADMIN,
  import_types3.ApplicationStatus.CLOSED_BY_RECRUITER,
  import_types3.ApplicationStatus.EXPIRED,
  import_types3.ApplicationStatus.JOBSEEKER_OPTED_OUT,
  import_types3.ApplicationStatus.OFFER_REJECTED,
  import_types3.ApplicationStatus.PLACED,
  import_types3.ApplicationStatus.REJECTED,
  import_types3.ApplicationStatus.SCREEN_REJECTED,
  import_types3.ApplicationStatus.AUTO_REJECTED,
  import_types3.ApplicationStatus.PLACED_ELSEWHERE,
  import_types3.ApplicationStatus.VERBALLY_PLACED,
  import_types3.ApplicationStatus.OFFER_REVOKED
];
var closedApplicationRoundStatuses = [
  import_types3.ApplicationRoundStatus.Cancelled,
  import_types3.ApplicationRoundStatus.JobseekerOptedOut,
  import_types3.ApplicationRoundStatus.Rejected,
  import_types3.ApplicationRoundStatus.Qualified,
  import_types3.ApplicationRoundStatus.PlacedElseWhere,
  import_types3.ApplicationRoundStatus.Skipped
];
var dontAllowDirectOptOutApplicationStatuses = [
  import_types3.ApplicationStatus.SHORTLISTED,
  import_types3.ApplicationStatus.ASSIGNMENT_IN_PROGRESS,
  import_types3.ApplicationStatus.CASE_STUDY_IN_PROGRESS,
  import_types3.ApplicationStatus.CLOSED_BY_ADMIN,
  import_types3.ApplicationStatus.CLOSED_BY_RECRUITER,
  import_types3.ApplicationStatus.EXPIRED,
  import_types3.ApplicationStatus.INTERVIEW_SCHEDULED,
  import_types3.ApplicationStatus.JOBSEEKER_OPTED_OUT,
  import_types3.ApplicationStatus.OFFER_REJECTED,
  import_types3.ApplicationStatus.OFFER_ROLLED_OUT,
  import_types3.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
  import_types3.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL,
  import_types3.ApplicationStatus.PLACED,
  import_types3.ApplicationStatus.PLACED_ELSEWHERE,
  import_types3.ApplicationStatus.QUALIFIED_ALL_ROUNDS,
  import_types3.ApplicationStatus.REJECTED,
  import_types3.ApplicationStatus.WAITING_FOR_RECRUITER_ACTION
];
var ownershipOptions = Object.values(import_types3.CompanyOwnershipType).map((o) => ({ label: o, value: o }));
var natureOfBusinessOptions = Object.values(import_types3.NatureOfBusinessType).map((o) => ({
  label: o,
  value: o
}));
var positionTitleOptions = Object.values(import_types3.PositionTitle).map((p) => ({
  label: generatePositionTitle(p),
  value: p
}));
var mapPositionTitlesToDropdownOptions = (positionTitles) => {
  if (!positionTitles || positionTitles.length === 0) {
    return [];
  }
  return positionTitles.map((title) => ({
    label: title.label || title.name,
    value: title.name
  }));
};
var expectedJoiningOptions = [
  {
    label: "Immediate",
    value: "Immediate"
  },
  {
    label: "Within 1 month",
    value: "Within_1_month"
  },
  {
    label: "Within 3 months",
    value: "Within_3_months"
  },
  {
    label: "After 3 months",
    value: "After_3_months"
  }
];
var outOfPlacementTags = [
  import_types3.UserPlacementTags.Placed,
  import_types3.UserPlacementTags.Paused,
  import_types3.UserPlacementTags.AutoPaused,
  import_types3.UserPlacementTags.Recovery,
  import_types3.UserPlacementTags.OutOfPLacement,
  import_types3.UserPlacementTags.PrePlacement,
  import_types3.UserPlacementTags.VerballyPlaced,
  import_types3.UserPlacementTags.NotAvailable,
  "placed",
  "audit",
  "placement-paused",
  "oop",
  "Placement-Paused",
  "verbally-placed",
  "bep",
  "pre-placement",
  "pre-placements",
  "Audit",
  "recovery",
  "Recovery"
];
var behaviouralFlagsOptions = Object.values(import_types3.PositionUserBehaviouralFlag).map((p) => ({ label: p, value: p }));
var meetingTypeOptions = Object.values(import_types3.MeetingType).map((m) => ({ label: m, value: m }));
var allowPaymentForDriveApplication = [
  import_types3.DriveInviteeApplicationStatus.PENDING_PAYMENT,
  import_types3.DriveInviteeApplicationStatus.PAYMENT_FAILED,
  import_types3.DriveInviteeApplicationStatus.PENDING_FINAL_PAYMENT,
  import_types3.DriveInviteeApplicationStatus.FINAL_PAYMENT_FAILED
];
var allowFirstPayment = [
  import_types3.DriveInviteeApplicationStatus.PENDING_PAYMENT,
  import_types3.DriveInviteeApplicationStatus.PAYMENT_FAILED
];
var allowSecondPayment = [
  import_types3.DriveInviteeApplicationStatus.PENDING_FINAL_PAYMENT,
  import_types3.DriveInviteeApplicationStatus.FINAL_PAYMENT_FAILED
];

// src/date.utils.ts
init_cjs_shims();
var import_moment = __toESM(require_moment());
var import_types4 = __toESM(require_dist());
var getDateValues = (countDown) => {
  const hours = Math.floor(countDown % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
  const minutes = Math.floor(countDown % (1e3 * 60 * 60) / (1e3 * 60));
  const seconds = Math.floor(countDown % (1e3 * 60) / 1e3);
  return [hours, minutes, seconds];
};
var timeGapConvertor = (startTime, endTime) => {
  if (!startTime)
    return "";
  const startDate = new Date(startTime);
  const currentTime = new Date();
  const endDate = endTime ? new Date(endTime) : currentTime;
  const diffInMilliseconds = endDate.getTime() - startDate.getTime();
  const diffInMonths = Math.floor(diffInMilliseconds / (1e3 * 60 * 60 * 24 * 30));
  const diffInYears = Math.floor(diffInMonths / 12);
  const remainingMonths = diffInMonths % 12;
  if (diffInYears && remainingMonths) {
    return `${diffInYears} ${diffInYears > 1 ? " Years " : " Year "} ${remainingMonths}${remainingMonths > 1 ? " Months" : " Month"}`;
  } else if (diffInYears) {
    return `${diffInYears} ${diffInYears > 1 ? " Years" : " Year"}`;
  } else {
    return `${remainingMonths} ${remainingMonths > 1 ? " Months" : " Month"}`;
  }
};
var checkIsFutureDate = (selectDate) => {
  const currentDate = (0, import_moment.default)();
  const selectedDate = (0, import_moment.default)(selectDate);
  const isFuture = selectedDate.isAfter(currentDate);
  if (isFuture) {
    return true;
  } else {
    return false;
  }
};
var formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const remainingSeconds = seconds % 60;
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");
  return {
    formattedHours,
    formattedMinutes,
    formattedSeconds
  };
};
var convertDays = (day) => {
  return day !== import_types4.WeekDay.Thursday ? day.substring(0, 3).toUpperCase() : day.substring(0, 4).toUpperCase();
};
var convertedDateFromDateType = (date) => {
  if (!date)
    return new Date();
  else
    return new Date(date);
};
var getAllDatesInRange = (startDate, endDate) => {
  const dates = [];
  while (startDate.valueOf() <= endDate.valueOf()) {
    dates.push(startDate);
    startDate = (0, import_moment.default)(startDate).add(1, "day").toDate();
  }
  return dates;
};
var groupAvailabilityByDurationAndDate = (availabilities) => {
  const availabilitiesByDurationAndWeekday = availabilities.reduce((acc, crr) => {
    let date = (0, import_moment.default)(crr.startTime).format("DD-MM-YYYY");
    if (acc[crr.duration]) {
      let duration = acc[crr.duration];
      if (duration[date]) {
        duration[date].push(crr);
      } else {
        duration[date] = [crr];
      }
    } else {
      acc[crr.duration] = {
        [date]: [crr]
      };
    }
    return acc;
  }, {});
  return availabilitiesByDurationAndWeekday;
};
var getExpiryDateInWorkingHours = (minutes, todaysDate) => {
  let minutesToBeAdded = 0;
  const currentDate = (0, import_moment.default)(todaysDate);
  const todaysEndingDate = (0, import_moment.default)(todaysDate).endOf("day").subtract(8.5, "hours");
  const minutesLeftToday = Math.max(todaysEndingDate.diff(currentDate, "minutes"), 0);
  console.log({ currentDate, todaysEndingDate, minutesLeftToday });
  if (minutesLeftToday >= minutes)
    return minutes;
  const carriedForwardWorkingMinutes = minutes - minutesLeftToday;
  const tomorrowStartingDate = (0, import_moment.default)(todaysDate).add(1, "day").startOf("day").add(3.5, "hours").toDate();
  const carriedForwardMinutess = getExpiryDateInWorkingHours(carriedForwardWorkingMinutes, tomorrowStartingDate);
  minutesToBeAdded = minutesLeftToday + 12 * 60 + carriedForwardMinutess;
  console.log({ finalMinutes: minutesToBeAdded });
  return minutesToBeAdded;
};
var convertTimeToMonthYearString = (inputDate) => {
  const date = new Date(inputDate);
  const options = { year: "numeric", month: "short" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  return formattedDate;
};
var ordinalSuffixOf = (i, withNumber = true) => {
  let j = i % 10, k = i % 100;
  if (j === 1 && k !== 11) {
    return withNumber ? i + "st" : "st";
  }
  if (j === 2 && k !== 12) {
    return withNumber ? i + "nd" : "nd";
  }
  if (j === 3 && k !== 13) {
    return withNumber ? i + "rd" : "rd";
  }
  return withNumber ? i + "th" : "th";
};
var formatNumberWithSuffix = (number) => {
  const suffixes = ["", "k", "M", "B", "T"];
  const magnitude = Math.floor(Math.log10(number) / 3);
  const suffixIndex = Math.min(magnitude, suffixes.length - 1);
  const scaledNumber = number / Math.pow(10, suffixIndex * 3);
  const formattedNumber = scaledNumber.toFixed(0);
  return formattedNumber + suffixes[suffixIndex];
};
var formatTimeDifference = (startDate, endDate) => {
  const diffInMilliseconds = endDate.getTime() - startDate.getTime();
  const durationInMinutes = Math.floor(diffInMilliseconds / (1e3 * 60));
  const minutes = durationInMinutes % 60;
  const hours = Math.floor(durationInMinutes / 60) % 24;
  const days = Math.floor(durationInMinutes / (60 * 24));
  const formatPart = (value, label) => {
    if (value === 0)
      return "";
    return `${value.toString().padStart(2, "0")} ${label}${value > 1 ? "s" : ""}`;
  };
  const daysStr = formatPart(days, "day");
  const hoursStr = formatPart(hours, "hr");
  const minutesStr = formatPart(minutes, "min");
  const parts = [daysStr, hoursStr, minutesStr].filter(Boolean);
  if (parts.length === 0)
    return "0 min";
  return parts.join(" ");
};
var csvToJson = (csvText) => {
  const lines = csvText.split("\n");
  const headers = lines[0].split(",").map((header) => header.trim());
  return lines.slice(1).map((line) => {
    const values = line.split(",").map((value) => value.trim());
    return headers.reduce((obj, header, index) => {
      obj[header] = values[index];
      return obj;
    }, {});
  });
};

// src/checkUserRole.ts
init_cjs_shims();
var import_types5 = __toESM(require_dist());
var isUserAdmin = (role) => {
  return [import_types5.UserRole.ADMIN, import_types5.UserRole.SUPER_ADMIN].includes(role);
};
var isUserSuperAdmin = (role) => {
  return [import_types5.UserRole.SUPER_ADMIN].includes(role);
};
var isUserAccountManager = (role) => {
  return [import_types5.UserRole.ACCOUNT_MANAGER, import_types5.UserRole.SUPER_ACCOUNT_MANAGER].includes(role);
};
var isUserSuperAccountManager = (role) => {
  return [import_types5.UserRole.SUPER_ACCOUNT_MANAGER, import_types5.UserRole.DRIVE_ADMIN].includes(role);
};
var isUserAlumniConnect = (role) => {
  return [import_types5.UserRole.ALUMNI_CONNECT].includes(role);
};
var isUserMentor = (role) => {
  return [import_types5.UserRole.MENTOR, import_types5.UserRole.AI_INTERVIEWER].includes(role);
};
var isUserJobseeker = (role) => {
  return [import_types5.UserRole.JOBSEEKER, import_types5.UserRole.EXPERIENCED_JOBSEEKER].includes(role);
};
var isUserRecruiter = (role) => {
  return [import_types5.UserRole.RECRUITER].includes(role);
};
var isUserUniversityManager = (role) => {
  return [import_types5.UserRole.UNIVERSITY_REPRESENTATIVE].includes(role);
};
var isUserDriveAdmin = (role) => {
  return [import_types5.UserRole.DRIVE_ADMIN].includes(role);
};
var isUserLeadGen = (role) => {
  return [import_types5.UserRole.LEAD_GEN, import_types5.UserRole.SUPER_LEAD_GEN].includes(role);
};
var isUserSuperLeadGen = (role) => {
  return [import_types5.UserRole.SUPER_LEAD_GEN].includes(role);
};
var canUndoScreenRejection = (user) => {
  var _a;
  const allowedRoles = ((_a = user == null ? void 0 : user.allowedRoles) == null ? void 0 : _a.length) ? user.allowedRoles : (user == null ? void 0 : user.role) ? [user.role] : [];
  return allowedRoles.includes(import_types5.UserRole.SUPER_ACCOUNT_MANAGER) && allowedRoles.includes(import_types5.UserRole.SUPER_ADMIN);
};

// src/handler.ts
init_cjs_shims();
var generateUniqueHandler = (userName) => {
  const uniqueIdentifier = Date.now().toString();
  const uniqueHandler = `${userName.replace(" ", "").replace(".", "")}_${uniqueIdentifier}`;
  return uniqueHandler;
};

// src/preferedLocationOptions.ts
init_cjs_shims();
var locationPreferenceOptions = [
  "Remote",
  "Bengaluru, Karnataka",
  "Mumbai, Maharashtra",
  "Hyderabad, Telangana",
  "Pune, Maharashtra",
  "Chennai, Tamil Nadu",
  "Hosur, Tamil Nadu",
  "Gurugram, Haryana",
  "Noida, Uttar Pradesh",
  "Delhi, National Capital Territory",
  "Kolkata, West Bengal",
  "Ahmedabad, Gujarat",
  "Jaipur, Rajasthan",
  "Kochi, Kerala",
  "Chandigarh, Union Territory",
  "Coimbatore, Tamil Nadu",
  "Lucknow, Uttar Pradesh",
  "Bhubaneswar, Odisha",
  "Surat, Gujarat",
  "Visakhapatnam, Andhra Pradesh",
  "Nagpur, Maharashtra",
  "Vadodara, Gujarat",
  "Mysuru, Karnataka",
  "Thiruvananthapuram, Kerala",
  "Bhopal, Madhya Pradesh",
  "Ludhiana, Punjab",
  "Kanpur, Uttar Pradesh",
  "Amritsar, Punjab",
  "Dehradun, Uttarakhand",
  "Raipur, Chhattisgarh",
  "Patna, Bihar",
  "Ranchi, Jharkhand",
  "Guwahati, Assam",
  "Goa, Goa",
  "Shimla, Himachal Pradesh",
  "Jammu, Jammu and Kashmir",
  "Puducherry, Union Territory",
  "Agra, Uttar Pradesh",
  "Varanasi, Uttar Pradesh",
  "Nashik, Maharashtra",
  "Aurangabad, Maharashtra",
  "Rajkot, Gujarat",
  "Jamshedpur, Jharkhand",
  "Mangalore, Karnataka",
  "Cochin, Kerala",
  "Udaipur, Rajasthan",
  "Vijayawada, Andhra Pradesh",
  "Cuttack, Odisha",
  "Jodhpur, Rajasthan",
  "Siliguri, West Bengal",
  "Allahabad, Uttar Pradesh",
  "Madurai, Tamil Nadu",
  "Mohali, Punjab",
  "Indore, Madhya Pradesh",
  "Navi Mumbai, Maharashtra",
  "Thane, Maharashtra",
  "Waterford, Ireland",
  "Ambala, Haryana",
  "Panchkula, Haryana",
  "Gondia, Maharashtra",
  "Bareilly, Uttar Pradesh",
  "Purnia, Bihar",
  "Hubli, Karnataka",
  "Other",
  "Ropar",
  "Jalandhar, Punjab",
  "Daman, Daman and Diu",
  "Diu, Daman and Diu",
  "Silvassa, Daman and Diu",
  "Amli, Daman and Diu",
  "Port Blair, Andaman and Nicobar Islands",
  "Rangat, Andaman and Nicobar Islands",
  "Diglipur, Andaman and Nicobar Islands",
  "Mayabunder, Andaman and Nicobar Islands",
  "Leh, Ladakh"
];

// src/round.ts
init_cjs_shims();
var findRemainingAttempts = (attempts, meetings) => {
  const completedMeetings = meetings.filter(
    (meeting) => meeting.isConsideredAttempt
  ).length;
  const remainingAttempts = attempts - completedMeetings;
  return Math.max(remainingAttempts, 0);
};

// src/skill.ts
init_cjs_shims();
function createItemsById(items, key = "_id") {
  const itemsById = {};
  items.forEach((item) => {
    const keyValue = item[key];
    itemsById[keyValue] = item;
  });
  return itemsById;
}
var displaySkillListForRecruiter = [
  "React",
  "Node",
  "MongoDB",
  "JavaScript",
  "Redux",
  "HTML & CSS",
  "Spring",
  "Java",
  "Flask",
  "Django",
  "Strong Communication",
  "Problem Solving",
  "Data Structures & Algorithms (DSA)",
  "High Level Design (HLD)",
  "Low Level Design (LLD)",
  "SQL",
  "Python",
  "Coding Skills",
  "Conceptual Understanding",
  "Fundamentals of Backend Dev"
].map((s) => ({ label: s, value: s }));
var generateProductSkillsForDisplayNames = (skill) => {
  switch (skill) {
    case "React":
      return ["React"];
    case "Node":
      return ["Node", "Node & Express"];
    case "MongoDB":
      return ["MongoDB", "Databases"];
    case "JavaScript":
      return ["Javascript", "Modern JS"];
    case "Redux":
      return ["Redux"];
    case "HTML & CSS":
      return ["HTML & CSS"];
    case "Spring":
      return ["Spring"];
    case "Java":
      return ["Core Java", "Java"];
    case "Flask":
      return ["Flask (Python)"];
    case "Django":
      return ["Django (Python)", "Django Rest Framework (DRF)"];
    case "Strong Communication":
      return ["Communication Skills", "Non Tech - First Impression", "Non Tech - Communication", "Interviewing Skill"];
    case "Problem Solving":
      return ["Problem Solving Skills"];
    case "Data Structures & Algorithms (DSA)":
      return ["DSA"];
    case "High Level Design (HLD)":
      return [
        "Architecture Design",
        "Data Modelling",
        "Understanding of Technologies and Infrastructure",
        "Tradeoff Analysis",
        "Requirement Gathering",
        "Estimations"
      ];
    case "Low Level Design (LLD)":
      return ["Object Oriented Design", "Requirement Gathering"];
    case "SQL":
      return ["SQL"];
    case "Python":
      return ["Python"];
    case "Coding Skills":
      return ["Coding Skills", " Working Code"];
    case "Conceptual Understanding":
      return ["Conceptual Understanding"];
    case "Fundamentals of Backend Dev":
      return ["Fundamentals of Backend Dev."];
    default:
      return [skill];
  }
};

// src/getNextAssessmentTokenDetails.ts
init_cjs_shims();
var getNextAssessmentTokenDetails = (currTokenDetails, meeting) => {
  return true;
};

// src/logic/checkUserEligibilityForSecondRound.ts
init_cjs_shims();
var checkUserEligibilityForSecondRound = (user) => {
  var _a, _b;
  const isResumeUploaded = Boolean((_a = user == null ? void 0 : user.profile) == null ? void 0 : _a.resumeLink);
  const isVideoResumeUploaded = Boolean((_b = user == null ? void 0 : user.profile) == null ? void 0 : _b.videoResume);
  const isEligible = !!isResumeUploaded && !!isVideoResumeUploaded;
  return {
    isEligible,
    isResumeUploaded,
    isVideoResumeUploaded
  };
};

// src/score.ts
init_cjs_shims();
var import_moment2 = __toESM(require_moment());
function getDecayFactor(n) {
  const factor = (0.5 * Math.exp(-Math.pow(n, 2) / 12e4) + Math.exp(-Math.pow(n + 120, 2) / 12e4)) / (1.5 * 0.925);
  return factor;
}
function getLatestInterview(interviews, currentDate) {
  const sorted = interviews.sort(
    (a, b) => (0, import_moment2.default)(a.meeting.startTime).isBefore((0, import_moment2.default)(b.meeting.startTime)) ? 1 : -1
  );
  let latestInterview = { score: 0, timeDifferenceInDays: 0 };
  if (sorted.length) {
    latestInterview.score = sorted[0].score;
    latestInterview.timeDifferenceInDays = Math.max(
      (0, import_moment2.default)(currentDate).diff((0, import_moment2.default)(sorted[0].meeting.startTime), "days"),
      0
    );
  }
  return latestInterview;
}
function calculateMedian(scores, currentDate) {
  if (scores.length === 0) {
    return null;
  }
  scores.sort((a, b) => a.score - b.score);
  const middleIndex = Math.floor(scores.length / 2);
  if (scores.length % 2 === 0) {
    const medianDate = new Date(
      (scores[middleIndex - 1].meeting.startTime.getTime() + scores[middleIndex].meeting.startTime.getTime()) / 2
    );
    return {
      score: (scores[middleIndex - 1].score + scores[middleIndex].score) / 2,
      timeDifferenceInDays: Math.max(
        (0, import_moment2.default)(currentDate).diff((0, import_moment2.default)(medianDate), "days"),
        0
      )
    };
  } else {
    return {
      score: scores[middleIndex].score,
      timeDifferenceInDays: Math.max(
        (0, import_moment2.default)(currentDate).diff(
          (0, import_moment2.default)(scores[middleIndex].meeting.startTime),
          "days"
        ),
        0
      )
    };
  }
}
var getTimeScore = (timeTaken, idealTime) => {
  if (timeTaken <= idealTime + 60)
    return 1;
  return 0.5;
};

// src/positionClosure.ts
init_cjs_shims();
var import_moment3 = __toESM(require_moment());
var import_types6 = __toESM(require_dist());
var POSITION_CLOSURE_REASON = {
  POSITION_FILLED_ON_LEVELUP: "Position filled on LevelUp",
  POSITION_FILLED_ELSEWHERE: "Position filled elsewhere",
  MISSING_IN_ACTION: "Missing in Action (MIA)",
  OTHER: "Other"
};
var RESTRICTED_POSITION_CLOSURE_REASONS = [
  POSITION_CLOSURE_REASON.OTHER,
  POSITION_CLOSURE_REASON.MISSING_IN_ACTION
];
var SUPER_ADMIN_ONLY_POSITION_CLOSURE_REASONS = RESTRICTED_POSITION_CLOSURE_REASONS;
var POSITION_CLOSURE_MIA_OTHER_ACCESS_MESSAGE = "Only users with both Super Account Manager and Super Admin access can close a position with this reason.";
var positionClosureEligibleApplicationStatuses = [
  import_types6.ApplicationStatus.REJECTED,
  import_types6.ApplicationStatus.SCREEN_REJECTED,
  import_types6.ApplicationStatus.AUTO_REJECTED,
  import_types6.ApplicationStatus.OFFER_REJECTED,
  import_types6.ApplicationStatus.PLACED_ELSEWHERE,
  import_types6.ApplicationStatus.PLACED
];
var POSITION_CLOSURE_INELIGIBLE_APPLICANTS_MESSAGE = "Position cannot be closed until all applicants in the Applicants tab are moved to Rejected, Screen Rejected, Rejected Offer, Placed Elsewhere, Placed, or Ongoing Round Movement Rejected status.";
var applicantsTabApplicationWhereClause = {
  $or: [
    { status: import_types6.ApplicationStatus.SHORTLISTED },
    { "history.newStatus": import_types6.ApplicationStatus.SHORTLISTED }
  ]
};
var activeApplicantsTabApplicationWhereClause = {
  $and: [
    applicantsTabApplicationWhereClause,
    {
      status: {
        $nin: [
          import_types6.ApplicationStatus.REJECTED,
          import_types6.ApplicationStatus.SCREEN_REJECTED,
          import_types6.ApplicationStatus.AUTO_REJECTED
        ]
      }
    }
  ]
};
var canClosePositionWithMIAOrOther = (user) => {
  var _a;
  const allowedRoles = ((_a = user == null ? void 0 : user.allowedRoles) == null ? void 0 : _a.length) ? user.allowedRoles : (user == null ? void 0 : user.role) ? [user.role] : [];
  return allowedRoles.includes(import_types6.UserRole.SUPER_ACCOUNT_MANAGER) && allowedRoles.includes(import_types6.UserRole.SUPER_ADMIN);
};
var getPositionClosureReasonOptions = (canUseMIAOrOther) => {
  const baseOptions = [
    POSITION_CLOSURE_REASON.POSITION_FILLED_ON_LEVELUP,
    POSITION_CLOSURE_REASON.POSITION_FILLED_ELSEWHERE
  ];
  if (canUseMIAOrOther) {
    return [...baseOptions, POSITION_CLOSURE_REASON.MISSING_IN_ACTION, POSITION_CLOSURE_REASON.OTHER];
  }
  return baseOptions;
};
var requiresApplicantStatusValidationForPositionClosure = (role) => {
  return isUserAccountManager(role) || isUserSuperAccountManager(role);
};
var isRestrictedPositionClosureReason = (reason) => {
  return !!reason && RESTRICTED_POSITION_CLOSURE_REASONS.includes(reason);
};
var isSuperAdminOnlyPositionClosureReason = isRestrictedPositionClosureReason;
var canUserSelectPositionClosureReason = (reason, user) => {
  if (isRestrictedPositionClosureReason(reason)) {
    return canClosePositionWithMIAOrOther(user);
  }
  return true;
};
var isPositionClosureEligibleApplicationStatus = (status) => {
  return positionClosureEligibleApplicationStatuses.includes(status);
};
var isVerballyPlacedApplicationBlockingClosure = (status) => {
  return status === import_types6.ApplicationStatus.VERBALLY_PLACED;
};
var hasPlacedElsewhereOnApplication = (applicationStatus, history) => {
  return applicationStatus === import_types6.ApplicationStatus.PLACED_ELSEWHERE || !!(history == null ? void 0 : history.some((entry) => entry.newStatus === import_types6.ApplicationStatus.PLACED_ELSEWHERE));
};
var isPlacedElsewhereWithVerballyPlacedStudentEligibleForClosure = (applicationStatus, userPlacementStatus, history) => {
  return userPlacementStatus === import_types6.UserPlacementTags.VerballyPlaced && hasPlacedElsewhereOnApplication(applicationStatus, history);
};
var isPositionClosureEligibleApplication = (application) => {
  if (!application)
    return true;
  if (isVerballyPlacedApplicationBlockingClosure(application.status))
    return false;
  if (application.status && isPositionClosureEligibleApplicationStatus(application.status))
    return true;
  if (isPlacedElsewhereWithVerballyPlacedStudentEligibleForClosure(
    application.status,
    application.userPlacementStatus,
    application.history
  )) {
    return true;
  }
  return false;
};
var isApplicationExpiredForPositionClosure = (application) => {
  if (!application)
    return false;
  if (application.status === import_types6.ApplicationStatus.EXPIRED)
    return true;
  if (application.expiryDate && (0, import_moment3.default)(application.expiryDate).isBefore((0, import_moment3.default)()))
    return true;
  return false;
};
var getMeaningfulStatusesAfterShortlist = (history) => {
  const shortlistIndex = history.findIndex((h) => h.newStatus === import_types6.ApplicationStatus.SHORTLISTED);
  if (shortlistIndex < 0)
    return [];
  return history.slice(shortlistIndex + 1).map((h) => h.newStatus).filter((status) => status !== import_types6.ApplicationStatus.SHORTLISTED);
};
var isNoActionAfterShortlistApplication = (application) => {
  var _a;
  if (!application)
    return false;
  const hasAppliedByJobSeeker = !!((_a = application.history) == null ? void 0 : _a.some(
    (h) => h.newStatus === import_types6.ApplicationStatus.APPLIED_BY_JOBSEEKER
  ));
  if (!hasAppliedByJobSeeker)
    return false;
  const history = application.history || [];
  if (!history.some((h) => h.newStatus === import_types6.ApplicationStatus.SHORTLISTED))
    return false;
  const statusesAfterShortlist = getMeaningfulStatusesAfterShortlist(history);
  const allowedClosureStatuses = [import_types6.ApplicationStatus.CLOSED_BY_RECRUITER, import_types6.ApplicationStatus.CLOSED_BY_ADMIN];
  if (application.status === import_types6.ApplicationStatus.SHORTLISTED) {
    return statusesAfterShortlist.length === 0;
  }
  if (application.status === import_types6.ApplicationStatus.CLOSED_BY_RECRUITER || application.status === import_types6.ApplicationStatus.CLOSED_BY_ADMIN) {
    return statusesAfterShortlist.length === 0 || statusesAfterShortlist.every((status) => allowedClosureStatuses.includes(status));
  }
  return false;
};
var isMIAOtherClosureEligibleApplication = (application) => {
  if (!application)
    return true;
  if (isVerballyPlacedApplicationBlockingClosure(application.status))
    return false;
  if (application.status && isPositionClosureEligibleApplicationStatus(application.status))
    return true;
  if (isNoActionAfterShortlistApplication(application))
    return true;
  if (isPlacedElsewhereWithVerballyPlacedStudentEligibleForClosure(
    application.status,
    application.userPlacementStatus,
    application.history
  )) {
    return true;
  }
  return false;
};
var isMIAOrOtherClosureReason = (reason) => {
  return isRestrictedPositionClosureReason(reason);
};
var resolveClosingPositionReason = (reason, otherReason) => {
  if (reason === POSITION_CLOSURE_REASON.OTHER && (otherReason == null ? void 0 : otherReason.trim())) {
    return otherReason.trim();
  }
  return reason;
};

// src/positionDownloadCsv.ts
init_cjs_shims();
var import_types7 = __toESM(require_dist());
var LINK_OPTIONS = ["github", "deployment", "drive", "googleCollab", "submission", "noSubmission", "other"];
var FILE_OPTIONS = ["pdf", "doc", "docx", "zip", "excel", "other"];
var linkSubmissionColumnKey = (opt) => `submission_${opt}`;
var fileSubmissionColumnKey = (opt) => opt === "other" ? "submission_file_other" : `submission_${opt}`;
var ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS = LINK_OPTIONS.map(linkSubmissionColumnKey);
var ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS = FILE_OPTIONS.map(fileSubmissionColumnKey);
var ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY = "submission_legacy";
var buildAssignmentSubmissionFields = (latestSubmission) => {
  var _a, _b;
  const fields = {};
  LINK_OPTIONS.forEach((opt) => {
    fields[linkSubmissionColumnKey(opt)] = "";
  });
  FILE_OPTIONS.forEach((opt) => {
    fields[fileSubmissionColumnKey(opt)] = "";
  });
  fields[ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY] = "";
  if ((_a = latestSubmission == null ? void 0 : latestSubmission.submittedLinks) == null ? void 0 : _a.length) {
    latestSubmission.submittedLinks.forEach((link) => {
      if (link == null ? void 0 : link.type) {
        fields[linkSubmissionColumnKey(link.type)] = link.url || "";
      }
    });
  } else if (latestSubmission == null ? void 0 : latestSubmission.submissionLink) {
    fields[ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY] = latestSubmission.submissionLink;
  }
  if ((_b = latestSubmission == null ? void 0 : latestSubmission.submittedFiles) == null ? void 0 : _b.length) {
    latestSubmission.submittedFiles.forEach((file) => {
      if (!(file == null ? void 0 : file.type))
        return;
      const key = fileSubmissionColumnKey(file.type);
      fields[key] = file.fileUrl ? [file.fileName, file.fileUrl].filter(Boolean).join(" | ") : file.fileName || "";
    });
  }
  return fields;
};
var getAssignmentSubmissionsDownloadColumns = () => [
  "name",
  "email",
  "phone",
  "roundNumber",
  "studentCode",
  "resumeLink",
  "assignmentLink",
  "assignmentDocumentLink",
  "assignmentSubmissionType",
  "assignmentDeadline",
  ...ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS,
  ...ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS,
  ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY
];
var getConnectedApplicantsDownloadColumns = () => [
  "name",
  "email",
  "phone",
  "roundNumber",
  "status",
  "studentCode",
  "resumeLink",
  "hasApplied",
  "isAdminPushed",
  "shownInterest"
];
var getRecommendedUsersDownloadColumns = () => [
  "name",
  "email",
  "phone",
  "studentCode",
  "resumeLink",
  "hasApplied",
  "isAdminPushed",
  "shownInterest"
];
var getResumeLinkFromUser = (user) => {
  var _a;
  return ((_a = user == null ? void 0 : user.profile) == null ? void 0 : _a.resumeLink) || "";
};
var getSubmissionColumnsForAssignmentType = (submissionType) => {
  switch (submissionType) {
    case import_types7.AssignmentSubmissionType.Link:
      return [...ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS, ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY];
    case import_types7.AssignmentSubmissionType.File:
      return [...ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS];
    case import_types7.AssignmentSubmissionType.Both:
    case import_types7.AssignmentSubmissionType.Other:
      return [
        ...ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS,
        ...ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS,
        ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY
      ];
    default:
      return [
        ...ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS,
        ...ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS,
        ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY
      ];
  }
};

// src/helpers.ts
init_cjs_shims();
var import_types8 = __toESM(require_dist());
function findPaths(idToObject, rootId, skillsById) {
  let maxDepth = 0;
  let maxDepthPath = [];
  function dfs(nodeId, depth, path) {
    var _a;
    const node = idToObject[nodeId];
    const topicDetails = node.combinations.map((combination) => {
      var _a2;
      return (_a2 = combination.tagRelationships) == null ? void 0 : _a2.map((tagRelationshipId) => {
        const skill = skillsById[tagRelationshipId];
        if (!skill)
          return;
        return skill;
      }).filter((a) => !!a).filter((a) => (a == null ? void 0 : a.type) === "Topic").map((topic) => ({ topicName: topic == null ? void 0 : topic.name, topicId: topic == null ? void 0 : topic._id }));
    }).flat();
    path.push({
      trIds: node.combinations,
      selectionConfigId: (_a = node.selectionConfig) == null ? void 0 : _a.value,
      topicDetails: { topicName: topicDetails[0].topicName, topicId: topicDetails[0].topicId }
    });
    if (depth > maxDepth) {
      maxDepth = depth;
      maxDepthPath = [...path];
    }
    for (const childId of node.children) {
      if (childId) {
        dfs(childId, depth + 1, path);
      }
    }
    path.pop();
  }
  dfs(rootId, 0, []);
  return maxDepthPath;
}
function difficultyNumberToTextMapping(difficulty) {
  if (difficulty <= 0.33) {
    return import_types8.QuestionDifficulty.Easy;
  }
  if (difficulty > 0.33 && difficulty < 0.66) {
    return import_types8.QuestionDifficulty.Medium;
  }
  if (difficulty >= 0.66) {
    return import_types8.QuestionDifficulty.Hard;
  }
  return import_types8.QuestionDifficulty.Easy;
}
function getMonthName(monthNumber) {
  if (monthNumber < 1 || monthNumber > 12)
    return "January";
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  return months[monthNumber - 1];
}
var formatCareerPathType = (type) => {
  const formatted = type.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ").split(" ").map((word) => {
    if (word === "sdet")
      return "SDET";
    if (word === "bd")
      return "BD";
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(" ");
  return formatted;
};
var revertPositionTitleV2 = (title) => {
  let positionTitle = "";
  if (title === import_types8.UserCareerPathType.SOFTWARE_DEVELOPMENT) {
    positionTitle = "Software Engineer";
  } else if (title === import_types8.UserCareerPathType.DATA_ANALYTICS) {
    positionTitle = "Data Analyst";
  } else if (title === import_types8.UserCareerPathType.SDET) {
    positionTitle = "Software Tester";
  } else if (title === import_types8.UserCareerPathType.MATH_ANNOTATIONS_EXPERT) {
    positionTitle = "Math Annotations Expert";
  } else if (title === import_types8.UserCareerPathType.TECH_SUPPORT) {
    positionTitle = "Tech Support";
  } else if (title === import_types8.UserCareerPathType.OPERATIONS) {
    positionTitle = "Operation Executive";
  } else if (title === import_types8.UserCareerPathType.BD_EXECUTIVE) {
    positionTitle = "BD Executive";
  } else if (title === import_types8.UserCareerPathType.DEV_OPS) {
    positionTitle = "DevOps Engineer";
  } else {
    positionTitle = title;
  }
  return positionTitle;
};

// src/jap.ts
init_cjs_shims();
var import_moment4 = __toESM(require_moment());
var getValidJapAmount = (args) => {
  const { originalPrice, expiry, discountedPrice } = args;
  return expiry && (0, import_moment4.default)().isBefore(expiry) ? discountedPrice != null ? discountedPrice : originalPrice : originalPrice;
};

// src/assessmentTemplate.ts
init_cjs_shims();
var convertDifficulty = (difficulty) => {
  if ([0, 0.5, 1].includes(difficulty)) {
    return difficulty;
  } else if (difficulty <= 0.33) {
    return 0;
  } else if (difficulty < 0.66) {
    return 0.5;
  } else {
    return 1;
  }
};

// src/application.ts
init_cjs_shims();
var import_types9 = __toESM(require_dist());
var import_moment5 = __toESM(require_moment());
var checkInPipelineApplication = (application) => {
  var _a;
  return (application == null ? void 0 : application.status) !== import_types9.ApplicationStatus.SHORTLISTED && ((_a = application == null ? void 0 : application.history) == null ? void 0 : _a.map((h) => h.newStatus).includes(import_types9.ApplicationStatus.SHORTLISTED));
};
var checkIsConnectedApplicant = (application) => {
  return (application == null ? void 0 : application.status) === import_types9.ApplicationStatus.SHORTLISTED;
};
var isApplicantsTabApplication = (application) => {
  var _a;
  if (!application)
    return false;
  return application.status === import_types9.ApplicationStatus.SHORTLISTED || !!((_a = application.history) == null ? void 0 : _a.some((history) => history.newStatus === import_types9.ApplicationStatus.SHORTLISTED));
};
var terminalRejectionStatuses = [
  import_types9.ApplicationStatus.REJECTED,
  import_types9.ApplicationStatus.SCREEN_REJECTED,
  import_types9.ApplicationStatus.AUTO_REJECTED
];
var hasAnyApplicationRoundStarted = (application) => {
  var _a, _b, _c;
  if (((_b = (_a = application == null ? void 0 : application.ongoingRound) == null ? void 0 : _a.order) != null ? _b : 0) > 1) {
    return true;
  }
  if ((_c = application == null ? void 0 : application.applicationRounds) == null ? void 0 : _c.some(
    (round) => {
      var _a2;
      return ((_a2 = round.order) != null ? _a2 : 0) > 1 || round.status && round.status !== import_types9.ApplicationRoundStatus.NotStarted;
    }
  )) {
    return true;
  }
  const ongoingRound = application == null ? void 0 : application.ongoingRound;
  return !!((ongoingRound == null ? void 0 : ongoingRound.status) && ongoingRound.status !== import_types9.ApplicationRoundStatus.NotStarted);
};
var wasApplicationShortlisted = (application) => {
  var _a;
  return (application == null ? void 0 : application.status) === import_types9.ApplicationStatus.SHORTLISTED || !!((_a = application == null ? void 0 : application.history) == null ? void 0 : _a.some((history) => history.newStatus === import_types9.ApplicationStatus.SHORTLISTED));
};
var canScreenRejectApplication = (application) => {
  if (!application || terminalRejectionStatuses.includes(application.status))
    return false;
  if (application.status !== import_types9.ApplicationStatus.SHORTLISTED)
    return false;
  return wasApplicationShortlisted(application) && !hasAnyApplicationRoundStarted(application);
};
var canRegularRejectApplication = (application) => {
  if (!application)
    return false;
  if ([
    import_types9.ApplicationStatus.PLACED,
    import_types9.ApplicationStatus.VERBALLY_PLACED,
    import_types9.ApplicationStatus.REJECTED,
    import_types9.ApplicationStatus.SCREEN_REJECTED,
    import_types9.ApplicationStatus.AUTO_REJECTED
  ].includes(application.status)) {
    return false;
  }
  if (canScreenRejectApplication(application))
    return false;
  if (wasApplicationShortlisted(application)) {
    return hasAnyApplicationRoundStarted(application) || application.status !== import_types9.ApplicationStatus.SHORTLISTED;
  }
  return true;
};
var isApplicationRejectionStatus = (status) => {
  return !!status && terminalRejectionStatuses.includes(status);
};
var getScreenRejectRoundNameFromApplicationStatus = (status) => {
  switch (status) {
    case import_types9.ApplicationStatus.SHORTLISTED:
      return "Resume Screening";
    default:
      return status;
  }
};
var getCtaTextAndActionForRecruiterForPipeLineUser = (recommendation, user) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const applicationStatus = (_a = recommendation == null ? void 0 : recommendation.application) == null ? void 0 : _a.status;
  const ongoingRound = (_b = recommendation == null ? void 0 : recommendation.application) == null ? void 0 : _b.ongoingRound;
  const roundStatus = ongoingRound == null ? void 0 : ongoingRound.status;
  const isAM = isUserAccountManager(user == null ? void 0 : user.role);
  const hasAssignmentCompleted = !(ongoingRound == null ? void 0 : ongoingRound.expiry) || (0, import_moment5.default)().isAfter(ongoingRound == null ? void 0 : ongoingRound.expiry);
  const isAssignment = applicationStatus && [import_types9.ApplicationStatus.ASSIGNMENT_IN_PROGRESS, import_types9.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL].includes(
    applicationStatus
  );
  const isCaseStudy = applicationStatus && [import_types9.ApplicationStatus.CASE_STUDY_IN_PROGRESS, import_types9.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL].includes(
    applicationStatus
  );
  const ctaText = applicationStatus ? applicationStatus === import_types9.ApplicationStatus.SHORTLISTED ? "Start Interviews" : applicationStatus === import_types9.ApplicationStatus.WAITING_FOR_RECRUITER_ACTION ? "Schedule" : applicationStatus === import_types9.ApplicationStatus.INTERVIEW_SCHEDULED && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.Interview ? (ongoingRound == null ? void 0 : ongoingRound.interviewOrAssignmentLink) ? "Join" : "Reschedule" : ((_c = recommendation == null ? void 0 : recommendation.application) == null ? void 0 : _c.adminRejectedOfferLetter) ? "Revise Offer" : ((_d = recommendation == null ? void 0 : recommendation.application) == null ? void 0 : _d.pendingForAdminApproval) ? "In Review" : applicationStatus === import_types9.ApplicationStatus.QUALIFIED_ALL_ROUNDS ? "Send Offer" : isAM && isAssignment && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.Assignment && ((_e = ongoingRound.assignmentSubmissions) == null ? void 0 : _e.length) ? "Submitted Assignment" : !isAM && isAssignment && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.Assignment && (!((_f = ongoingRound.assignmentSubmissions) == null ? void 0 : _f.length) || !hasAssignmentCompleted) ? "View Assignment" : !isAM && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.Assignment && isAssignment ? "Submitted Assignment" : isAM && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.Assignment && isAssignment ? "View Assignment" : (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.OnlineTest ? (ongoingRound == null ? void 0 : ongoingRound.status) === import_types9.ApplicationRoundStatus.Submitted ? "Submitted Online Test" : "View Online Test" : isAM && isCaseStudy && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.CaseStudy && ((_g = ongoingRound.assignmentSubmissions) == null ? void 0 : _g.length) ? "Marked Submitted" : !isAM && isCaseStudy && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.CaseStudy && (!((_h = ongoingRound.assignmentSubmissions) == null ? void 0 : _h.length) || !hasAssignmentCompleted) ? "View Case Study" : !isAM && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.CaseStudy && isCaseStudy ? "Marked Submitted" : isAM && (ongoingRound == null ? void 0 : ongoingRound.type) === import_types9.ApplicationRoundType.CaseStudy && isCaseStudy ? "View Case Study" : applicationStatus && ([
    import_types9.ApplicationStatus.OFFER_ROLLED_OUT,
    import_types9.ApplicationStatus.PLACED,
    import_types9.ApplicationStatus.VERBALLY_PLACED,
    import_types9.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
    import_types9.ApplicationStatus.OFFER_REVOKED
  ].includes(applicationStatus) || [
    import_types9.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL,
    import_types9.ApplicationStatus.CHANGED_OFFER_TERMS
  ].includes(applicationStatus) && ((_j = (_i = recommendation.application) == null ? void 0 : _i.history) == null ? void 0 : _j.some(
    (history) => history.newStatus === import_types9.ApplicationStatus.OFFER_ROLLED_OUT
  ))) ? "View Offer" : applicationStatus && (user == null ? void 0 : user.role) && (isUserAccountManager(user.role) || isUserRecruiter(user.role) && !recommendation.user.flags.isMasaiStudent) && [import_types9.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL].includes(applicationStatus) && !((_l = (_k = recommendation.application) == null ? void 0 : _k.history) == null ? void 0 : _l.some(
    (history) => history.newStatus === import_types9.ApplicationStatus.OFFER_ROLLED_OUT
  )) ? "View Opt Out" : [import_types9.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL].includes(applicationStatus) ? "Requested for Opt Out" : [import_types9.ApplicationStatus.CLOSED_BY_ADMIN, import_types9.ApplicationStatus.CLOSED_BY_RECRUITER].includes(
    applicationStatus
  ) ? "Closed" : "View" : "";
  const redirectLink = applicationStatus ? [import_types9.ApplicationStatus.ASSIGNMENT_IN_PROGRESS, import_types9.ApplicationStatus.PENDING_FOR_ASSIGNMENT_SUBMISSION_APPROVAL].includes(
    applicationStatus
  ) ? "viewAssignment" : [import_types9.ApplicationStatus.CASE_STUDY_IN_PROGRESS, import_types9.ApplicationStatus.PENDING_FOR_CASE_STUDY_SUBMISSION_APPROVAL].includes(
    applicationStatus
  ) ? "viewAssignment" : applicationStatus && ([
    import_types9.ApplicationStatus.OFFER_ROLLED_OUT,
    import_types9.ApplicationStatus.PLACED,
    import_types9.ApplicationStatus.VERBALLY_PLACED,
    import_types9.ApplicationStatus.PENDING_FOR_OFFER_LETTER_APPROVAL,
    import_types9.ApplicationStatus.OFFER_REVOKED
  ].includes(applicationStatus) || [import_types9.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL, import_types9.ApplicationStatus.CHANGED_OFFER_TERMS].includes(
    applicationStatus
  ) && ((_n = (_m = recommendation.application) == null ? void 0 : _m.history) == null ? void 0 : _n.some(
    (history) => history.newStatus === import_types9.ApplicationStatus.OFFER_ROLLED_OUT
  ))) ? "viewOffer" : applicationStatus && (user == null ? void 0 : user.role) && (isUserAccountManager(user.role) || isUserRecruiter(user.role) && !recommendation.user.flags.isMasaiStudent) && [import_types9.ApplicationStatus.PENDING_FOR_OPT_OUT_APPROVAL].includes(applicationStatus) && !((_p = (_o = recommendation.application) == null ? void 0 : _o.history) == null ? void 0 : _p.some(
    (history) => history.newStatus === import_types9.ApplicationStatus.OFFER_ROLLED_OUT
  )) ? "viewOptOut" : void 0 : void 0;
  return { ctaText, redirectLink };
};
var showApplicationStatusToRecruiterCard = (status) => {
  return [
    import_types9.ApplicationStatus.OFFER_REJECTED,
    import_types9.ApplicationStatus.JOBSEEKER_OPTED_OUT,
    import_types9.ApplicationStatus.REJECTED,
    import_types9.ApplicationStatus.SCREEN_REJECTED,
    import_types9.ApplicationStatus.AUTO_REJECTED,
    import_types9.ApplicationStatus.VERBALLY_PLACED,
    import_types9.ApplicationStatus.PLACED,
    import_types9.ApplicationStatus.PLACED_ELSEWHERE,
    import_types9.ApplicationStatus.OFFER_REVOKED,
    import_types9.ApplicationStatus.CLOSED_BY_ADMIN,
    import_types9.ApplicationStatus.CLOSED_BY_RECRUITER
  ].includes(status);
};
var hideCtaToRecruiterCard = (status) => {
  return [
    import_types9.ApplicationStatus.OFFER_REJECTED,
    import_types9.ApplicationStatus.JOBSEEKER_OPTED_OUT,
    import_types9.ApplicationStatus.REJECTED,
    import_types9.ApplicationStatus.SCREEN_REJECTED,
    import_types9.ApplicationStatus.AUTO_REJECTED,
    import_types9.ApplicationStatus.PLACED_ELSEWHERE,
    import_types9.ApplicationStatus.CLOSED_BY_ADMIN,
    import_types9.ApplicationStatus.CLOSED_BY_RECRUITER
  ].includes(status);
};
var matchedApplicationStatuses = [import_types9.ApplicationStatus.OPENED_BY_ADMIN, import_types9.ApplicationStatus.OPENED_BY_EMPLOYER];
var resolveReopenedApplicationStatus = (application, position, excludeStatusesFromHistory) => {
  if (position.positionStatus === import_types9.PositionStatus.CLOSED) {
    return null;
  }
  const history = application.history || [];
  const latestHistory = history.filter((h) => !excludeStatusesFromHistory.includes(h.newStatus) && h.createdAt).sort((a, b) => (0, import_moment5.default)(b.createdAt).valueOf() - (0, import_moment5.default)(a.createdAt).valueOf());
  const containsShortlisted = history.some((h) => h.newStatus === import_types9.ApplicationStatus.SHORTLISTED);
  const containsApplied = history.some((h) => h.newStatus === import_types9.ApplicationStatus.APPLIED_BY_JOBSEEKER);
  let status = latestHistory.length ? latestHistory[0].newStatus : containsShortlisted ? import_types9.ApplicationStatus.SHORTLISTED : containsApplied ? import_types9.ApplicationStatus.APPLIED_BY_JOBSEEKER : import_types9.ApplicationStatus.OPENED_BY_ADMIN;
  if (matchedApplicationStatuses.includes(status)) {
    const isExpired = application.status === import_types9.ApplicationStatus.EXPIRED || !!application.expiryDate && (0, import_moment5.default)(application.expiryDate).isBefore((0, import_moment5.default)());
    if (isExpired) {
      status = import_types9.ApplicationStatus.EXPIRED;
    }
  }
  return { status };
};
var isPositionClosed = (position) => {
  return (position == null ? void 0 : position.positionStatus) === import_types9.PositionStatus.CLOSED;
};
var partitionApplicationsByClosedPosition = (applications) => {
  const onOpenPosition = [];
  const onClosedPosition = [];
  for (const app of applications) {
    if (isPositionClosed(app.position)) {
      onClosedPosition.push(app);
    } else {
      onOpenPosition.push(app);
    }
  }
  return { onOpenPosition, onClosedPosition };
};
var displayApplicationStatus = (status) => {
  switch (status) {
    case import_types9.ApplicationStatus.OFFER_REJECTED:
      return "Rejected Offer";
    case import_types9.ApplicationStatus.JOBSEEKER_OPTED_OUT:
      return "Opted out";
    case import_types9.ApplicationStatus.REJECTED:
      return "Rejected";
    case import_types9.ApplicationStatus.SCREEN_REJECTED:
      return "Screen Rejected";
    case import_types9.ApplicationStatus.AUTO_REJECTED:
      return "Auto Rejected";
    case import_types9.ApplicationStatus.VERBALLY_PLACED:
      return "Accepted Offer";
    case import_types9.ApplicationStatus.PLACED:
      return "Accepted Offer";
    case import_types9.ApplicationStatus.PLACED_ELSEWHERE:
      return "Placed Elsewhere";
    case import_types9.ApplicationStatus.CLOSED_BY_ADMIN:
      return "Closed";
    case import_types9.ApplicationStatus.CLOSED_BY_RECRUITER:
      return "Closed";
    default:
      return status;
  }
};

// src/getJobSeekerAssignmentExpiry.ts
init_cjs_shims();
var getJobSeekerAssignmentExpiry = (expiry) => {
  const expiryDate = new Date(expiry);
  const currentDate = new Date();
  const diffMs = expiryDate.getTime() - currentDate.getTime();
  const diffHours = diffMs / (1e3 * 60 * 60);
  let jobseekerAssignmentExpiry;
  if (diffHours >= 30) {
    const newExpiryMs = expiryDate.getTime() - 24 * 60 * 60 * 1e3;
    jobseekerAssignmentExpiry = new Date(newExpiryMs);
  } else {
    const newExpiryMs = currentDate.getTime() + diffMs / 2;
    jobseekerAssignmentExpiry = new Date(newExpiryMs);
  }
  return jobseekerAssignmentExpiry.toISOString();
};
var getDumnyUser = () => {
  const data = {
    _id: "65e8726467edf812ca3769000",
    blur: true,
    user: {
      _id: "65806aa3d6d75b816121082c",
      name: "John Smith",
      email: "johnsmith@gmail.com",
      phone: "78170*****",
      handler: "johnsmith_1702914722952",
      password: "7a2c1aa6-7594-4919-9f04-66f2c212323b",
      role: "JobSeeker",
      flags: {
        showOnboardingVideo: false,
        isTestUser: false,
        showTechScoreCard: true,
        isMentorAnonymous: false,
        isTrusted: false,
        isEmailVerified: true,
        isPhoneVerified: true,
        lastUnseenMeetingId: null,
        isGitHubConnected: true,
        isLinkedInConnected: false,
        showPostInterviewScheduleNudge: false,
        isCnUser: false,
        isTakingScreeningRound: false,
        showLevelModalPostScreening: false,
        isMasaiStudent: true,
        _id: "65806aa3d6d75b816121082d",
        createdAt: "2023-12-18T15:52:03.467Z",
        updatedAt: "2024-01-19T07:46:05.210Z",
        showKyl: false,
        isDeletedAccount: false,
        isPlaced: true,
        isDefaultPOC: false,
        hideRecommendations: false
      },
      evaluation: {
        level: 533.1432088744588,
        streak: 0,
        roundTypeScores: ["659e8f0af220795001aa0612", "659e92caf220795001ab088e"],
        screenedBy: null,
        _id: "65806aa3d6d75b816121082e",
        streakUpdatedAt: "2024-02-19T16:37:58.489Z",
        skillRatings: [
          {
            rating: 500,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "6454d60f6f98fbd0a58d8239",
            _id: "65d3097ce56b98fbc24c6e73",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 500,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "6454d6206f98fbd0a58d823a",
            _id: "65d3097ce56b98fbc24c6e74",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 607.2727272727271,
            roundTypes: ["Development", "DSA"],
            subRoundTypes: ["MERN", "JAVAANDSPRING"],
            skill: "6454d59b6f98fbd0a58d8233",
            _id: "65d3097ce56b98fbc24c6e75",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 445.4545454545455,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "64f5b8b9388460aab5631b79",
            _id: "65d3097ce56b98fbc24c6e76",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 670.8333333333333,
            roundTypes: ["Development", "DSA"],
            subRoundTypes: ["MERN", "JAVAANDSPRING"],
            skill: "6455057b6f98fbd0a58d82c7",
            _id: "65d3097ce56b98fbc24c6e77",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 642.7272727272726,
            roundTypes: ["Development", "DSA"],
            subRoundTypes: ["MERN", "JAVAANDSPRING"],
            skill: "6454d5ae6f98fbd0a58d8234",
            _id: "65d3097ce56b98fbc24c6e78",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 628.1249999999999,
            roundTypes: ["Development", "DSA"],
            subRoundTypes: ["MERN", "JAVAANDSPRING"],
            skill: "6454d5cc6f98fbd0a58d8236",
            _id: "65d3097ce56b98fbc24c6e79",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 676.4285714285712,
            roundTypes: ["Development", "DSA"],
            subRoundTypes: ["MERN", "JAVAANDSPRING"],
            skill: "645505536f98fbd0a58d82c6",
            _id: "65d3097ce56b98fbc24c6e7a",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 0,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "649aa466c1afc4e2b99d97b3",
            _id: "65d3097ce56b98fbc24c6e7b",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 0,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "645a0026ce04b8b94151e060",
            _id: "65d3097ce56b98fbc24c6e7c",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 0,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "649aa494a4b3a5b80cbbf63e",
            _id: "65d3097ce56b98fbc24c6e7d",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 710.0000000000001,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "64539cbc6f98fbd0a58d81b0",
            _id: "65d3097ce56b98fbc24c6e7e",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 354.1666666666667,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "6454d5bd6f98fbd0a58d8235",
            _id: "65d3097ce56b98fbc24c6e7f",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 950.0000000000001,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "652fb3444b6474c8e83a41ca",
            _id: "65d3097ce56b98fbc24c6e80",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 0,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "645399cd6f98fbd0a58d81af",
            _id: "65d3097ce56b98fbc24c6e81",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 950.0000000000001,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "645505286f98fbd0a58d82c5",
            _id: "65d3097ce56b98fbc24c6e82",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 950.0000000000001,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "6455050e6f98fbd0a58d82c4",
            _id: "65d3097ce56b98fbc24c6e83",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 950.0000000000001,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "653a8b5e516a8f0f726daa24",
            _id: "65d3097ce56b98fbc24c6e84",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 0,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "645504fb6f98fbd0a58d82c3",
            _id: "65d3097ce56b98fbc24c6e85",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          },
          {
            rating: 0,
            roundTypes: ["Development"],
            subRoundTypes: ["MERN"],
            skill: "652fb3c74b6474c8e83a63a2",
            _id: "65d3097ce56b98fbc24c6e86",
            createdAt: "2024-02-19T07:55:40.923Z",
            updatedAt: "2024-02-19T07:55:40.923Z"
          }
        ],
        history: [
          {
            updatedBy: "6464e042839e9e618ada2111",
            path: "MAP",
            predictedSalary: { min: 5, max: 6 },
            level: 62,
            _id: "659e92cc5f65c37410b638e8",
            createdAt: "2024-01-10T12:51:24.628Z",
            updatedAt: "2024-01-10T12:51:24.628Z"
          },
          {
            level: 533.1432088744588,
            _id: "65d317fa8b7c89a5ae23d68b",
            createdAt: "2024-02-19T08:57:30.477Z",
            updatedAt: "2024-02-19T08:57:30.477Z"
          }
        ],
        createdAt: "2023-12-18T15:52:03.467Z",
        updatedAt: "2024-03-01T18:30:01.302Z",
        interviewPath: {
          offeredPrice: 0,
          originalPrice: 0,
          type: "Free",
          payment: "65806aa3d6d75b8161210a3a",
          _id: "65806aa4d6d75b8161210cf2",
          createdAt: "2023-12-18T15:52:04.231Z",
          updatedAt: "2023-12-18T15:52:04.231Z"
        },
        predictedSalary: { min: 5, max: 6 },
        recommendedPath: "MAP",
        screeningCompletedBy: null
      },
      japEnrollments: ["659e92ca5f65c37410b635b4"],
      profile: {
        expectedSalary: { min: 5, max: 7, _id: "659e7b5fd7611aefced5280c" },
        totalExperience: 0,
        preferredCompanyTypes: [],
        preferredJobLocations: ["Bengaluru, Karnataka"],
        skills: [],
        profileSkills: ["650a8fa3ff2ee39b30cfd720", "650a8fa3ff2ee39b30cfd73e"],
        mentorCost: 0,
        _id: "65806aa3d6d75b8161210830",
        projectDetails: [
          {
            title: "JewelLane",
            description: "Jewel Lane is a clone of an e-commerce website Caratlane which sells the best gold & diamond jewelry. They offer a wide range of rings, earrings, bangles, bracelets and necklaces at the best price.",
            link: "https://jewellane.vercel.app/",
            endedAt: "2023-06-15T18:30:00.000Z",
            startedFrom: "2023-06-11T18:30:00.000Z",
            _id: "659ec279e41b5a2b0ecde602",
            createdAt: "2024-01-10T16:14:49.896Z",
            updatedAt: "2024-01-10T16:14:49.896Z"
          },
          {
            title: "Tackle&Trail",
            description: "Tackle&Trail: Your one-stop shop for top-notch fishing, hunting, boating, and outdoor gear. Explore our wide selection for unforgettable adventures.",
            link: "https://tackle-and-trail.netlify.app/",
            endedAt: "2023-05-11T18:30:00.000Z",
            startedFrom: "2023-05-08T18:30:00.000Z",
            _id: "659ec45e1e97b878099b405a",
            createdAt: "2024-01-10T16:22:54.077Z",
            updatedAt: "2024-01-10T16:22:54.077Z"
          }
        ],
        certifications: [],
        workExperiences: [
          {
            isScrapedFromLinkedIn: false,
            company: "- ",
            jobTitle: "-",
            salary: 1,
            _id: "659e7b5fd7611aefced5280b",
            createdAt: "2024-01-10T11:11:27.685Z",
            updatedAt: "2024-01-10T11:11:27.685Z"
          }
        ],
        educationalDetails: [
          {
            isScrapedFromLinkedIn: false,
            degreeName: "Bachelors",
            fieldOfStudy: "Computer Science ",
            collagelocation: "Aligarh ",
            collegeName: "Shri Varshney College",
            gradeType: "Percentage (%)",
            gradeValue: 82,
            startedFrom: "2019-08-12T18:30:00.000Z",
            endedAt: "2022-08-14T18:30:00.000Z",
            _id: "659ec10fe41b5a2b0ecad1d9",
            createdAt: "2024-01-10T16:08:47.714Z",
            updatedAt: "2024-01-10T16:08:47.714Z"
          }
        ],
        screenedSkills: [],
        createdAt: "2023-12-18T15:52:03.467Z",
        updatedAt: "2024-02-19T16:33:29.163Z",
        currentWorkingStatus: "GraduatedNotWorking",
        expectedJoining: "Immediate",
        gradYear: 2022,
        lastDrawnSalary: 1,
        parsedResumeData: "\n\nContact\n+917817032067\nkhushikatara041@gmail.com\nNoida,Uttar Pradesh\nPortfolio\nHarshitakatara34\nharshita-katara-09904b246/\nEducation\nBachelor of Science (Computer\nScience)\nShri Varshney College, Aligarh\nAug 19 - Aug 22\n12th (Higher Secondary)\nGagan Public School\nMarch 18 - May 19\nTechnical Skills\nJavaScriptNode.js\nMongoDBHTML5CSS3\nReactRESTful APIsRedux\nExpress.js\nResponsive Web Design\nSoft Skills\nTeamworkAdaptability\nProblem Solving\nEffective Communication\nCertifications\nMERN Stack Development\nCertification\nMasai\nZoom Marathon Challenge\nMasai\nCertification Link\nHarshita Katara\nFull Stack Web Developer\nProfessional Summary\nHighly skilled and motivated Full Stack Web Developer\nproficient in MERN stack. with a proven track record of\ndelivering solo and team projects. Strong in both front-end\nand back-end development, adept at problem-solving, and\neffective communication. Eager to contribute to innovative\nweb development endeavors.\nProjects\nJewelLane\nLive Demo LinkGithub Repo Link\nHTMLCSSReactReduxNode.js\nExpress.jsMongoDBChakraUI\nImplemented user and admin registration and\nauthentication functionality\nCreated a user-friendly product page with features\nlike filtering, sorting, and searching.\nImplemented Add to Cart Functionality .\nTackle&Trail\nLive Demo LinkGithub Repo Link\nHTML5CSSReactReduxChakraUI\nDeveloped an e-commerce website for purchasing\nfishing accessories\nImplemented user and admin registration and\nauthentication functionality\nCreated a user-friendly product page with filtering,\nsorting, Pagination and searching features\nLicious\nLive Demo LinkGithub Repo Link\nHTMLCSSJavaScript\nDeveloped an e-commerce application for purchasing\npoultry and fish products\nImplemented user login/signup functionality\nDeveloped filtering, searching, and sort functionalities\nExperience\nMasai\n|\nFull Stack Developer (Training)\nAug 2022 - Aug 2023\n1200+ projects completed at Masai School in both\nfrontend and backend development.\nStrong teamwork and leadership in group projects.\nExpert in resolving technical challenges for optimal\nperformance.\nThe Matrix Labs\n|\nSoftware Developer\nAugust 2023 - Present",
        resumeLink: "https://s3.ap-south-1.amazonaws.com/levelup-app-production/resumeUrls/65806aa3d6d75b816121082c/Harshita Katara-Harshita Katara-Full Stack Web Developer.pdf"
      },
      labels: [],
      completedScreeningRounds: 0,
      assignedScreeningRounds: 0,
      availedFreeInterviews: [
        {
          round: "6597df208cfccc115bfd1d29",
          availedAt: "2024-01-05T10:51:12.654Z",
          interviewType: "First",
          _id: "6597df208cfccc115bfd1d2b",
          createdAt: "2024-01-05T10:51:12.654Z",
          updatedAt: "2024-01-05T10:51:12.654Z"
        }
      ],
      account: [
        {
          type: "oauth",
          provider: "github",
          providerAccountId: "112870595",
          token_type: "bearer",
          access_token: "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",
          _id: "659ebd305f65c37410377934",
          createdAt: "2024-01-10T15:52:16.634Z",
          updatedAt: "2024-01-10T15:52:16.634Z"
        }
      ],
      __v: 0,
      createdAt: "2023-12-18T15:52:03.467Z",
      updatedAt: "2024-03-01T18:30:01.302Z",
      subRole: "MasaiStudent",
      screeningFeedback: []
    },
    position: "65d3510567be10482785503d",
    application: {
      _id: "65d35445ddfd21eded5f3514",
      position: "65d3510567be10482785503d",
      user: "65806aa3d6d75b816121082c",
      __v: 0,
      applicationRounds: ["65d354452a134559c8e64c17", "65d354452a134559c8e64c19"],
      createdAt: "2024-02-19T13:14:45.221Z",
      createdBy: "65d30a40ddfd21eded50994b",
      history: [
        {
          newStatus: "OpenedByEmployer",
          updatedBy: "65d30a40ddfd21eded50994b",
          _id: "65d354452a134559c8e64bf1",
          createdAt: "2024-02-19T13:14:45.221Z",
          updatedAt: "2024-02-19T13:14:45.221Z"
        },
        { newStatus: "AppliedByJobSeeker", updatedBy: "65806aa3d6d75b816121082c", _id: "65d382e88af6fb1a28a94262" },
        { newStatus: "Shortlisted", updatedBy: "65806aa3d6d75b816121082c", _id: "65d382e88af6fb1a28a94263" }
      ],
      offerLetterApprovalChatThread: [],
      status: "Shortlisted",
      updatedAt: "2024-02-19T16:33:44.984Z",
      ongoingRound: {
        _id: "65d354452a134559c8e64c17",
        user: "65806aa3d6d75b816121082c",
        position: "65d3510567be10482785503d",
        application: "65d35445ddfd21eded5f3514",
        order: 1,
        interviewers: [],
        title: "Harshita Katara - Frontend Engineer - Round 1",
        status: "NotStarted",
        type: "Interview",
        statusHistory: [
          {
            status: "NotStarted",
            updatedBy: "65d30a40ddfd21eded50994b",
            _id: "65d354452a134559c8e64c18",
            createdAt: "2024-02-19T13:14:45.260Z",
            updatedAt: "2024-02-19T13:14:45.260Z"
          }
        ],
        roundStartedAt: "2024-02-19T13:14:45.257Z",
        approvalChatThread: [],
        jobseekerChatThread: [],
        assignmentSubmissions: [],
        __v: 0,
        createdAt: "2024-02-19T13:14:45.260Z",
        updatedAt: "2024-02-19T13:14:45.260Z",
        sentSubmissionsToRecruiters: false
      },
      roundFeedbackHistory: []
    },
    hasConnected: true,
    isEligible: true,
    isShownToRecruiter: true,
    percentageMatch: 80,
    isProfileShared: false,
    isInvalidRecommendation: false,
    buPriority: 0,
    __v: 0,
    createdAt: "2024-03-06T13:40:52.059Z",
    updatedAt: "2024-03-06T13:40:52.059Z"
  };
  return data;
};

// src/user.ts
init_cjs_shims();
var import_types10 = __toESM(require_dist());
var isMandatoryFormFilled = (user) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
  const isTenthScoreFilled = (_b = (_a = user.pifMeta) == null ? void 0 : _a.tenth) == null ? void 0 : _b.percentage;
  const isTwelfthScoreFilled = (_d = (_c = user.pifMeta) == null ? void 0 : _c.twelfth) == null ? void 0 : _d.percentage;
  const isCollegeFilled = ((_f = (_e = user.pifMeta) == null ? void 0 : _e.underGraduate) == null ? void 0 : _f.collegeUniversityName) || ((_h = (_g = user.pifMeta) == null ? void 0 : _g.postGraduate) == null ? void 0 : _h.collegeUniversityName);
  const isDegreeFilled = ((_j = (_i = user.pifMeta) == null ? void 0 : _i.underGraduate) == null ? void 0 : _j.degree) || ((_l = (_k = user.pifMeta) == null ? void 0 : _k.postGraduate) == null ? void 0 : _l.degree);
  const isSpecialisationFilled = ((_n = (_m = user.pifMeta) == null ? void 0 : _m.underGraduate) == null ? void 0 : _n.specialisation) || ((_p = (_o = user.pifMeta) == null ? void 0 : _o.postGraduate) == null ? void 0 : _p.specialisation);
  const isCurrentScoreFilled = ((_r = (_q = user.pifMeta) == null ? void 0 : _q.underGraduate) == null ? void 0 : _r.percentage) || ((_t = (_s = user.pifMeta) == null ? void 0 : _s.postGraduate) == null ? void 0 : _t.percentage);
  const isGradYearFilled = user.profile.gradYear;
  const isGenderFilled = (_u = user.pifMeta) == null ? void 0 : _u.gender;
  const isPincodeFilled = ((_w = (_v = user.pifMeta) == null ? void 0 : _v.location) == null ? void 0 : _w.pincode) || ((_x = user.userPreference) == null ? void 0 : _x.experienceLevel) === import_types10.UserExperienceLevelType.FINAL_YEAR_STUDENT;
  return isTenthScoreFilled && isTwelfthScoreFilled && isCollegeFilled && isDegreeFilled && isSpecialisationFilled && isCurrentScoreFilled && isGradYearFilled && isGenderFilled && isPincodeFilled;
};
var isUserPreferenceFilled = (userPreference) => {
  return (userPreference == null ? void 0 : userPreference.experienceLevel) && (userPreference == null ? void 0 : userPreference.careerPath) && (userPreference == null ? void 0 : userPreference.developmentRole) && userPreference.techStack;
};
var MIN_GRAD_YEAR = 2e3;
var MAX_GRAD_YEAR = 2030;
var MIN_PREDICTED_SALARY = 1;
var MAX_PREDICTED_SALARY = 80;
var MIN_LEVEL = 1;
var MAX_LEVEL = 1e3;
var PROCESS_NOT_STARTED = "Process is yet to start";
var checkDisplayUserEmail = (user) => {
  return user.subRole !== "Onwards" || !user.email.includes(`dummy_email_for_`);
};
var isUserCollegeUser = (user) => {
  var _a;
  return (user == null ? void 0 : user.college) || ((_a = user == null ? void 0 : user.usedReferralCode) == null ? void 0 : _a.includes("shardauniversity"));
};
function capitalize(s) {
  var _a;
  return ((_a = s[0]) == null ? void 0 : _a.toUpperCase()) + (s == null ? void 0 : s.slice(1));
}
var getDevelopmentRoleUIConfig = (developmentRole) => {
  let tabIcon = null;
  let finalText = developmentRole == null ? void 0 : developmentRole.split(/(?=[A-Z])/).map((word) => capitalize(word == null ? void 0 : word.toLowerCase())).join(" ");
  switch (developmentRole) {
    case "salesB2B" /* SALES_B2B */:
      finalText = "Sales B2B";
      break;
    case "salesB2C" /* SALES_B2C */:
      finalText = "Sales B2C";
      break;
  }
  return { finalText, tabIcon };
};
var getUserPreferenceUIConfig = ({
  text,
  isMock = false,
  showTechStack = false,
  userPreferenceSnapshot
}) => {
  var _a, _b, _c, _d;
  let tabIcon = null;
  let finalText = isMock ? text : text == null ? void 0 : text.split(/(?=[A-Z])/).map((word) => capitalize(word == null ? void 0 : word.toLowerCase())).join(" ");
  switch (text) {
    case "sales":
      if (userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.developmentRole) {
        finalText = (_a = getDevelopmentRoleUIConfig(userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.developmentRole)) == null ? void 0 : _a.finalText;
      }
      break;
    case "softwareDevelopment":
      finalText = "Software Development";
      tabIcon = `/assets/preferenceIcons/softwareDevelopment.svg`;
      break;
    case "dataAnalytics":
      finalText = "Data Analytics";
      tabIcon = `/assets/preferenceIcons/dataAnalytics.svg`;
      break;
    case "sdet":
      finalText = "Software Testing";
      tabIcon = `/assets/preferenceIcons/sdet.png`;
      break;
    case "frontend":
      finalText = "Frontend Developer";
      break;
    case "backend":
      finalText = "Backend Developer";
      break;
    case "fullStack":
      finalText = "Full Stack Developer";
      break;
    case "mern":
      finalText = "MERN Stack";
      tabIcon = `/assets/preferenceIcons/mern.svg`;
      break;
    case "django":
      finalText = "Django";
      tabIcon = `/assets/preferenceIcons/django.svg`;
      break;
    case "java":
      finalText = "Java";
      tabIcon = `/assets/preferenceIcons/java.svg`;
      break;
    case "node":
      finalText = "NodeJs";
      tabIcon = `/assets/preferenceIcons/node.svg`;
      break;
    case "react":
      finalText = "ReactJs";
      tabIcon = `/assets/preferenceIcons/react.svg`;
      break;
    case "angular":
      finalText = "AngularJs";
      break;
    case import_types10.UserExperienceLevelType.FINAL_YEAR_STUDENT:
      finalText = "Final Year Student";
      break;
    case import_types10.UserExperienceLevelType.FRESHER:
      finalText = "Freshers";
      break;
    case import_types10.UserExperienceLevelType.OneToTwoYears:
      finalText = "1-2 Years";
      break;
    case import_types10.UserExperienceLevelType.TwoPlusYears:
      finalText = "2+ Years";
      break;
  }
  if ((userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.techStack) !== import_types10.TechStackType.OTHER && showTechStack) {
    finalText = `${finalText} (${(_b = getUserPreferenceUIConfig({ text: (userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.techStack) || "" })) == null ? void 0 : _b.finalText})`;
  } else if ((userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.techStack) === import_types10.TechStackType.OTHER && showTechStack) {
    finalText = `${finalText} (${(_c = getUserPreferenceUIConfig({ text: (userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.experienceLevel) || "" })) == null ? void 0 : _c.finalText})`;
  } else if ((userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.developmentRole) !== "other" /* OTHER */ && showTechStack) {
    finalText = `${finalText} (${(_d = getUserPreferenceUIConfig({ text: (userPreferenceSnapshot == null ? void 0 : userPreferenceSnapshot.developmentRole) || "" })) == null ? void 0 : _d.finalText})`;
  }
  return { finalText, tabIcon };
};
var highestQualifications = [
  { value: "12th", label: "12th" },
  { value: "Diploma After 10th", label: "Diploma After 10th" },
  { value: "Diploma After 12th", label: "Diploma After 12th" },
  { value: "Under Graduate", label: "Under Graduate" },
  { value: "Post Graduate", label: "Post Graduate" }
];
var boards = [
  { value: "CBSE", label: "CBSE" },
  { value: "ICSE", label: "ICSE" },
  { value: "State Board", label: "State Board" },
  { value: "Others", label: "Others" }
];
var genderOptions = ["Male", "Female", "Transgender"];
var backLogsOptions = [
  { value: false, label: "No" },
  { value: true, label: "Yes" }
];
var postgraduateDegrees = {
  [import_types10.PostgraduateDegreeTypes.Others]: ["Others"],
  [import_types10.PostgraduateDegreeTypes.MSc]: [
    "Physics",
    "Chemistry",
    "Biology",
    "Mathematics",
    "Computer Science",
    "Biotechnology",
    "Microbiology",
    "Environmental Science",
    "Statistics",
    "Zoology",
    "Botany",
    "Geology",
    "Agriculture",
    "Nanotechnology",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MTech]: [
    "Computer Science Engineering",
    "Mechanical Engineering",
    "Civil Engineering",
    "Electrical Engineering",
    "Electronics and Communication Engineering",
    "Information Technology",
    "Chemical Engineering",
    "Biomedical Engineering",
    "Aerospace Engineering",
    "Automobile Engineering",
    "Biotechnology",
    "Agricultural Engineering",
    "Textile Engineering",
    "Structural Engineering",
    "Software Engineering",
    "Power Systems",
    "VLSI Design",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.ME]: [
    "Computer Science Engineering",
    "Mechanical Engineering",
    "Civil Engineering",
    "Electrical Engineering",
    "Electronics and Communication Engineering",
    "Information Technology",
    "Chemical Engineering",
    "Biomedical Engineering",
    "Aerospace Engineering",
    "Automobile Engineering",
    "Biotechnology",
    "Agricultural Engineering",
    "Textile Engineering",
    "Structural Engineering",
    "Software Engineering",
    "Power Systems",
    "VLSI Design",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MArch]: [
    "Architecture",
    "Urban Planning",
    "Environmental Planning",
    "Regional Planning",
    "Landscape Architecture",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MCA]: ["Computer Applications", "Others"],
  [import_types10.PostgraduateDegreeTypes.MCom]: [
    "General",
    "Accounting and Finance",
    "Banking and Insurance",
    "Marketing",
    "International Business",
    "Business Analytics",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MBA]: [
    "General Management",
    "Finance",
    "Marketing",
    "Human Resources",
    "Operations Management",
    "Information Technology",
    "International Business",
    "Business Analytics",
    "Healthcare Management",
    "Hospitality Management",
    "Retail Management",
    "Supply Chain Management",
    "Entrepreneurship",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MA]: [
    "English",
    "History",
    "Political Science",
    "Economics",
    "Sociology",
    "Psychology",
    "Philosophy",
    "Geography",
    "Journalism and Mass Communication",
    "Anthropology",
    "Hindi",
    "Sanskrit",
    "Education",
    "Public Administration",
    "Linguistics",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MFA]: ["Fine Arts", "Applied Arts", "Painting", "Sculpture", "Animation", "Others"],
  [import_types10.PostgraduateDegreeTypes.MDes]: [
    "Fashion Design",
    "Interior Design",
    "Graphic Design",
    "Product Design",
    "Textile Design",
    "Animation and Multimedia",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MJMC]: ["Journalism", "Mass Communication", "Public Relations", "Advertising", "Others"],
  [import_types10.PostgraduateDegreeTypes.MSW]: [
    "Social Work",
    "Community Development",
    "Medical and Psychiatric Social Work",
    "Human Resource Management",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.LLM]: [
    "Law",
    "Constitutional Law",
    "Corporate Law",
    "International Law",
    "Criminal Law",
    "Taxation Law",
    "Labor Law",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MD]: [
    "General Medicine",
    "Pediatrics",
    "Dermatology",
    "Psychiatry",
    "Radiology",
    "Pathology",
    "Anesthesiology",
    "Physiology",
    "Biochemistry",
    "Community Medicine",
    "Forensic Medicine",
    "Pharmacology",
    "Microbiology",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MS]: [
    "General Surgery",
    "Orthopedics",
    "Ophthalmology",
    "ENT (Ear, Nose, Throat)",
    "Obstetrics and Gynecology",
    "Neurosurgery",
    "Cardiothoracic Surgery",
    "Plastic Surgery",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MDS]: [
    "Conservative Dentistry and Endodontics",
    "Oral and Maxillofacial Surgery",
    "Orthodontics",
    "Periodontology",
    "Prosthodontics",
    "Pedodontics",
    "Oral Pathology",
    "Oral Medicine and Radiology",
    "Public Health Dentistry",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MPharm]: [
    "Pharmaceutics",
    "Pharmacology",
    "Pharmaceutical Chemistry",
    "Pharmaceutical Analysis",
    "Pharmacognosy",
    "Pharmacy Practice",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MEd]: [
    "Education",
    "Special Education",
    "Educational Technology",
    "Educational Management",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MLiSc]: ["Library Science", "Others"],
  [import_types10.PostgraduateDegreeTypes.MPlan]: ["Planning", "Urban Planning", "Regional Planning", "Transport Planning", "Others"],
  [import_types10.PostgraduateDegreeTypes.MVoc]: [
    "Retail Management",
    "Healthcare Management",
    "Software Development",
    "Tourism and Hospitality Management",
    "Others"
  ],
  [import_types10.PostgraduateDegreeTypes.MASLP]: ["Audiology and Speech-Language Pathology", "Others"]
};
var undergraduateDegrees = {
  [import_types10.UndergraduateDegreeTypes.Others]: ["Others"],
  [import_types10.UndergraduateDegreeTypes.BSc]: [
    "Physics",
    "Chemistry",
    "Biology",
    "Mathematics",
    "Computer Science",
    "Biotechnology",
    "Microbiology",
    "Environmental Science",
    "Statistics",
    "Zoology",
    "Botany",
    "Geology",
    "Home Science",
    "Agriculture",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BTech]: [
    "Computer Science Engineering",
    "Mechanical Engineering",
    "Civil Engineering",
    "Electrical Engineering",
    "Electronics and Communication Engineering",
    "Information Technology",
    "Chemical Engineering",
    "Biomedical Engineering",
    "Aerospace Engineering",
    "Automobile Engineering",
    "Biotechnology",
    "Agricultural Engineering",
    "Textile Engineering",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BE]: [
    "Computer Science Engineering",
    "Mechanical Engineering",
    "Civil Engineering",
    "Electrical Engineering",
    "Electronics and Communication Engineering",
    "Information Technology",
    "Chemical Engineering",
    "Biomedical Engineering",
    "Aerospace Engineering",
    "Automobile Engineering",
    "Biotechnology",
    "Agricultural Engineering",
    "Textile Engineering",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BArch]: ["Architecture", "Others"],
  [import_types10.UndergraduateDegreeTypes.BCA]: ["Computer Applications", "Others"],
  [import_types10.UndergraduateDegreeTypes.BCom]: [
    "General",
    "Accounting and Finance",
    "Banking and Insurance",
    "Marketing",
    "Tourism and Travel Management",
    "Business Analytics",
    "Computer Applications",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BBA]: [
    "General Management",
    "International Business",
    "Finance",
    "Marketing",
    "Human Resources",
    "Entrepreneurship",
    "Logistics and Supply Chain Management",
    "Business Analytics",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BBM]: [
    "Finance",
    "Marketing",
    "Human Resources",
    "International Business",
    "Operations",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BMS]: ["Management Studies", "Others"],
  [import_types10.UndergraduateDegreeTypes.BA]: [
    "English",
    "History",
    "Political Science",
    "Economics",
    "Sociology",
    "Psychology",
    "Philosophy",
    "Geography",
    "Journalism",
    "Anthropology",
    "Hindi",
    "Sanskrit",
    "Education",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BFA]: ["Fine Arts", "Applied Arts", "Painting", "Sculpture", "Animation", "Others"],
  [import_types10.UndergraduateDegreeTypes.BVA]: ["Visual Arts", "Others"],
  [import_types10.UndergraduateDegreeTypes.BDes]: [
    "Fashion Design",
    "Interior Design",
    "Graphic Design",
    "Product Design",
    "Textile Design",
    "Animation and Multimedia",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BJMC]: ["Journalism", "Mass Communication", "Public Relations", "Advertising", "Others"],
  [import_types10.UndergraduateDegreeTypes.BSW]: ["Social Work", "Others"],
  [import_types10.UndergraduateDegreeTypes.LLB]: ["Law", "Others"],
  [import_types10.UndergraduateDegreeTypes.MBBS]: ["Medicine and Surgery", "Others"],
  [import_types10.UndergraduateDegreeTypes.BDS]: ["Dental Surgery", "Others"],
  [import_types10.UndergraduateDegreeTypes.BAMS]: ["Ayurvedic Medicine and Surgery", "Others"],
  [import_types10.UndergraduateDegreeTypes.BHMS]: ["Homeopathic Medicine and Surgery", "Others"],
  [import_types10.UndergraduateDegreeTypes.BPT]: ["Physiotherapy", "Others"],
  [import_types10.UndergraduateDegreeTypes.BOT]: ["Occupational Therapy", "Others"],
  [import_types10.UndergraduateDegreeTypes.BPharm]: ["Pharmacy", "Others"],
  [import_types10.UndergraduateDegreeTypes.BHM]: ["Hotel Management", "Others"],
  [import_types10.UndergraduateDegreeTypes.BEd]: ["Education", "Others"],
  [import_types10.UndergraduateDegreeTypes.BLiSc]: ["Library Science", "Others"],
  [import_types10.UndergraduateDegreeTypes.BPlan]: ["Planning", "Others"],
  [import_types10.UndergraduateDegreeTypes.BVoc]: [
    "Retail Management",
    "Healthcare Management",
    "Software Development",
    "Tourism and Hospitality Management",
    "Others"
  ],
  [import_types10.UndergraduateDegreeTypes.BASLP]: ["Audiology and Speech-Language Pathology", "Others"],
  [import_types10.UndergraduateDegreeTypes.BALlb]: ["Integrated Law", "Others"],
  [import_types10.UndergraduateDegreeTypes.BComLlb]: ["Integrated Law", "Others"],
  [import_types10.UndergraduateDegreeTypes.BBALLb]: ["Integrated Law", "Others"]
};
function extractUniqueSpecializations(degrees) {
  const allSpecializations2 = Object.values(degrees).flat();
  return [...new Set(allSpecializations2)];
}
var allSpecializations = [
  ...extractUniqueSpecializations(undergraduateDegrees),
  ...extractUniqueSpecializations(postgraduateDegrees)
];
var uniqueSpecializations = [...new Set(allSpecializations)].sort();
function extractUniqueDegrees(degrees) {
  return Object.keys(degrees);
}
var allDegrees = [...extractUniqueDegrees(undergraduateDegrees), ...extractUniqueDegrees(postgraduateDegrees)];
var uniqueDegrees = [...new Set(allDegrees)].sort();
var stateCityOptions = {
  [import_types10.StateCityTypes.Maharashtra]: [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Nashik",
    "Aurangabad",
    "Solapur",
    "Thane",
    "Kolhapur",
    "Jalgaon",
    "Amravati",
    "Akola",
    "Ulhasnagar",
    "Latur",
    "Dhule",
    "Ahmednagar",
    "Chandrapur",
    "Parbhani",
    "Ichalkaranji",
    "Nanded",
    "Sangli",
    "Malegaon",
    "Bhiwandi",
    "Ratnagiri",
    "Satara",
    "Others"
  ],
  [import_types10.StateCityTypes.Karnataka]: [
    "Bangalore",
    "Mysore",
    "Hubli-Dharwad",
    "Mangalore",
    "Belgaum",
    "Gulbarga",
    "Davanagere",
    "Bellary",
    "Bijapur",
    "Shimoga",
    "Tumkur",
    "Raichur",
    "Bidar",
    "Hospet",
    "Hassan",
    "Others"
  ],
  [import_types10.StateCityTypes.TamilNadu]: [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
    "Tirunelveli",
    "Erode",
    "Vellore",
    "Thoothukudi",
    "Dindigul",
    "Thanjavur",
    "Ranipet",
    "Karur",
    "Udhagamandalam (Ooty)",
    "Sivakasi",
    "Hosur",
    "Kancheepuram",
    "Kumbakonam",
    "Nagercoil",
    "Tiruvannamalai",
    "Ambur",
    "Rajapalayam",
    "Nagapattinam",
    "Pudukkottai",
    "Others"
  ],
  [import_types10.StateCityTypes.UttarPradesh]: [
    "Lucknow",
    "Kanpur",
    "Ghaziabad",
    "Agra",
    "Varanasi",
    "Meerut",
    "Prayagraj (Allahabad)",
    "Bareilly",
    "Aligarh",
    "Moradabad",
    "Saharanpur",
    "Gorakhpur",
    "Noida",
    "Faizabad (Ayodhya)",
    "Firozabad",
    "Jhansi",
    "Muzaffarnagar",
    "Mathura",
    "Budaun",
    "Rampur",
    "Shahjahanpur",
    "Others"
  ],
  [import_types10.StateCityTypes.WestBengal]: [
    "Kolkata",
    "Howrah",
    "Darjeeling",
    "Asansol",
    "Siliguri",
    "Durgapur",
    "Bardhaman",
    "Haldia",
    "Kharagpur",
    "Baharampur",
    "Malda",
    "Medinipur",
    "Jalpaiguri",
    "Balurghat",
    "Krishnanagar",
    "Chandannagar",
    "Others"
  ],
  [import_types10.StateCityTypes.Gujarat]: [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Junagadh",
    "Gandhinagar",
    "Anand",
    "Bharuch",
    "Porbandar",
    "Morbi",
    "Nadiad",
    "Surendranagar",
    "Mehsana",
    "Bhuj",
    "Others"
  ],
  [import_types10.StateCityTypes.Rajasthan]: [
    "Jaipur",
    "Jodhpur",
    "Kota",
    "Bikaner",
    "Ajmer",
    "Udaipur",
    "Bhilwara",
    "Alwar",
    "Bharatpur",
    "Sikar",
    "Pali",
    "Tonka",
    "Sriganganagar",
    "Bundi",
    "Chittorgarh",
    "Jaisalmer",
    "Others"
  ],
  [import_types10.StateCityTypes.MadhyaPradesh]: [
    "Bhopal",
    "Indore",
    "Gwalior",
    "Jabalpur",
    "Ujjain",
    "Sagar",
    "Dewas",
    "Satna",
    "Ratlam",
    "Rewa",
    "Murwara (Katni)",
    "Singrauli",
    "Burhanpur",
    "Khandwa",
    "Others"
  ],
  [import_types10.StateCityTypes.Punjab]: [
    "Amritsar",
    "Ludhiana",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Hoshiarpur",
    "Mohali",
    "Pathankot",
    "Batala",
    "Moga",
    "Abohar",
    "Malerkotla",
    "Khanna",
    "Phagwara",
    "Shimla",
    "Others"
  ],
  [import_types10.StateCityTypes.Bihar]: [
    "Patna",
    "Gaya",
    "Bhagalpur",
    "Muzaffarpur",
    "Purnia",
    "Darbhanga",
    "Bihar Sharif",
    "Arrah",
    "Begusarai",
    "Katihar",
    "Munger",
    "Chhapra",
    "Danapur",
    "Saharsa",
    "Hajipur",
    "Others"
  ],
  [import_types10.StateCityTypes.Odisha]: [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Berhampur",
    "Sambalpur",
    "Balasore",
    "Baripada",
    "Bhuban",
    "Puri",
    "Jeypore",
    "Bhadrak",
    "Kendujhar",
    "Balangir",
    "Rayagada",
    "Others"
  ],
  [import_types10.StateCityTypes.Telangana]: [
    "Hyderabad",
    "Warangal",
    "Nizamabad",
    "Khammam",
    "Karimnagar",
    "Ramagundam",
    "Mahbubnagar",
    "Nalgonda",
    "Adilabad",
    "Siddipet",
    "Miryalaguda",
    "Suryapet",
    "Others"
  ],
  [import_types10.StateCityTypes.AndhraPradesh]: [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
    "Kadapa",
    "Rajahmundry",
    "Tirupati",
    "Anantapur",
    "Kakinada",
    "Eluru",
    "Ongole",
    "Chittoor",
    "Vizianagaram",
    "Others"
  ],
  [import_types10.StateCityTypes.Kerala]: [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Thrissur",
    "Kannur",
    "Kollam",
    "Palakkad",
    "Alappuzha",
    "Malappuram",
    "Kottayam",
    "Kasaragod",
    "Pathanamthitta",
    "Idukki",
    "Others"
  ],
  [import_types10.StateCityTypes.Haryana]: [
    "Gurgaon",
    "Faridabad",
    "Panipat",
    "Ambala",
    "Yamunanagar",
    "Rohtak",
    "Hisar",
    "Karnal",
    "Sonipat",
    "Panchkula",
    "Kaithal",
    "Rewari",
    "Bhiwani",
    "Jhajjar",
    "Others"
  ],
  [import_types10.StateCityTypes.Jharkhand]: [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro",
    "Deoghar",
    "Hazaribagh",
    "Giridih",
    "Ramgarh",
    "Phusro",
    "Medininagar (Daltonganj)",
    "Chaibasa",
    "Hussainabad",
    "Others"
  ],
  [import_types10.StateCityTypes.Chhattisgarh]: [
    "Raipur",
    "Bilaspur",
    "Durg",
    "Bhilai",
    "Korba",
    "Raigarh",
    "Jagdalpur",
    "Rajnandgaon",
    "Ambikapur",
    "Mahasamund",
    "Dhamtari",
    "Others"
  ],
  [import_types10.StateCityTypes.Assam]: [
    "Guwahati",
    "Silchar",
    "Dibrugarh",
    "Jorhat",
    "Nagaon",
    "Tinsukia",
    "Tezpur",
    "Bongaigaon",
    "Diphu",
    "Karimganj",
    "Sivasagar",
    "Dhubri",
    "Barpeta",
    "Others"
  ],
  [import_types10.StateCityTypes.HimachalPradesh]: [
    "Shimla",
    "Dharamshala",
    "Manali",
    "Kullu",
    "Mandi",
    "Solan",
    "Hamirpur",
    "Bilaspur",
    "Chamba",
    "Dalhousie",
    "Nahan",
    "Kangra",
    "Una",
    "Others"
  ],
  [import_types10.StateCityTypes.JammuAndKashmir]: [
    "Srinagar",
    "Jammu",
    "Anantnag",
    "Baramulla",
    "Udhampur",
    "Sopore",
    "Kathua",
    "Poonch",
    "Rajouri",
    "Kupwara",
    "Pulwama",
    "Kulgam",
    "Others"
  ],
  [import_types10.StateCityTypes.Uttarakhand]: [
    "Dehradun",
    "Haridwar",
    "Roorkee",
    "Haldwani",
    "Rishikesh",
    "Nainital",
    "Kashipur",
    "Rudrapur",
    "Pithoragarh",
    "Tehri",
    "Almora",
    "Tanakpur",
    "Champawat",
    "Others"
  ],
  [import_types10.StateCityTypes.Tripura]: [
    "Agartala",
    "Dharmanagar",
    "Kailashahar",
    "Udaipur",
    "Kamalpur",
    "Khowai",
    "Ranirbazar",
    "Belonia",
    "Amarpur",
    "Sabroom",
    "Pratapgarh",
    "Others"
  ],
  [import_types10.StateCityTypes.Meghalaya]: [
    "Shillong",
    "Tura",
    "Nongstoin",
    "Mairang",
    "Nongpoh",
    "Cherrapunji",
    "Baghmara",
    "Jowai",
    "Resubelpara",
    "Williamnagar",
    "Mawkyrwat",
    "Byrnihat",
    "Others"
  ],
  [import_types10.StateCityTypes.Manipur]: [
    "Imphal",
    "Thoubal",
    "Bishnupur",
    "Kakching",
    "Churachandpur",
    "Ukhrul",
    "Senapati",
    "Tamenglong",
    "Moreh",
    "Moirang",
    "Jiribam",
    "Others"
  ],
  [import_types10.StateCityTypes.Nagaland]: [
    "Kohima",
    "Dimapur",
    "Mokokchung",
    "Tuensang",
    "Wokha",
    "Mon",
    "Zunheboto",
    "Phek",
    "Kiphire",
    "Longleng",
    "Peren",
    "Others"
  ],
  [import_types10.StateCityTypes.Mizoram]: [
    "Aizawl",
    "Lunglei",
    "Saiha",
    "Champhai",
    "Serchhip",
    "Kolasib",
    "Lawngtlai",
    "Mamit",
    "Bairabi",
    "Saitual",
    "Tlabung",
    "Others"
  ],
  [import_types10.StateCityTypes.ArunachalPradesh]: [
    "Itanagar",
    "Naharlagun",
    "Pasighat",
    "Tawang",
    "Ziro",
    "Pangin",
    "Roing",
    "Tezu",
    "Yingkiong",
    "Anini",
    "Aalo (Along)",
    "Others"
  ],
  [import_types10.StateCityTypes.Sikkim]: [
    "Gangtok",
    "Namchi",
    "Gyalshing",
    "Singtam",
    "Mangan",
    "Rangpo",
    "Jorethang",
    "Pakyong",
    "Soreng",
    "Yuksom",
    "Others"
  ],
  [import_types10.StateCityTypes.Goa]: [
    "Panaji",
    "Margao",
    "Vasco da Gama",
    "Mapusa",
    "Ponda",
    "Curchorem",
    "Bicholim",
    "Quepem",
    "Sanguem",
    "Canacona",
    "Sanquelim",
    "Others"
  ],
  [import_types10.StateCityTypes.Delhi]: [
    "New Delhi",
    "North Delhi",
    "North West Delhi",
    "West Delhi",
    "South West Delhi",
    "South Delhi",
    "South East Delhi",
    "Central Delhi",
    "North East Delhi",
    "Shahdara",
    "East Delhi",
    "Others"
  ],
  [import_types10.StateCityTypes.Chandigarh]: ["Chandigarh", "Others"],
  [import_types10.StateCityTypes.Puducherry]: ["Puducherry", "Oulgaret", "Karaikal", "Yanam", "Mahe", "Others"],
  [import_types10.StateCityTypes.Lakshadweep]: [
    "Kavaratti",
    "Agatti",
    "Amini",
    "Andrott",
    "Bitra",
    "Chetlat",
    "Kadmat",
    "Kalpeni",
    "Kilthan",
    "Minicoy",
    "Others"
  ],
  [import_types10.StateCityTypes.DadraAndNagarHaveliAndDamanAndDiu]: ["Daman", "Diu", "Silvassa", "Amli", "Others"],
  [import_types10.StateCityTypes.AndamanAndNicobarIslands]: ["Port Blair", "Rangat", "Diglipur", "Mayabunder", "Others"],
  [import_types10.StateCityTypes.Ladakh]: ["Leh", "Kargil", "Nubra", "Zanskar", "Dras", "Others"]
};

// src/dashboard.tsx
init_cjs_shims();
var TopCardChildComponentOptions = /* @__PURE__ */ ((TopCardChildComponentOptions2) => {
  TopCardChildComponentOptions2["TAKE_TEST_CARD"] = "TAKE_TEST_CARD";
  TopCardChildComponentOptions2["COMPLETE_TEST_CARD"] = "COMPLETE_TEST_CARD";
  TopCardChildComponentOptions2["WAITING_FOR_SCORE_CARD"] = "WAITING_FOR_SCORE_CARD";
  TopCardChildComponentOptions2["VIEW_SCORE_CARD"] = "VIEW_SCORE_CARD";
  return TopCardChildComponentOptions2;
})(TopCardChildComponentOptions || {});

// src/benchmarkForm.ts
init_cjs_shims();
var import_types11 = __toESM(require_dist());
var checkIfUserFilledForm = ({
  user,
  onlyMandatory = false,
  onlyOptional = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$;
  let total = 0;
  let maxTotal = 0;
  const missingFields = [];
  const checkField = (condition, isMandatory, fieldName) => {
    if (onlyMandatory && isMandatory || onlyOptional && !isMandatory || !onlyMandatory && !onlyOptional) {
      if (condition) {
        total += 1;
      } else {
        missingFields.push(fieldName);
      }
      maxTotal += 1;
    }
  };
  checkField(!!((_b = (_a = user == null ? void 0 : user.pifMeta) == null ? void 0 : _a.tenth) == null ? void 0 : _b.scoreType), true, "10th Score Type");
  checkField(!!((_d = (_c = user == null ? void 0 : user.pifMeta) == null ? void 0 : _c.twelfth) == null ? void 0 : _d.scoreType), true, "12th Score Type");
  checkField(
    !!((_f = (_e = user == null ? void 0 : user.pifMeta) == null ? void 0 : _e.underGraduate) == null ? void 0 : _f.scoreType) || !!((_h = (_g = user == null ? void 0 : user.pifMeta) == null ? void 0 : _g.postGraduate) == null ? void 0 : _h.scoreType),
    true,
    "Undergraduate/Postgraduate Score Type"
  );
  checkField(
    !!((_j = (_i = user == null ? void 0 : user.pifMeta) == null ? void 0 : _i.underGraduate) == null ? void 0 : _j.degree) || !!((_l = (_k = user == null ? void 0 : user.pifMeta) == null ? void 0 : _k.postGraduate) == null ? void 0 : _l.degree),
    true,
    "Undergraduate/Postgraduate Degree"
  );
  checkField(!!((_n = (_m = user == null ? void 0 : user.pifMeta) == null ? void 0 : _m.tenth) == null ? void 0 : _n.percentage), true, "10th Percentage");
  checkField(!!((_p = (_o = user == null ? void 0 : user.pifMeta) == null ? void 0 : _o.twelfth) == null ? void 0 : _p.percentage), true, "12th Percentage");
  checkField(
    !!((_r = (_q = user == null ? void 0 : user.pifMeta) == null ? void 0 : _q.underGraduate) == null ? void 0 : _r.percentage) || !!((_t = (_s = user == null ? void 0 : user.pifMeta) == null ? void 0 : _s.postGraduate) == null ? void 0 : _t.percentage),
    true,
    "Undergraduate/Postgraduate Percentage"
  );
  checkField(!!((_u = user == null ? void 0 : user.pifMeta) == null ? void 0 : _u.gender) || !!((_v = user == null ? void 0 : user.profile) == null ? void 0 : _v.gender), true, "Gender");
  checkField(!!((_x = (_w = user == null ? void 0 : user.profile) == null ? void 0 : _w.gradYear) == null ? void 0 : _x.toString()), true, "Graduation Year");
  checkField(!!((_y = user == null ? void 0 : user.pifMeta) == null ? void 0 : _y.resumeLink) || !!((_z = user == null ? void 0 : user.profile) == null ? void 0 : _z.resumeLink), true, "Resume Link");
  if (!onlyMandatory && !onlyOptional) {
    checkField(!!((_A = user == null ? void 0 : user.pifMeta) == null ? void 0 : _A.linkedinUrl) || !!((_B = user == null ? void 0 : user.profile) == null ? void 0 : _B.linkedInProfile), false, "LinkedIn Profile");
    checkField(!!((_C = user == null ? void 0 : user.pifMeta) == null ? void 0 : _C.githubProfileLink) || !!((_D = user == null ? void 0 : user.profile) == null ? void 0 : _D.githubURL), false, "GitHub Profile");
    checkField(!!((_E = user == null ? void 0 : user.pifMeta) == null ? void 0 : _E.leetcodeProfileLink), false, "LeetCode Profile");
    checkField(!!((_F = user == null ? void 0 : user.pifMeta) == null ? void 0 : _F.hackerRankProfileLink), false, "HackerRank Profile");
  }
  checkField(!!((_H = (_G = user == null ? void 0 : user.pifMeta) == null ? void 0 : _G.expectedCtc) == null ? void 0 : _H.toString()), false, "Expected CTC");
  checkField(
    (_O = (_K = (_J = (_I = user == null ? void 0 : user.pifMeta) == null ? void 0 : _I.underGraduate) == null ? void 0 : _J.college) == null ? void 0 : _K._id) != null ? _O : (_N = (_M = (_L = user == null ? void 0 : user.pifMeta) == null ? void 0 : _L.postGraduate) == null ? void 0 : _M.college) == null ? void 0 : _N._id,
    true,
    "College ID"
  );
  checkField(!!((_Q = (_P = user == null ? void 0 : user.profile) == null ? void 0 : _P.preferredJobLocations) == null ? void 0 : _Q.length), false, "Preferred Job Locations");
  checkField(
    !!((_S = (_R = user == null ? void 0 : user.pifMeta) == null ? void 0 : _R.underGraduate) == null ? void 0 : _S.isBacklog) || !!((_U = (_T = user == null ? void 0 : user.pifMeta) == null ? void 0 : _T.postGraduate) == null ? void 0 : _U.isBacklog),
    false,
    "Backlog Status"
  );
  checkField(!!((_V = user == null ? void 0 : user.profile) == null ? void 0 : _V.isImmediateJoiner) || !!((_W = user == null ? void 0 : user.profile) == null ? void 0 : _W.expectedJoining), false, "Immediate Joiner Status");
  const isFinalYearStudent = ((_X = user == null ? void 0 : user.userPreference) == null ? void 0 : _X.experienceLevel) === import_types11.UserExperienceLevelType.FINAL_YEAR_STUDENT;
  isFinalYearStudent && checkField(isFinalYearStudent && !!((_Y = user == null ? void 0 : user.pifMeta) == null ? void 0 : _Y.collegeIdCardLink), false, "College ID Card Link");
  !isFinalYearStudent && checkField(!isFinalYearStudent && !!((_Z = user == null ? void 0 : user.pifMeta) == null ? void 0 : _Z.panCardDoc), false, "PAN Card Document");
  !isFinalYearStudent && checkField(!isFinalYearStudent && !!((_$ = (__ = user == null ? void 0 : user.pifMeta) == null ? void 0 : __.location) == null ? void 0 : _$.pincode), true, "Pincode");
  if (missingFields.length > 0) {
    console.log("Missing fields:", missingFields);
  }
  return maxTotal > 0 ? Math.round(total / maxTotal * 100) : 0;
};

// src/index.ts
var getTodaysDate = () => {
  return new Date();
};
var cleanStringForRegex = (word) => {
  return word.toLowerCase().replace(/[\.\*\+\?\|\(\)\[\]\{\}\\]/g, "\\$&");
};
var isScoreRangeValid = (score) => {
  if (0 <= score && score <= 1e3) {
    return score;
  } else if (score > 1e3) {
    return 1e3;
  }
  return 0;
};
var camelCaseToSpace = (str) => str.replace(/([a-zA-Z])(?=[A-Z])/g, "$1 ");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ASSIGNMENT_SUBMISSION_FILE_COLUMN_KEYS,
  ASSIGNMENT_SUBMISSION_LEGACY_COLUMN_KEY,
  ASSIGNMENT_SUBMISSION_LINK_COLUMN_KEYS,
  DURATION_OPTIONS,
  MAX_GRAD_YEAR,
  MAX_LEVEL,
  MAX_PREDICTED_SALARY,
  MIN_GRAD_YEAR,
  MIN_LEVEL,
  MIN_PREDICTED_SALARY,
  POSITION_CLOSURE_INELIGIBLE_APPLICANTS_MESSAGE,
  POSITION_CLOSURE_MIA_OTHER_ACCESS_MESSAGE,
  POSITION_CLOSURE_REASON,
  PROCESS_NOT_STARTED,
  RESTRICTED_POSITION_CLOSURE_REASONS,
  SUPER_ADMIN_ONLY_POSITION_CLOSURE_REASONS,
  TopCardChildComponentOptions,
  accountManagerRoleOptions,
  activeApplicantStatuses,
  activeApplicantsTabApplicationWhereClause,
  adminRoleOptions,
  allDegrees,
  allSkillsDropdownForPosition,
  allSpecializations,
  allWeekDays,
  allowFirstPayment,
  allowPaymentForDriveApplication,
  allowSecondPayment,
  allowedMoveToNextRoundApplicationStatuses,
  allowedRecruiterRoundActionApplicationStatuses,
  allowedSendOfferLetterApplicationStatuses,
  allowedUpdateOfferLetterApplicationStatuses,
  alumniUserRoleOptions,
  applicantsTabApplicationWhereClause,
  backLogsOptions,
  behaviouralFlagsOptions,
  boards,
  buildAssignmentSubmissionFields,
  calculateMedian,
  camelCaseToSpace,
  canClosePositionWithMIAOrOther,
  canRegularRejectApplication,
  canScreenRejectApplication,
  canUndoScreenRejection,
  canUserSelectPositionClosureReason,
  capitalize,
  checkDisplayUserEmail,
  checkIfUserFilledForm,
  checkInPipelineApplication,
  checkIsConnectedApplicant,
  checkIsFutureDate,
  checkUserEligibilityForSecondRound,
  cleanStringForRegex,
  closedApplicationRoundStatuses,
  closedApplicationStatuses,
  companyNatureOptions,
  companyTypeOptions,
  completedMeetingStatuses,
  conditionsOptions,
  convertDays,
  convertDifficulty,
  convertEnumToTitleCaseProfileTab,
  convertTimeToMonthYearString,
  convertedDateFromDateType,
  createItemsById,
  csvToJson,
  designationMappingWithTechStack,
  difficultyNumberToTextMapping,
  displayApplicationStatus,
  displaySkillListForRecruiter,
  dontAllowDirectOptOutApplicationStatuses,
  expectedJoiningOptions,
  fileSubmissionColumnKey,
  findCombinations,
  findPaths,
  findRemainingAttempts,
  formatCareerPathType,
  formatNumberWithSuffix,
  formatTime,
  formatTimeDifference,
  genderOptions,
  generateCareerPathTypeOptions,
  generateDevelopmentRoleTypeOptions,
  generatePositionTitle,
  generateProductSkillsForDisplayNames,
  generateRangeValuesArray,
  generateTechStackName,
  generateTechStackTypeOptions,
  generateUniqueHandler,
  generateUserExperienceLevelTypeOptions,
  getAllDatesInRange,
  getAssignmentSubmissionsDownloadColumns,
  getBUPriority,
  getConnectedApplicantsDownloadColumns,
  getCtaTextAndActionForRecruiterForPipeLineUser,
  getDateValues,
  getDecayFactor,
  getDevelopmentRoleUIConfig,
  getDumnyUser,
  getExpiryDateInWorkingHours,
  getJobSeekerAssignmentExpiry,
  getLastStringOfId,
  getLatestInterview,
  getMonthName,
  getNextAssessmentTokenDetails,
  getPositionClosureReasonOptions,
  getRecommendedUsersDownloadColumns,
  getResumeLinkFromUser,
  getScreenRejectRoundNameFromApplicationStatus,
  getSubmissionColumnsForAssignmentType,
  getTimeScore,
  getTodaysDate,
  getUserPreferenceUIConfig,
  getValidJapAmount,
  gradYearOptions,
  groupAvailabilityByDurationAndDate,
  hasAnyApplicationRoundStarted,
  hideCtaToRecruiterCard,
  highestQualifications,
  inProgressApplicationStatuses,
  isApplicantsTabApplication,
  isApplicationExpiredForPositionClosure,
  isApplicationRejectionStatus,
  isCancelledMeeting,
  isCancelledOrRescheduledMeeting,
  isDecimal,
  isMIAOrOtherClosureReason,
  isMIAOtherClosureEligibleApplication,
  isMandatoryFormFilled,
  isNoActionAfterShortlistApplication,
  isPhoneOrEmail,
  isPlacedElsewhereWithVerballyPlacedStudentEligibleForClosure,
  isPositionClosed,
  isPositionClosureEligibleApplication,
  isPositionClosureEligibleApplicationStatus,
  isRescheduledMeeting,
  isRestrictedPositionClosureReason,
  isScheduledOrOngoingMeeting,
  isScheduledOrOngoingSession,
  isScoreRangeValid,
  isSellableOptions,
  isSuperAdminOnlyPositionClosureReason,
  isUserAccountManager,
  isUserAdmin,
  isUserAllowedToApply,
  isUserAlumniConnect,
  isUserCollegeUser,
  isUserDriveAdmin,
  isUserJobseeker,
  isUserLeadGen,
  isUserMentor,
  isUserPreferenceFilled,
  isUserRecruiter,
  isUserSuperAccountManager,
  isUserSuperAdmin,
  isUserSuperLeadGen,
  isUserUniversityManager,
  isVerballyPlacedApplicationBlockingClosure,
  leadGenRoleOptions,
  linkSubmissionColumnKey,
  locationPreferenceOptions,
  mapPositionTitlesToDropdownOptions,
  maxAttemptsOptions,
  meetingTypeOptions,
  mentorJobRoleOptions,
  mentorUserRoleOptions,
  mustHaveSkillsIrrespectiveOfPosition,
  natureOfBusinessOptions,
  neighbourStatesMapping,
  ordinalSuffixOf,
  outOfPlacementTags,
  ownershipOptions,
  partitionApplicationsByClosedPosition,
  positionClosureEligibleApplicationStatuses,
  positionStatusOptions,
  positionTitleOptions,
  positionTypeOptions,
  postgraduateDegrees,
  regionStateMapping,
  requiresApplicantStatusValidationForPositionClosure,
  resolveClosingPositionReason,
  resolveReopenedApplicationStatus,
  revertPositionTitle,
  revertPositionTitleV2,
  sanitizeContactInformationOfUser,
  sendMessageToJSApplicationStatuses,
  sendMessageToParent,
  sessionMeetingStatuses,
  showApplicationStatusToRecruiterCard,
  skillNameToIdMapping,
  skillTypeOptions,
  stateCityOptions,
  stringAvatar,
  techStackMappingWithSkills,
  timeGapConvertor,
  undergraduateDegrees,
  uniqueDegrees,
  uniqueSpecializations,
  validateEmailAddress,
  validateLinkedInProfileUrl,
  validateName,
  validatePhoneNumber,
  validateUrl,
  visibilityTypeOptions,
  wasApplicationShortlisted,
  workingModeOptions
});
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! moment.js
//! momentjs.com
//! version : 2.29.4
